(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb45a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb45a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aARjA", function(module, exports) {
window.jPar = {
    state: {
        wdkDialog: {
            openedDialogList: []
        }
    }
};
/* eslint-disable-next-line no-global-assign */ // TODO auf eslint hören und besser machen
deepMerge = function() {
    // I just copied and pasted from jQuery source and made just a small adaption to not prototpy the jQuery Object
    let options;
    let name;
    let src;
    let copy;
    let copyIsArray;
    let clone;
    let target = arguments[0] || {};
    let i = 1;
    const length = arguments.length;
    let deep = false;
    // Handle a deep copy situation
    if (typeof target === 'boolean') {
        deep = target;
        // Skip the boolean and the target
        target = arguments[i] || {};
        i++;
    }
    // Handle case when target is a string or something (possible in deep copy)
    // eslint-disable-next-line no-undef
    if (typeof target !== 'object' && !isFunction(target)) target = {};
    // Extend jQuery itself if only one argument is passed
    if (i === length) {
        target = this;
        i--;
    }
    for(; i < length; i++)// Only deal with non-null/undefined values
    if ((options = arguments[i]) !== null) {
        // Extend the base object
        // we don't want to check for if I guess, because we want to copy everything
        for(name in options)if (Object.prototype.hasOwnProperty.call(options, name)) {
            copy = options[name];
            // Prevent Object.prototype pollution
            // Prevent never-ending loop
            if (name === '__proto__' || target === copy) continue;
            // Recurse if we're merging plain objects or arrays
            if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                src = target[name];
                // Ensure proper type for the source value
                if (copyIsArray && !Array.isArray(src)) clone = [];
                else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                else clone = src;
                copyIsArray = false;
                // Never move original objects, clone them
                target[name] = deepMerge(deep, clone, copy);
            // Don't bring in undefined values
            } else if (copy !== undefined) target[name] = copy;
        }
    }
    // Return the modified object
    return target;
};

});

parcelRegister("9GUbU", function(module, exports) {
/** @namespace Helper-Namspace for general Functions that can be used everywhere */ $j.extend(true, jPar, {
    Tracking: {
        init: function() {
            // Initialisierung des Event-Trackings
            try {
                // erstmal nicht mehr this.connectionType();
                // erstmal nicht mehr this.ui.standaloneWebApp();
                this.setEventForUnhandledRejection();
            } catch  {
                console.error('jPar.Tracking.init failed!');
            }
        },
        setEventForUnhandledRejection: function() {
            window.addEventListener('unhandledrejection', (event)=>{
                // Wenn Promises nicht richtig aufgelöst werden
                if (typeof event !== 'undefined') {
                    event.preventDefault(); // Can prevent error output on the console:
                    const reasonDefined = typeof event.reason !== 'undefined';
                    const stackDefined = reasonDefined && typeof event.reason.stack !== 'undefined';
                    const messageDefined = reasonDefined && typeof event.reason.message !== 'undefined';
                    if (stackDefined && event.reason.stack !== '') jPar.util.log.error(event.reason.stack, 'unhandledrejection (event.reason.stack) Caught_2'); // Caught_2
                    else if (messageDefined) jPar.util.log.error(event.reason.message, 'unhandledrejection (event.reason.message) Caught_2'); // Caught_2
                }
            });
        },
        parmacontoTeaser: {
            init: function() {
                const _this = this;
                document.addEventListener('scroll', ()=>{
                    _this.onScrollOrResizeViewed();
                }, {
                    passive: true,
                    signal: jPar.util.getGlobalAbortSignal()
                });
                window.addEventListener('resize', ()=>{
                    _this.onScrollOrResizeViewed();
                }, {
                    passive: true,
                    signal: jPar.util.getGlobalAbortSignal()
                });
            },
            onScrollOrResizeViewed: function() {
                const _this = this;
                const $allUnviewedSlots = $j('.urcCard [data-urclayout]:not(.is-viewed)');
                if ($allUnviewedSlots.length > 0) $allUnviewedSlots.each(function() {
                    _this.slotViewed($j(this));
                });
            },
            slotLoaded: function($loadedSlot) {
                const _this = this;
                const isVisibleSlot = $loadedSlot.height() > 0;
                if (isVisibleSlot) _this.triggerPegLoggerEvent($loadedSlot, 'loaded');
            },
            slotViewed: function($loadedSlot) {
                const currentUrcSlotIsOnScreen = $loadedSlot.isOnScreen(function(deltas) {
                    return deltas.top >= $loadedSlot.height() * 0.75 && deltas.bottom >= $j(this).height(); // etwas mehr luft, da das Plugin die Höhe vom Window und nicht von dem scrollbaren Kasten nimmt
                });
                if (currentUrcSlotIsOnScreen) {
                    $loadedSlot.addClass('is-viewed');
                    this.triggerPegLoggerEvent($loadedSlot, 'viewed');
                }
            },
            slotClicked: function($loadedSlot) {
                const _this = this;
                $loadedSlot.on('click', function() {
                    _this.triggerPegLoggerEvent($j(this), 'click');
                });
            },
            addParamsToParmacontoLink: function($loadedSlot) {
                const currentLink = $loadedSlot.find('a').attr('href');
                if (currentLink !== undefined && currentLink !== null) {
                    const linkDivider = currentLink.lastIndexOf('?') === -1 ? '?' : '&';
                    const targetIdParam = 'target_id=' + $loadedSlot.data('urc-id');
                    const urcTitle = '&urcTitle=' + $loadedSlot.data('urc-title');
                    const slotName = '&slotName=' + $loadedSlot.parents('.urcCard').attr('id');
                    const displaySize = '&displaySize=' + jPar.wdk.screensize.getCurrentScreenSize();
                    const enhancedLink = currentLink + linkDivider + targetIdParam + urcTitle + slotName + displaySize;
                    $loadedSlot.attr('href', enhancedLink);
                }
            },
            triggerPegLoggerEvent: function($urcAjaxContent, action) {
                const slotName = $urcAjaxContent.data('urc-slot');
                const urcId = $urcAjaxContent.data('urc-id');
                const urcTitle = $urcAjaxContent.data('urc-title');
                // console.log(`xsendTrackEvent: ${slotName} urcId: ${urcId}`);
                jPar.util.log.bigData({
                    category: 'parmacontoTeaser',
                    subcategory: slotName,
                    targetId: urcId + ':' + urcTitle,
                    action: action
                });
            }
        },
        registration: {
            trackLayer: function(pageName) {
                // layerName
                // mal durch /bd ersetzen?
                jPar.util.log.devConsole('Deprecated Tracking.registration.trackLayer() ', pageName);
            }
        }
    }
});

});

parcelRegister("DAqcY", function(module, exports) {

var $ef2u9 = parcelRequire("ef2u9");
class $076fe539fec44ccc$var$FetchIt {
    constructor(){
        this.defaultBrowserTimeout = 15000; // Will be overwritten in backstage mockFetch.mockRequest if explicit timeout is given there
    }
    /**
	 * @param url {string}
	 * @param [options={}] {RequestInit & {timeout: number=}}
	 * @returns {Promise<Object|undefined|string>}
	 */ async get(url, options = {}) {
        const { timeout: timeout = this.defaultBrowserTimeout } = options;
        const abortController = new AbortController();
        const timeoutId = window.setTimeout(()=>{
            abortController.abort(new (0, $ef2u9.TechnicalFetchCommandError)('browserTimeout')); // Wir wollen unseren eigenen abort getrennt behandeln können
        }, timeout);
        try {
            // jPar.util.log.devConsole(`FETCH, GET: ${url}`);
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'x-requested-with': 'XMLHttpRequest'
                },
                signal: abortController.signal,
                ...options
            });
            window.clearTimeout(timeoutId);
            if (!response.ok) {
                // https://thewebdev.info/2021/03/20/how-to-reject-a-promise-with-the-javascript-async-await-syntax/
                if (response.status === 418) throw new (0, $ef2u9.TechnicalFetchCommandError)('offline');
                else throw new (0, $ef2u9.TechnicalFetchCommandError)(response.status);
            // TODO invalid csrf token handling
            }
            const text = await response.text(); // Parse it as text
            if (this.isJson(text)) return this.getJson(text); // Try to parse it as JSON
            else if (text.includes('loginPage')) throw new (0, $ef2u9.TechnicalFetchCommandError)('sessionExpired');
            else return text;
        } catch (error) {
            if (abortController.signal?.aborted) throw abortController.signal.reason ?? new (0, $ef2u9.TechnicalFetchCommandError)('browserTimeout');
            throw error instanceof (0, $ef2u9.FetchCommandError) ? error : new (0, $ef2u9.TechnicalFetchCommandError)(error);
        }
    }
    /**
	 * @param url {string}
	 * @param [data={}] {BodyInit}
	 * @param [options={}] {Omit<RequestInit, 'body'> & {timeout: number=}}
	 * @returns {Promise<object|string>}
	 * @throws {TechnicalFetchCommandError, FetchCommandError}
	 */ async post(url, data = {}, options = {}) {
        const { timeout: timeout = this.defaultBrowserTimeout } = options;
        const abortController = new AbortController();
        const timeoutId = window.setTimeout(()=>{
            abortController.abort(new (0, $ef2u9.TechnicalFetchCommandError)('browserTimeout')); // Wir wollen unseren eigenen abort getrennt behandeln können
        }, timeout);
        try {
            const { headers: headers, ...restOptions } = options;
            // jPar.util.log.devConsole(`FETCH, POST: ${url}`);
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'X-CSRF-TOKEN': jPar.wdk.security.csrf.getToken(),
                    'x-requested-with': 'XMLHttpRequest',
                    'Content-Type': data instanceof URLSearchParams ? 'application/x-www-form-urlencoded' : 'application/json',
                    ...headers
                },
                body: data,
                // credentials: 'include', // TODO brauch man das
                signal: abortController.signal,
                ...restOptions
            });
            window.clearTimeout(timeoutId);
            if (!response.ok) switch(response.status){
                case 418:
                    throw new (0, $ef2u9.TechnicalFetchCommandError)('offline');
                case 403:
                    throw new (0, $ef2u9.TechnicalFetchCommandError)('sessionExpired');
                default:
                    throw new (0, $ef2u9.TechnicalFetchCommandError)(response.status); // e.g. String "500"
            }
            const text = await response.text(); // Parse it as text
            if (this.isJson(text)) return this.getJson(text); // Try to parse it as JSON
            else if (text.includes('loginPage')) throw new (0, $ef2u9.TechnicalFetchCommandError)('sessionExpired');
            else return text;
        } catch (error) {
            if (abortController.signal?.aborted) throw abortController.signal.reason ?? new (0, $ef2u9.TechnicalFetchCommandError)('browserTimeout');
            throw error instanceof (0, $ef2u9.FetchCommandError) ? error : new (0, $ef2u9.TechnicalFetchCommandError)(error);
        }
    }
    /**
	 * @param url {string}
	 * @param [data={}] {BodyInit}
	 * @param [options={}] {Omit<RequestInit, 'body'> & {timeout: number=}}
	 * @returns {Promise<object|string>}
	 * @throws {TechnicalFetchCommandError, FetchCommandError}
	 */ async put(url, data = {}, options = {}) {
        const { timeout: timeout = this.defaultBrowserTimeout } = options;
        const abortController = new AbortController();
        const timeoutId = window.setTimeout(()=>{
            abortController.abort(new (0, $ef2u9.TechnicalFetchCommandError)('browserTimeout')); // Wir wollen unseren eigenen abort getrennt behandeln können
        }, timeout);
        try {
            const { headers: headers, ...restOptions } = options;
            // jPar.util.log.devConsole(`FETCH, POST: ${url}`);
            const response = await fetch(url, {
                method: 'PUT',
                headers: {
                    'X-CSRF-TOKEN': jPar.wdk.security.csrf.getToken(),
                    'x-requested-with': 'XMLHttpRequest',
                    'Content-Type': data instanceof URLSearchParams ? 'application/x-www-form-urlencoded' : 'application/json',
                    ...headers
                },
                body: data,
                // credentials: 'include', // TODO brauch man das
                signal: abortController.signal,
                ...restOptions
            });
            window.clearTimeout(timeoutId);
            if (!response.ok) switch(response.status){
                case 418:
                    throw new (0, $ef2u9.TechnicalFetchCommandError)('offline');
                case 403:
                    throw new (0, $ef2u9.TechnicalFetchCommandError)('sessionExpired');
                default:
                    throw new (0, $ef2u9.TechnicalFetchCommandError)(response.status); // e.g. String "500"
            }
            const text = await response.text(); // Parse it as text
            if (this.isJson(text)) return this.getJson(text); // Try to parse it as JSON
            else if (text.includes('loginPage')) throw new (0, $ef2u9.TechnicalFetchCommandError)('sessionExpired');
            else return text;
        } catch (error) {
            if (abortController.signal?.aborted) throw abortController.signal.reason ?? new (0, $ef2u9.TechnicalFetchCommandError)('browserTimeout');
            throw error instanceof (0, $ef2u9.FetchCommandError) ? error : new (0, $ef2u9.TechnicalFetchCommandError)(error);
        }
    }
    /**
	 * @param url {string}
	 * @param [data={}] {BodyInit}
	 * @param [options={}] {Omit<RequestInit, 'body'> & {timeout: number=}}
	 * @returns {Promise<object|string>}
	 * @throws {TechnicalFetchCommandError, FetchCommandError}
	 */ async delete(url, data = {}, options = {}) {
        const { timeout: timeout = this.defaultBrowserTimeout } = options;
        const abortController = new AbortController();
        const timeoutId = window.setTimeout(()=>{
            abortController.abort(new (0, $ef2u9.TechnicalFetchCommandError)('browserTimeout')); // Wir wollen unseren eigenen abort getrennt behandeln können
        }, timeout);
        try {
            const { headers: headers, ...restOptions } = options;
            // jPar.util.log.devConsole(`FETCH, POST: ${url}`);
            const response = await fetch(url, {
                method: 'DELETE',
                headers: {
                    'X-CSRF-TOKEN': jPar.wdk.security.csrf.getToken(),
                    'x-requested-with': 'XMLHttpRequest',
                    'Content-Type': data instanceof URLSearchParams ? 'application/x-www-form-urlencoded' : 'application/json',
                    ...headers
                },
                body: data,
                // credentials: 'include', // TODO brauch man das
                signal: abortController.signal,
                ...restOptions
            });
            window.clearTimeout(timeoutId);
            if (!response.ok) switch(response.status){
                case 418:
                    throw new (0, $ef2u9.TechnicalFetchCommandError)('offline');
                case 403:
                    throw new (0, $ef2u9.TechnicalFetchCommandError)('sessionExpired');
                default:
                    throw new (0, $ef2u9.TechnicalFetchCommandError)(response.status); // e.g. String "500"
            }
            const text = await response.text(); // Parse it as text
            if (this.isJson(text)) return this.getJson(text); // Try to parse it as JSON
            else if (text.includes('loginPage')) throw new (0, $ef2u9.TechnicalFetchCommandError)('sessionExpired');
            else return text;
        } catch (error) {
            if (abortController.signal?.aborted) throw abortController.signal.reason ?? new (0, $ef2u9.TechnicalFetchCommandError)('browserTimeout');
            throw error instanceof (0, $ef2u9.FetchCommandError) ? error : new (0, $ef2u9.TechnicalFetchCommandError)(error);
        }
    }
    /**
	 * @param item {any}
	 * @returns {any}
	 */ tryParseJson(item) {
        if (this.isJson(item)) return this.getJson(item);
        return item;
    }
    /**
	 * @param item {unknown}
	 * @returns {boolean}
	 */ isJson(item) {
        item = typeof item !== 'string' ? JSON.stringify(item) : item;
        try {
            item = JSON.parse(item);
        } catch  {
            return false;
        }
        return typeof item === 'object' && item !== null;
    }
    /**
	 * @param item {unknown}
	 * @returns {object | undefined}
	 */ getJson(item) {
        item = typeof item !== 'string' ? JSON.stringify(item) : item;
        item = JSON.parse(item);
        if (typeof item === 'object' && item !== null) return item;
    }
}
/* eslint-disable-next-line no-global-assign */ // TODO auf eslint hören und besser machen
fetchIt = new $076fe539fec44ccc$var$FetchIt();

});
parcelRegister("ef2u9", function(module, exports) {

$parcel$export(module.exports, "FetchCommandError", function () { return $a5e464e91f3a5395$export$48809384eaf65e93; });
$parcel$export(module.exports, "PermissionFetchCommandError", function () { return $a5e464e91f3a5395$export$54948c8d057bf0a1; });
$parcel$export(module.exports, "TechnicalFetchCommandError", function () { return $a5e464e91f3a5395$export$60363336870ec77a; });
class $a5e464e91f3a5395$export$48809384eaf65e93 extends Error {
    constructor(type, message, name = 'FetchCommandError'){
        super();
        this.name = name;
        this.type = type;
        this.message = typeof message === 'object' ? message : message?.toString().replace('Error: ', '');
    // keep String replacement, because nearly all ErrorHandling is checking for exact String (without "Error: " in front).
    // There might be one ErrorHandling that is broken now, but I can't remember. Some Handling has to deal with an Array, that failes if we try to make a String out of it
    }
}
class $a5e464e91f3a5395$export$54948c8d057bf0a1 extends $a5e464e91f3a5395$export$48809384eaf65e93 {
    constructor(message){
        super('permission', message, 'PermissionFetchCommandError');
    }
}
class $a5e464e91f3a5395$export$60363336870ec77a extends $a5e464e91f3a5395$export$48809384eaf65e93 {
    constructor(message){
        super('technicalError', message, 'TechnicalFetchCommandError');
    }
}

});


parcelRegister("c5qCG", function(module, exports) {
jPar.app = jPar.app || {};
jPar.app.appState = jPar.app.appState || {};
$j.extend(true, jPar.app.appState, {
    // Namespace removeNamespace()
    // Catergory setCategoryValue(), getCategoryValue(), removeCategory()
    // values addCategoryValue, removeCategoryValue
    // setMem / setDb
    set: function(storageName, namespaceKey, categoryKey, categoryVal) {
        if (browserDetails.features.hasStorageAccess()) {
            const storageType = this._getStorageType(storageName);
            const namespaceVal = storageType.getItem(namespaceKey);
            if (namespaceVal !== null && namespaceVal !== '') {
                const namespaceValAsJson = JSON.parse(namespaceVal);
                namespaceValAsJson[categoryKey] = categoryVal;
                storageType.setItem(namespaceKey, JSON.stringify(namespaceValAsJson));
            } else {
                const newCategory = {};
                newCategory[categoryKey] = categoryVal;
                storageType.setItem(namespaceKey, JSON.stringify(newCategory));
            }
        }
    },
    // returns objects not plain String
    get: function(storageName, namespaceKey, categoryKey) {
        if (browserDetails.features.hasStorageAccess()) {
            const storageType = this._getStorageType(storageName);
            const namespaceVal = storageType.getItem(namespaceKey);
            const hasInvalidValue = namespaceVal === null || namespaceVal === '' || namespaceVal === '{}';
            if (hasInvalidValue) return null;
            else {
                const namespaceValAsJson = JSON.parse(namespaceVal);
                const hasInvalidCategory = namespaceValAsJson[categoryKey] === undefined;
                if (hasInvalidCategory) return null;
                else return namespaceValAsJson[categoryKey];
            }
        }
    },
    // TODO refactor get function. Add getNameSpace function
    getNameSpace: function(storageName, namespaceKey) {
        if (browserDetails.features.hasStorageAccess()) {
            const storageType = this._getStorageType(storageName);
            const namespaceVal = storageType.getItem(namespaceKey);
            const hasInvalidValue = namespaceVal === null || namespaceVal === '' || namespaceVal === '{}';
            if (hasInvalidValue) return null;
            else return JSON.parse(namespaceVal);
        }
    },
    addEntry: function(storageName, namespaceKey, categoryKey, categoryVal) {
        if (browserDetails.features.hasStorageAccess()) {
            const storageType = this._getStorageType(storageName);
            const namespaceVal = storageType.getItem(namespaceKey);
            if (namespaceVal !== null && namespaceVal !== '') {
                const namespaceValAsJson = JSON.parse(namespaceVal);
                const storedCategoryValue = namespaceValAsJson[categoryKey] !== undefined ? namespaceValAsJson[categoryKey] : '';
                const isInvalidNewVal = categoryVal.indexOf(',') > -1;
                if (isInvalidNewVal) {
                    console.error('Adding Values with "," is not allowed');
                    return;
                }
                const isValueNotInCategory = storedCategoryValue.includes(categoryVal) === false;
                if (isValueNotInCategory) {
                    let newCategoryValue;
                    if (storedCategoryValue.length === 0) newCategoryValue = [
                        categoryVal
                    ];
                    else {
                        storedCategoryValue.push(categoryVal);
                        newCategoryValue = storedCategoryValue;
                    }
                    namespaceValAsJson[categoryKey] = newCategoryValue;
                    storageType.setItem(namespaceKey, JSON.stringify(namespaceValAsJson));
                }
            } else {
                const newCategory = {};
                newCategory[categoryKey] = [
                    categoryVal
                ];
                storageType.setItem(namespaceKey, JSON.stringify(newCategory));
            }
        }
    },
    // Anzahl der Parameter entscheidet, auf welcher Ebene gelöscht wird
    remove: function(storageName, namespaceKey, categoryKey, categoryVal) {
        if (categoryVal !== undefined) this._removeEntry(storageName, namespaceKey, categoryKey, categoryVal);
        else if (categoryKey !== undefined && categoryVal === undefined) this._removeCategory(storageName, namespaceKey, categoryKey);
        else if (namespaceKey !== undefined) this._removeNamespace(storageName, namespaceKey, categoryKey);
    },
    _removeCategory: function(storageName, namespaceKey, categoryKey) {
        if (browserDetails.features.hasStorageAccess()) {
            const storageType = this._getStorageType(storageName);
            const namespaceVal = storageType.getItem(namespaceKey);
            if (namespaceVal !== null && namespaceVal !== '') {
                const namespaceValAsJson = JSON.parse(namespaceVal);
                delete namespaceValAsJson[categoryKey];
                storageType.setItem(namespaceKey, JSON.stringify(namespaceValAsJson));
            }
        }
    },
    _removeEntry: function(storageName, namespaceKey, categoryKey, categoryVal) {
        if (browserDetails.features.hasStorageAccess()) {
            const storageType = this._getStorageType(storageName);
            const namespaceVal = storageType.getItem(namespaceKey);
            if (namespaceVal !== null && namespaceVal !== '') {
                const namespaceValAsJson = JSON.parse(namespaceVal);
                const storedCategoryValue = namespaceValAsJson[categoryKey];
                let storedCategoryValueAsArray = storedCategoryValue;
                if (typeof storedCategoryValue === 'string') storedCategoryValueAsArray = storedCategoryValue.split(',');
                if (storedCategoryValueAsArray.indexOf(categoryVal) > -1) {
                    storedCategoryValueAsArray.splice(storedCategoryValueAsArray.indexOf(categoryVal), 1);
                    namespaceValAsJson[categoryKey] = storedCategoryValueAsArray;
                    storageType.setItem(namespaceKey, JSON.stringify(namespaceValAsJson));
                }
            }
        }
    },
    _removeNamespace: function(storageName, namespaceKey) {
        if (browserDetails.features.hasStorageAccess()) {
            const storageType = this._getStorageType(storageName);
            storageType.removeItem(namespaceKey);
        }
    },
    // localStorage: Bleibt, bis man ihn löscht. Ist gleich über alle Tabs
    // sessionStorage: Immer nur für eine Session UND nur für einen Tab. Der Wert wird nicht synchron gehalten
    _getStorageType: function(storageName) {
        if (storageName === 'sessionStorage') return sessionStorage;
        else if (storageName === 'localStorage') return localStorage;
        else {
            console.error('Storage Type not Supported', storageName);
            return null;
        }
    }
});

});

parcelRegister("iVy6J", function(module, exports) {
jPar.util = jPar.util || {};
deepMerge(true, jPar.util, {
    isTouch: function() {
        return window.matchMedia('(pointer: coarse)').matches; // hover: none funktioniert in Samsung Internet nicht. Empfohlener  Workaround ist pointer
    },
    isMouse: function() {
        return window.matchMedia('(pointer: fine)').matches;
    },
    prefersReducedMotion: function() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    },
    setCookie: function(name, value) {
        const exp = new Date();
        exp.setTime(exp.getTime() + 8553600000); // 99 Days
        const cookieString = `${name}=${value}; path=/; domain=${this.getTopLevelDomain()}; expires=${exp.toGMTString()};`;
        document.cookie = cookieString;
    },
    getCookie: function(name) {
        const ca = document.cookie.split(' ');
        if (typeof ca !== 'undefined') for(let i = 0; i < ca.length; i++){
            const kv = ca[i].split('=');
            if (kv[0] === name) return kv.slice(1).join('=');
        }
        return null;
    },
    loadScript: function loadScript(script, callback) {
        const path = $j('#domPageVars').data('jsPath');
        const scriptTag = document.createElement('script');
        const isDevSystem = document.location.href.indexOf('.dev') > -1;
        let cacheBreakerForDevSystem = '';
        if (isDevSystem && $j('#domPageVars').data('useCacheBreaker') === true) cacheBreakerForDevSystem = '?ts' + Date.now();
        if (script.indexOf('https:') > -1) scriptTag.setAttribute('src', script);
        else scriptTag.setAttribute('src', path + script + '.js' + cacheBreakerForDevSystem);
        document.getElementsByTagName('head')[0].appendChild(scriptTag);
        if (!scriptTag.onloadDone && callback !== undefined) {
            scriptTag.onloadDone = true;
            scriptTag.onload = function() {
                callback();
            };
        }
    },
    vibrate: function() {
        if (typeof window.navigator.vibrate !== 'undefined') window.navigator.vibrate(30);
    },
    getTopLevelDomain: function() {
        const h = location.hostname;
        const n = h.match(/(.co.uk|.com.mx|.com.au)$/) ? -3 : -2;
        return h.split('.').slice(n).join('.');
    },
    getGetParamFromUrl: function getGetParamFromUrl(sParam) {
        const sPageURL = decodeURIComponent(window.location.search.substring(1));
        const sURLVariables = sPageURL.split('&');
        let sParameterName;
        let i;
        for(i = 0; i < sURLVariables.length; i++){
            sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] === sParam) return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    },
    putCursorAtEnd: function putCursorAtEnd($input) {
        // Nur für no-touchevents weil iOS8 ein Problem mit dem reinklicken hat, wenn vorher ein Javascript focus() aufgerufen wurde.
        // http://stackoverflow.com/questions/26146252/in-ios8-using-focus-will-show-virtual-keyboard-and-scroll-page-after-touch
        if ($j('html.no-touchevents').length > 0) {
            const value = $input.val();
            $input.trigger('focus');
            $input.val('');
            $input.val(value);
        }
    },
    setFocusOnFirstFocusableElement: function($domScope) {
        const focusableElementsString = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable], summary';
        $domScope.filter(focusableElementsString).filter(':visible:not([aria-hidden=true])').first().trigger('focus');
    },
    /**
	 * serializes a form element to an object
	 * @param form {HTMLFormElement}
	 * @returns {{[key: string]: string | Array | object}}
	 */ serializeForm: function(form) {
        const obj = {};
        const formData = new FormData(form);
        for (const key of formData.keys()){
            const formDataValue = formData.getAll(key);
            obj[key] = fetchIt.tryParseJson(formDataValue.length === 1 ? formDataValue[0] : formDataValue);
        }
        return obj;
    },
    // Best usage: await jPar.util.awaitTimeout(1000);
    awaitTimeout: function(delay) {
        return new Promise((resolve)=>setTimeout(resolve, delay));
    },
    waitForChildNodes: async function() {
        // wait a tick until all Child Nodes in a CustomElement are rendered // https://stackoverflow.com/questions/70949141/web-components-accessing-innerhtml-in-connectedcallback/70952159#70952159
        return new Promise(requestAnimationFrame);
    },
    getGlobalAbortSignal: function() {
        if (document.querySelector('peg-app-shell') !== null) {
            // All AppShell Pages
            const abortControllerSignal = document.querySelector('peg-app-shell')?.getAppShellAbortController().signal;
            if (abortControllerSignal !== undefined) return abortControllerSignal;
            else {
                jPar.util.log.error('getGlobalAbortSignal failed', 'AbortSignal was requested before AbortController was created');
                return null;
            }
        } else // non AppShell Pages
        return new AbortController().signal;
    }
});

});

parcelRegister("5fGOo", function(module, exports) {
jPar.util = jPar.util || {};

deepMerge(true, jPar.util, {
    pwa: {
        newServiceworkerAvailable: false,
        isOfflineSwEnabled: false,
        swListenerInit: false,
        init: function() {
            const killDefaultCache = document.querySelector('#serviceWorkerKillSwitch') !== null;
            this.isOfflineSwEnabled = document.querySelector('#offlineError') !== null;
            this.createServiceWorker();
            if (this.isOfflineSwEnabled) {
                document.addEventListener('peg:newUserLogin', ()=>{
                    this.killDefaultCache();
                }, {
                    signal: jPar.util.getGlobalAbortSignal()
                });
                this.startPrepareDefaultCache();
                this.lieFi.init();
                this.checkStandalone();
            } else if (killDefaultCache) this.killDefaultCache();
        },
        createServiceWorker: function() {
            if (navigator.serviceWorker !== undefined) {
                // && serviceworkerIsAllowed //Firefox private Mode kann keine Serviceworker. https://bugzilla.mozilla.org/show_bug.cgi?id=1320796
                // ein neuer Serviceworker ist vorhanden = release hat stattgefunden
                if (this.swListenerInit === false) {
                    // navigator.serviceWorker.removeEventListener('message', this.handleSwEvents);
                    navigator.serviceWorker.addEventListener('message', this.handleSwEvents);
                    this.swListenerInit = true;
                }
                navigator.serviceWorker.register((parcelRequire("glHlf"))).then(()=>{
                // console.log('sw installed');
                }, ()=>{
                // console.log('Firefox: "Webseite-Daten bei Beenden von Firefox löschen" angehakt hat zwar SW, wird aber rejected'.);
                }).catch((err)=>{
                    jPar.util.log.error('PWA Serviceworker:', err);
                });
            }
        },
        handleSwEvents: function(event) {
            if (event.data?.command === 'logJsError') jPar.util.log.error('PWA', event.data.stacktrace);
            if (event.data?.command === 'pageAnsweredFromCache') {
                // console.log('....pageAnsweredFromCache');
                document.querySelector('html').setAttribute('data-origin', 'cacheStorageAjax');
                jPar.util.pwa.lieFi.setCachedPageCount();
            }
            if (event.data?.command === 'pageAnsweredFromNetwork') // console.log('....pageAnsweredFromNetwork');
            document.dispatchEvent(new CustomEvent('serviceworker:pageFromNetwork'));
        /* if (event.data?.command === 'newServcieWorkerActivated') {
				console.log('neue SW ist da einmal reload');
				document.location.reload();
			}*/ },
        hasNewServiceWorker: function() {
            if (navigator.serviceWorker !== undefined && this.isOfflineSwEnabled) navigator.serviceWorker.getRegistrations().then((registrations)=>{
                if (registrations.length > 0 && registrations[0].active !== null) registrations[0].update();
            });
        },
        killServiceWorker: function() {
            if (navigator.serviceWorker !== undefined) navigator.serviceWorker.getRegistrations().then((registrations)=>{
                if (registrations.length > 0) {
                    navigator.serviceWorker.addEventListener('message', (event)=>{
                        if (event.data === 'killSwitchSwDeleted') document.location.reload(); // Seite vom aktuellen SW befreien
                    });
                    navigator.serviceWorker.controller.postMessage('killSwitch');
                }
            }, ()=>{
            // console.log('Wegen Firefox');
            });
        },
        killDefaultCache: function() {
            try {
                caches.keys().then(function(cacheNames) {
                    // Alle vorhandenen Caches
                    cacheNames.forEach(function(cacheName) {
                        const isDefaultCache = cacheName.indexOf('defaultCache-') > -1;
                        if (isDefaultCache) {
                            console.log('killDefaultCache');
                            caches.delete(cacheName).then(function() {
                            // console.log(cacheName);
                            });
                        }
                    });
                }).catch((error)=>{
                    jPar.util.log.error(error, 'killDefaultCaches: failed');
                });
            } catch  {
            /* Firefox private Mode fails */ }
        },
        killCaches: function() {
            caches.keys().then(function(cacheNames) {
                // Alle vorhandenen Caches
                cacheNames.forEach(function(cacheName) {
                    caches.delete(cacheName).then(function() {
                    // console.log(cacheName);
                    });
                });
            }).catch((error)=>{
                jPar.util.log.error(error, 'killCaches: failed');
            });
        },
        startPrepareDefaultCache: function() {
            const isLoggedIn = document.querySelector('#domPageVars').dataset.userId !== undefined;
            const isNotCacheablePage = document.querySelector('peg-registration-featured-profile, #partnerCompatibilityPage, #partnerCompatibilityPage2025') === null;
            const hasRunningSw = navigator.serviceWorker !== undefined && navigator.serviceWorker.controller !== null;
            if (isLoggedIn && hasRunningSw && isNotCacheablePage) navigator.serviceWorker.controller.postMessage('prepareDefaultCache');
        },
        lieFi: {
            init: function() {
                this.handleCachedPageTracking();
                this.checkDomForCachedHtml();
            },
            checkDomForCachedHtml: function() {
                if (document.querySelector('html[data-origin=cacheStorage]') !== null) // From PageNavigation outside of AppShell
                this.setCachedPageCount();
            },
            handleCachedPageTracking: function() {
                const isLoggedIn = document.querySelector('#domPageVars').dataset.userId !== undefined && jPar.app !== undefined;
                if (isLoggedIn) {
                    const dayOfSwData = jPar.app.appState.get('localStorage', 'pwa', 'dayOfSwData');
                    const slowPageCurrentCount = jPar.app.appState.get('localStorage', 'pwa', 'slowPageFromCacheCount');
                    const offlinePageCurrentCount = jPar.app.appState.get('localStorage', 'pwa', 'offlinePageFromCacheCount');
                    if (dayOfSwData !== null && navigator.onLine === true) {
                        if (parseInt(dayOfSwData) !== new Date().getDate()) {
                            if (slowPageCurrentCount !== null) {
                                jPar.util.log.ux(slowPageCurrentCount, 'pwa:slowPageFromCacheCount delivered last Session for this User');
                                jPar.app.appState.remove('localStorage', 'pwa', 'slowPageFromCacheCount');
                            }
                            if (offlinePageCurrentCount !== null) {
                                jPar.util.log.ux(offlinePageCurrentCount, 'pwa:offlinePageFromCacheCount delivered last Session for this User');
                                jPar.app.appState.remove('localStorage', 'pwa', 'offlinePageFromCacheCount');
                            }
                            jPar.app.appState.remove('localStorage', 'pwa', 'dayOfSwData');
                        }
                    }
                }
            },
            setCachedPageCount: function() {
                if (typeof jPar.app !== 'undefined') {
                    // jPar.app.sharedFeatures gibt es im Moment nicht imn ausgeloggten Bereich
                    const isLoggedIn = document.querySelector('#domPageVars').dataset.userId !== undefined;
                    if (isLoggedIn) {
                        const isCachedAppshellPage = document.querySelector('peg-app-shell') !== null && document.querySelector('html[data-origin="cacheStorageAjax"]') !== null;
                        const isCachedNormalPage = document.querySelector('peg-app-shell') !== null && document.querySelector('html[data-origin="cacheStorage"]') !== null;
                        if (isCachedAppshellPage || isCachedNormalPage) {
                            // prevent double tracking
                            const dayOfSwData = jPar.app.appState.get('localStorage', 'pwa', 'dayOfSwData');
                            if (dayOfSwData === null) jPar.app.appState.set('localStorage', 'pwa', 'dayOfSwData', new Date().getDate());
                            if (navigator.onLine === false) {
                                let currentOfflineCount = jPar.app.appState.get('localStorage', 'pwa', 'offlinePageFromCacheCount');
                                if (currentOfflineCount === null) currentOfflineCount = 0;
                                const newOfflineCount = parseInt(currentOfflineCount) + 1;
                                jPar.app.appState.set('localStorage', 'pwa', 'offlinePageFromCacheCount', newOfflineCount);
                            } else {
                                let currentSlowCount = jPar.app.appState.get('localStorage', 'pwa', 'slowPageFromCacheCount');
                                if (currentSlowCount === null) currentSlowCount = 0;
                                const newSlowCount = parseInt(currentSlowCount) + 1;
                                jPar.app.appState.set('localStorage', 'pwa', 'slowPageFromCacheCount', newSlowCount);
                            }
                        }
                    }
                }
            }
        },
        checkStandalone: function() {
            const isInWebAppChrome = window.matchMedia('(display-mode: standalone)').matches;
            const isInWebAppiOS = window.navigator.standalone === true;
            if (isInWebAppChrome || isInWebAppiOS) document.documentElement.classList.add('is-inPWA');
        }
    }
}); /* pushNotification: {
	pushButton: null,
	swRegistration: null,
	isSubscribed: false,
	applicationServerPublicKey: 'BODJ54m6oemIHQUtDed1oOFAkYGr_y3XHLXQ6D3oT6b9zoNkyWaP_r_Usj6KU8OPWYG485pUoVROhp_RDxDA4bU',

	init: function init() {
		var _this = this;

		if ('serviceWorker' in navigator && 'PushManager' in window) {
			//eslint-env browser, es6

			this.pushButton = document.querySelector('.js-push-btn');
			jPar.util.log.devConsole('Service Worker and Push is supported');

			navigator.serviceWorker.register('/service-worker')
				.then(function(swReg) {
					jPar.util.log.devConsole('Service Worker is registered', swReg);

					_this.swRegistration = swReg;
					_this.initialiseUI();
				})
				.catch(function(error) {
					console.error('Service Worker Error', error);
				});
		} else {
			console.warn('Push messaging is not supported');
			_this.pushButton.textContent = 'Push Not Supported';
		}
	},

	initialiseUI: function initialiseUI() {
		var _this = this;
		_this.pushButton.addEventListener('click', function() {
			_this.pushButton.disabled = true;
			if (_this.isSubscribed) {
				_this.unsubscribeUser();
			} else {
				_this.subscribeUser();
			}
		});

		// Set the initial subscription value
		this.swRegistration.pushManager.getSubscription()
			.then(function(subscription) {
				_this.isSubscribed = subscription !== null;

				if (_this.isSubscribed) {
					jPar.util.log.devConsole('User IS subscribed.');
				} else {
					jPar.util.log.devConsole('User is NOT subscribed.');
				}

				_this.updateBtn();
			});
	},

	subscribeUser: function subscribeUser() {
		var _this = this;
		var applicationServerKey = this.urlB64ToUint8Array(this.applicationServerPublicKey);
		this.swRegistration.pushManager.subscribe({
			userVisibleOnly: true,
			applicationServerKey: applicationServerKey
		})
			.then(function(subscription) {
				jPar.util.log.devConsole('User is subscribed:', subscription);

				_this.updateSubscriptionOnServer(subscription);

				_this.isSubscribed = true;

				_this.updateBtn();
			})
			.catch(function(err) {
				jPar.util.log.devConsole('Failed to subscribe the user: ', err);
				_this.updateBtn();
			});
	},

	unsubscribeUser: function unsubscribeUser() {
		var _this = this;
		this.swRegistration.pushManager.getSubscription()
			.then(function(subscription) {
				if (subscription) {
					return subscription.unsubscribe();
				}
			})
			.catch(function(error) {
				jPar.util.log.devConsole('Error unsubscribing', error);
			})
			.then(function() {
				_this.updateSubscriptionOnServer(null);

				jPar.util.log.devConsole('User is unsubscribed.');
				_this.isSubscribed = false;

				_this.updateBtn();
			});
	},

	updateSubscriptionOnServer: function updateSubscriptionOnServer(subscription) {
		//Hier muss dann: Send subscription to application server

		var subscriptionJson = document.querySelector('.js-subscription-json');
		var subscriptionDetails =document.querySelector('.js-subscription-details');

		if (subscription) {
			subscriptionJson.textContent = JSON.stringify(subscription);
			subscriptionDetails.classList.remove('noDisplay');
		} else {
			subscriptionDetails.classList.add('noDisplay');
		}
	},

	updateBtn: function updateBtn() {
		if (Notification.permission === 'denied') {
			this.pushButton.textContent = 'Push Messaging Blocked.';
			this.pushButton.disabled = true;
			this.updateSubscriptionOnServer(null);
			return;
		}

		if (this.isSubscribed) {
			this.pushButton.textContent = 'Disable Push Messaging';
		} else {
			this.pushButton.textContent = 'Enable Push Messaging';
		}

		this.pushButton.disabled = false;
	},

	urlB64ToUint8Array: function urlB64ToUint8Array(base64String) {
		var padding = '='.repeat((4 - base64String.length % 4) % 4);
		var base64 = (base64String + padding)
			.replace(/\-/g, '+')
			.replace(/_/g, '/');

		var rawData = window.atob(base64);
		var outputArray = new Uint8Array(rawData.length);

		for (var i = 0; i < rawData.length; ++i) {
			outputArray[i] = rawData.charCodeAt(i);
		}
		return outputArray;
	}
},
*/ 

});
parcelRegister("glHlf", function(module, exports) {
module.exports = "/service-worker";

});


parcelRegister("7BphF", function(module, exports) {
jPar.util = jPar.util || {};
deepMerge(true, jPar.util, {
    log: {
        error: function error(detailedInformation, highlevelInformation) {
            try {
                // Falls tracking mal schief geht soll alles andere weiterlaufen können
                const detailedInformationText = typeof detailedInformation === 'object' ? JSON.stringify(detailedInformation) : detailedInformation.toString();
                console.trace('%c----CAUGHT ERROR: ' + detailedInformationText + ' -> ' + highlevelInformation.toString() + ' ----', 'color: red; font-size: 14px;'); // NOSONAR
                const customEvent = new CustomEvent('pegLogger-logJsError', {
                    detail: {
                        message: detailedInformation,
                        stacktrace: highlevelInformation.toString(),
                        origin: 'Caught_JSError'
                    }
                });
                document.dispatchEvent(customEvent);
            } catch  {
                console.error('call of jPar.util.log.error() failed');
            }
        },
        ux: function(detailedInformation, highlevelInformation) {
            console.log('%c----UX: ' + detailedInformation + ' -> ' + highlevelInformation.toString() + ' ----', 'color: blue; font-size: 14px;'); // NOSONAR
            const customEvent = new CustomEvent('pegLogger-logJsError', {
                detail: {
                    message: detailedInformation,
                    stacktrace: highlevelInformation.toString(),
                    origin: 'UXLogging'
                }
            });
            document.dispatchEvent(customEvent);
        },
        /**
		 * @typedef {{category: string, subcategory: string, action: string, targetId: string, cd1: string, cd2: string, cd3: string, cd4: string, cd5: string,cd6: string}} logData
		 */ /**
		 * @param {Partial<logData>} logData
		 */ bigData: function(logData) {
            //TODO if supported in Safari 17. We have a shim here
            window.requestIdleCallback(()=>{
                const customEvent = new CustomEvent('pegLogger-logWebAppEvents', {
                    detail: logData
                });
                document.dispatchEvent(customEvent);
            }, {
                timeout: 100
            });
        },
        // Der einzig legitime Weg um dauerhaft Sachen in die Konsole zu schreiben.
        // console.log sollte ansonsten nur zu debug-zwecken benuzt werden.
        // Am Ende der Feature Entwicklung console.log Ausgaben immer aus den JS Dateien löschen.
        devConsole: function devConsole(output) {
            if ($j('#domPageVars').length > 0) {
                const isDevSystem = $j('#domPageVars').data('isDevSystem') !== undefined || document.location.href.indexOf('.dev') > -1;
                if (isDevSystem) {
                    console.log(output); // NOSONAR
                    document.querySelector('bst-opener')?.appLogging(output);
                }
            }
        }
    }
});

});

parcelRegister("bpIsd", function(module, exports) {
jPar.util = jPar.util || {};
deepMerge(true, jPar.util, {
    network: {
        hasValidSessionAndCsrfToken: function(loadedContent) {
            // isValidNetworkResponse
            // AJAX POST Requests mit CSRF-Token verhalten sich anders als GET Requests
            // Da greift dann erst die CSRF Prüfung und dann erst die 302 Session Prüfung
            /* eslint-disable-next-line no-prototype-builtins */ // TODO auf eslint hören und besser machen
            if (typeof loadedContent !== 'undefined' && loadedContent.hasOwnProperty('status')) return loadedContent.status !== 403;
            else // BUG-5612 Ajax-Anfragen, die HTML zurückliefern darauf testen, ob die Login.-Seite kommt und ggf. weiterleiten.
            // BUG-13958 Ajax-Requests sometimes return welcomepage HTML
            return typeof loadedContent !== 'string' || loadedContent.indexOf('<html') === -1 && loadedContent.indexOf('<body') === -1 && loadedContent.indexOf('loginForm') === -1; // loginForm für die Tests
        },
        reloadIfResponseInvalid: function(loadedContent, forceReload = false) {
            if (forceReload || this.hasValidSessionAndCsrfToken(loadedContent) === false) {
                if (document.querySelector('#errorModalboxSessionExpired.is-open') === null) {
                    // nur einmal ausführen
                    jPar.wdk.modalbox.show({
                        modalboxId: '#errorModalboxSessionExpired'
                    });
                    window.setTimeout(function() {
                        const locationWithoutHash = document.URL.split('#')[0]; // Wenn ein Hash in der URL steht springt er nur zur sprungmarke anstatt zu navigieren
                        location.replace(locationWithoutHash); // Damit beim nächsten login nicht der Ajax-Controller geladen wird.
                    }, 500);
                }
            } else return true;
        },
        reloadForSessionExpired: function() {
            this.reloadIfResponseInvalid(null, true);
        },
        defaultErrorHandling: function(error) {
            if (error.type === 'technicalError') {
                if (error.message === 'browserTimeout') document.querySelector('wdk-snackbar#timeoutNotification').show();
                else if (error.message === 'sessionExpired') jPar.util.network.reloadForSessionExpired();
                else if (error.message === 'offline') document.dispatchEvent(new CustomEvent('serviceworker:triggerOfflineAttention', {
                    bubbles: true
                }));
                else if (document.querySelector('#errorDialog500') !== null) document.querySelector('#errorDialog500').openModal();
                else jPar.wdk.modalbox.show({
                    modalboxId: 'errorModalbox500'
                }); //Deprecated
            } else throw error;
        },
        setGlobalAjaxTimeout: function() {
            const timeout = '15000'; // lets try with 15sek
            $j.ajaxSetup({
                timeout: timeout
            });
        }
    }
});

});

parcelRegister("8UdKr", function(module, exports) {
jPar.util = jPar.util || {};
deepMerge(true, jPar.util, {
    validate: {
        checkboxIsChecked: function checkboxIsChecked(elem) {
            if (elem !== null) {
                if (elem instanceof jQuery) return elem.prop('checked') === true ? true : false;
                else {
                    if (elem.length > 1) // Kann auch eine nodeList übegeben werden
                    elem.forEach((checkbox)=>{
                        return checkbox.checked ? true : false;
                    });
                    else return elem.checked ? true : false;
                }
            }
        },
        /**
		 * @param element {Element}
		 * @param testValue {string}
		 * @returns {boolean}
		 */ selectBoxHasValue: function(element, testValue) {
            if (element instanceof jQuery) return $j.trim(element.val()) === testValue;
            else if (element instanceof HTMLElement) return element.value.trim() === testValue;
        },
        /**
		 * @param element {Element}
		 * @returns {boolean}
		 */ toggleIsChecked: function(element) {
            if (element instanceof jQuery) return element.filter(':checked').length > 0;
            else if (element instanceof HTMLElement) return element.checked === true;
        },
        /**
		 * @param elem {HTMLTextAreaElement | NodeList}
		 * @returns {boolean}
		 */ textfieldIsEmpty: function textfieldIsEmpty(elem) {
            let inputValue = '';
            if (elem !== null) {
                if (elem instanceof jQuery) return $j.trim(elem.val()) === '';
                else if (elem.length > 1) // Kann auch eine nodeList übegeben werden
                elem.forEach((inputField)=>{
                    inputValue = inputField.value.trim();
                    return inputValue === '';
                });
                else {
                    inputValue = elem.value.trim();
                    return inputValue === '';
                }
            }
        },
        hasMinimumWordsFilled: function(input, minWords) {
            const re = new RegExp('([^ ]+ +){' + (minWords - 1) + ',}[^ ]+', 'g');
            const trimmedValue = $j.trim(input.value);
            return re.test(trimmedValue);
        },
        isNumber: function isNumber($elem) {
            const value = $elem.val().trim().replace(/ /g, ''); // Alle Leerzeichen raus wegen Payment CC
            return $j.isNumeric(value);
        },
        /**
		 *
		 * @param element {Element}
		 * @returns {boolean}
		 */ isEmailAddress: function isEmailAddress(element) {
            if (element !== null) {
                const emailValidationReg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (element instanceof jQuery) return emailValidationReg.test(element.val()) === true;
                else if (element instanceof HTMLElement) return emailValidationReg.test(element.value) === true;
            }
        },
        isNotTabOrShiftKey: function isNotTabOrShiftKey(keyCode) {
            return keyCode !== 9 && keyCode !== 16;
        },
        isMouseclickEnterOrSpaceKey: function(keyCode) {
            const isMouseClick = keyCode === undefined;
            const isEnterKey = keyCode === 13;
            const isSpaceKey = keyCode === 32;
            return isMouseClick || isEnterKey || isSpaceKey;
        }
    }
});

});

parcelRegister("jWUCj", function(module, exports) {
jPar.util = jPar.util || {};
deepMerge(true, jPar.util, {
    timezone: {
        setTimezone: function() {
            const _this = this;
            const hasNoFreshTimezoneForSession = jPar.app.appState.get('sessionStorage', 'webapp', 'hasFreshTimezoneForSession') === null;
            const hasNoTimezoneCookie = jPar.util.getCookie('timezone') === null;
            if (hasNoFreshTimezoneForSession || hasNoTimezoneCookie) // muss über sessionStorage gehen, da Chrome/Firefox Session Cookies nicht löschen
            try {
                const currentTimezone = _this.getTimezoneForModernBrowsers();
                _this.writeTimezoneToCookie(currentTimezone);
            } catch  {
            /* old Browsers without Intl Interface fail - we don't care */ }
        },
        getTimezoneForModernBrowsers: function() {
            const invalidTimeZoneObject = typeof Intl.DateTimeFormat().resolvedOptions().timeZone !== 'string';
            if (invalidTimeZoneObject) throw new Error('Timezone could not be resolved by Intl.DateTimeFormat');
            return Intl.DateTimeFormat().resolvedOptions().timeZone; //z.B. "Europe/Berlin"
        },
        writeTimezoneToCookie: function(currentTimezone) {
            jPar.util.setCookie('timezone', currentTimezone);
            jPar.app.appState.set('sessionStorage', 'webapp', 'hasFreshTimezoneForSession', true);
        }
    }
});

});

parcelRegister("7NWf9", function(module, exports) {
jPar.wdk = jPar.wdk || {};
$j.extend(true, jPar.wdk, {
    security: {
        _charsToHTMLEntityMap: {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;',
            '`': '&#96;'
        },
        _htmlEntityToCharMap: {
            '&amp;': '&',
            '&lt;': '<',
            '&gt;': '>',
            '&quot;': '"',
            '&#39;': "'",
            '&#96;': '`'
        },
        escapeStringForHtml: function(string) {
            const _this = this;
            return String(string).replace(/[&<>"'`]/g, function(m) {
                return _this._charsToHTMLEntityMap[m];
            });
        },
        /**
		 * Always use this Method to sanitize HTML-Strings. (BUT not for Backstage-Components, there use a local sanitizeEvilHtml() instead)
		 * @param string
		 * @returns {string} Cleaner String for security reasons
		 */ sanitizeEvilHtml: function(string) {
            // TODO when ready: https://developer.mozilla.org/en-US/docs/Web/API/HTML_Sanitizer_API
            if (string.indexOf('matchingWheelData') > -1) // MatchingWheel needs to write a script-Tag. We should not remove that for this call. Remove after new MatchingWheel (maybe 2024)
            return String(string).replace(/\bonerror=|\bonload=|\bonmouseover=|\bonmouseout=|\bonpagehide=|\bonpageshow=|\bonmessage=|\bonhashchange=|\bonbeforeunload=|\bonpopstate=|\bonresize=|\bonunload=|\bonkeydown=|\bonkeyup=|\bonkeypress=|\bonfocus=|\bonblur=|\bonchange=|\bonsubmit=|\bonreset=|\bonselect=|\bondblclick=|\bondrag=|\bondragend=|\bondragenter=|\bondragleave=|\bondragover=|\bondragstart=|\bondrop=|\bonwheel=|\boncopy=|\boncut=|\bonpaste=|\bonanimationend=|\bonanimationiteration=|\bonanimationstart=|\bontransitionend=|\bontouchcancel=|\bontouchend=|\bontouchmove=|\bontouchstart=|\bonclick=/gi, '');
            else return String(string).replace(/<script\b|\bonerror=|\bonload=|\bonmouseover=|\bonmouseout=|\bonpagehide=|\bonpageshow=|\bonmessage=|\bonhashchange=|\bonbeforeunload=|\bonpopstate=|\bonresize=|\bonunload=|\bonkeydown=|\bonkeyup=|\bonkeypress=|\bonfocus=|\bonblur=|\bonchange=|\bonsubmit=|\bonreset=|\bonselect=|\bondblclick=|\bondrag=|\bondragend=|\bondragenter=|\bondragleave=|\bondragover=|\bondragstart=|\bondrop=|\bonwheel=|\boncopy=|\boncut=|\bonpaste=|\bonanimationend=|\bonanimationiteration=|\bonanimationstart=|\bontransitionend=|\bontouchcancel=|\bontouchend=|\bontouchmove=|\bontouchstart=|\bonclick=/gi, '');
        },
        /**
		 * For Text that should be used in Textareas, we don't want to remove the HTML-Entities
		 * @param string
		 * @returns {string} Clean String for Textareas
		 */ htmlEntitiesToChars: function(string) {
            const _this = this;
            return String(string).replace(/&[^;]+;/g, function(m) {
                if (_this._htmlEntityToCharMap[m] !== '') return _this._htmlEntityToCharMap[m];
                else return m;
            });
        },
        csrf: {
            getToken: function() {
                let csrfToken = '';
                if (document.querySelector('meta[name="_csrf"]') !== null) csrfToken = document.querySelector('meta[name="_csrf"]').getAttribute('content');
                return csrfToken;
            },
            updateToken: function(token) {
                document.querySelector('meta[name="_csrf"]')?.setAttribute('content', token);
                this.setValidstate(true);
            },
            hasValidToken: function() {
                return document.querySelector('meta[name=_csrf]')?.hasAttribute('data-invalid') === false;
            },
            setValidstate: function(state) {
                if (state === true) document.querySelector('meta[name=_csrf]')?.removeAttribute('data-invalid');
                else document.querySelector('meta[name=_csrf]').dataset.invalid = true;
            }
        }
    }
});

});

parcelRegister("47BUi", function(module, exports) {
jPar.wdk = jPar.wdk || {};
$j.extend(true, jPar.wdk, {
    brands: {
        forBrands: function(brands) {
            if ($j('#domPageVars').length > 0) return brands.some(function(currentBrand) {
                return $j('#domPageVars').data('brandId') === currentBrand;
            });
            else // race condition, da unser JS async geladen wird. machmal ist das JS wohl früher fertig, als die Variable im DOM aufgebaut wurde
            window.setTimeout(function() {
                return brands.some(function(currentBrand) {
                    return $j('#domPageVars').data('brandId') === currentBrand;
                });
            }, 1000);
        }
    }
});

});

parcelRegister("fWFpU", function(module, exports) {
jPar.wdk = jPar.wdk || {};
$j.extend(true, jPar.wdk, {
    screensize: {
        getCurrentScreenSize: function() {
            const BREAKPOINT_M = 481;
            const BREAKPOINT_L = 768;
            const BREAKPOINT_XL = 980;
            const windowWidth = this.getInnerWidth();
            let screenSize;
            if (windowWidth >= 0 && windowWidth < BREAKPOINT_M) screenSize = 'S';
            else if (windowWidth >= BREAKPOINT_M && windowWidth < BREAKPOINT_L) screenSize = 'M';
            else if (windowWidth >= BREAKPOINT_L && windowWidth < BREAKPOINT_XL) screenSize = 'L';
            else if (windowWidth >= BREAKPOINT_XL) screenSize = 'XL';
            return screenSize;
        },
        isBreakpoint: function(breakpoints) {
            return breakpoints.indexOf(jPar.wdk.screensize.getCurrentScreenSize()) > -1;
        },
        getInnerWidth: function(forceFresh) {
            if (document.querySelector('peg-app-shell') === null || forceFresh) return window.innerWidth;
            else return document.querySelector('peg-app-shell').getCachedWindowWidth();
        },
        /**
		 * Für SCRUM-14941: Single Product Paywall for Screensize S/M
		 */ setScreenSizeCookie: function() {
            try {
                //TODO if supported in Safari 17. We have a shim here
                window.requestIdleCallback(()=>{
                    const currentScreenSize = this.getCurrentScreenSize();
                    setCookie('currentScreenSize', currentScreenSize);
                    if ($j('#specialOfferScreensize').length > 0) $j('#specialOfferScreensize').val(currentScreenSize);
                });
            } catch (e) {
                jPar.util.log.error('failed to set screensize-cookie on page ' + $j('body').attr('id') + ' - ' + e, 'jPar.wdk.screensize.setScreenSizeCookie()');
            }
        }
    }
});

});

parcelRegister("jViHV", function(module, exports) {
jPar.wdk = jPar.wdk || {};
$j.extend(true, jPar.wdk, {
    /**
	 * @deprecated use wdk-dialog instead
	 */ modalbox: {
        conf: {},
        show: function(param) {
            const _this = this;
            jPar.wdk.modalbox.hide(true);
            document.querySelector('wdk-dialog[open]')?.closeModal(true);
            this.modalboxAbortController = new AbortController();
            this.setConfig(param);
            // console.log('isAjaxModalbox: ' + this.conf.isAjaxModalbox);
            if (this.conf.isAjaxModalbox) _this.loadAjax();
            else _this.loadInline();
            document.dispatchEvent(new CustomEvent('wdkModalBox:shown'));
        },
        setConfig: function(param) {
            // TODO split in 2 Methoden?
            this.conf = {
                // set Initial State for every Modalbox
                $currentModalbox: null,
                jqxhr: null,
                isAjaxModalbox: false,
                url: null,
                ajaxSettings: null,
                closeOnBgClick: false,
                closeOnEsc: false,
                originalPageScrollPosition: null,
                previousActiveElement: null,
                onSuccess: null,
                onFail: null,
                onAlways: null,
                onBeforeClose: null
            };
            // TODO umstellen, das immer der komplette slektor mitgegebn werden muss
            let modalboxSelector = $j(param.modalboxId);
            if (param.modalboxId.indexOf('#') === -1) modalboxSelector = $j('#' + param.modalboxId);
            const $currentModalbox = modalboxSelector;
            if ($currentModalbox.length > 0) {
                this.conf.$currentModalbox = $currentModalbox;
                if (typeof $currentModalbox.data('url') !== 'undefined') {
                    this.conf.isAjaxModalbox = true;
                    this.conf.url = $currentModalbox.data('url');
                    const hasAjaxSettings = typeof param.ajaxSettings !== 'undefined';
                    if (hasAjaxSettings) this.conf.ajaxSettings = param.ajaxSettings;
                    const hasFailCallback = typeof param.onFail !== 'undefined';
                    if (hasFailCallback) this.conf.onFail = param.onFail;
                    const hasAlwaysCallback = typeof param.onAlways !== 'undefined';
                    if (hasAlwaysCallback) this.conf.onAlways = param.onAlways;
                }
                const hasCloseOnBgClickAttr = typeof $currentModalbox.data('closeOnBgClick') !== 'undefined';
                if (hasCloseOnBgClickAttr) this.conf.closeOnBgClick = $currentModalbox.data('closeOnBgClick');
                const hasCloseOnEscAttr = typeof $currentModalbox.data('closeOnEsc') !== 'undefined';
                if (hasCloseOnEscAttr) this.conf.closeOnEsc = $currentModalbox.data('closeOnEsc');
                this.conf.originalPageScrollPosition = $j(document).scrollTop();
                this.conf.previousActiveElement = document.activeElement;
                const hasSuccessCallback = typeof param.onSuccess !== 'undefined';
                if (hasSuccessCallback) this.conf.onSuccess = param.onSuccess;
                const hasBeforeCloseCallback = typeof param.onBeforeClose !== 'undefined';
                if (hasBeforeCloseCallback) this.conf.onBeforeClose = param.onBeforeClose;
            } else {
                jPar.wdk.modalbox.show({
                    modalboxId: 'errorModalbox500'
                });
                throw new Error('wdkmodalbox: Modalbox ID not found on Page ' + param.modalboxId);
            }
        },
        loadAjax: function() {
            const _this = this;
            const $currentModalbox = this.conf.$currentModalbox;
            let _ajaxSettings = '';
            if (_this.conf.ajaxSettings !== null) _ajaxSettings = _this.conf.ajaxSettings;
            this.conf.jqxhr = $j.ajax(_this.conf.url, _ajaxSettings).done(function(responseText) {
                _this.handleSessionExpired(responseText);
                $currentModalbox.html(responseText);
                _this.setCloseEvents();
                _this.handleSpecialDataConfigs();
                _this.makeVisible();
                if (_this.conf.onSuccess !== null) _this.conf.onSuccess();
            }).fail(function(jqXHR, textStatus, errorThrown) {
                if (typeof _this.conf.onFail === 'function') _this.conf.onFail(jqXHR, textStatus, errorThrown);
                _this.handleNetworkErrors(jqXHR, textStatus, errorThrown, $currentModalbox);
            }).always(function() {
                if (typeof _this.conf.onAlways === 'function') _this.conf.onAlways();
            });
        },
        loadInline: function() {
            this.setCloseEvents();
            this.makeVisible();
            if (this.conf.onSuccess !== null) this.conf.onSuccess();
        },
        // Bei Ajax Layer können überraschende Ding zurückgeleifert werden. (MessagingNotAllowed) Wenn diese Layer Inhalte eine spezielle Config brauchen, können die per Data-Attribut gesetzt werden.
        handleSpecialDataConfigs: function() {
            if (this.conf.$currentModalbox.find('[data-set-small-content-class=true]').length > 0) this.conf.$currentModalbox.addClass('has-smallContent');
            if (this.conf.$currentModalbox.find('[data-set-full-bg-image-class=true]').length > 0) this.conf.$currentModalbox.addClass('has-fullBgImage');
        },
        makeVisible: function() {
            this.conf.$currentModalbox[0].classList.remove('noDisplay'); // Boxen mit vieeelen DOMKnoten verlangsamen das SeitenRendering merklich. (siehe Payment AGB boxen).
            this.moveModalboxDomToBottom();
            $j('html').addClass('has-modalboxOpen');
            // Js-Hack: layout trashing - apply all pending style changes
            let $currentModalbox;
            if (this.conf.$currentModalbox.hasClass('wdk-modalbox')) $currentModalbox = this.conf.$currentModalbox;
            else if (this.conf.$currentModalbox.find('.wdk-modalbox').length > 0) $currentModalbox = this.conf.$currentModalbox.find('.wdk-modalbox');
            if ($currentModalbox.find('textarea').length > 0) $currentModalbox.addClass('has-textarea');
            $currentModalbox.css('color'); // Der Wrapper verändert die Sichbarkeit von display none auf block, da braucht er das wohl
            $currentModalbox.addClass('is-open transition-in');
            this.setA11yForOpenModal();
            this.setInitialFocus();
            this.hideCloseButtonInApps();
            document.dispatchEvent(new CustomEvent('wdk:modalbox:isOpened', {
                detail: {
                    $modalboxObj: $currentModalbox
                }
            }));
        },
        setA11yForOpenModal: function() {
            // this.conf.$currentModalbox.attr('aria-hidden', 'false');
            // $j('#pageWrapper').attr('aria-hidden', 'true');
            const nodesArray = Array.prototype.slice.call(document.body.children);
            nodesArray.forEach((child)=>{
                const currentlyInert = child.getAttribute('inert') !== null;
                if (currentlyInert) child.setAttribute('data-inert-before', true);
                const isNotModalboxDom = child !== this.conf.$currentModalbox[0];
                const isNotBackstageTool = child.getAttribute('id') !== 'backstageOpenerRwd';
                if (isNotModalboxDom && isNotBackstageTool) child.setAttribute('inert', true); // Alle anderen Domknoten blockieren
                else child.removeAttribute('inert'); // Modal freigeben
            });
        },
        setA11yForClosedModal: function() {
            // this.conf.$currentModalbox.attr('aria-hidden', 'true');
            // $j('#pageWrapper').removeAttr('aria-hidden');
            const nodesArray = Array.prototype.slice.call(document.body.children);
            nodesArray.forEach((child)=>{
                const restoreInert = child.getAttribute('data-inert-before') !== null;
                if (restoreInert) {
                    child.setAttribute('inert', true);
                    child.removeAttribute('data-inert-before');
                } else child.removeAttribute('inert');
            });
        },
        setInitialFocus: function() {
            const _this = this;
            let focusElement = null;
            const hasNoSpecialFocusField = this.conf.$currentModalbox.find('.js-focusField').length === 0;
            const hasNoAriaLabel = this.conf.$currentModalbox.filter('[aria-labelledby]').length === 0;
            if (hasNoSpecialFocusField) {
                if (this.conf.$currentModalbox.find('header h3').length > 0 && this.conf.$currentModalbox.find('header h3').text().trim() !== '') focusElement = 'header h3';
                else if (this.conf.$currentModalbox.find('h3').length > 0 && this.conf.$currentModalbox.find('h3').text().trim() !== '') focusElement = 'h3';
                else if (this.conf.$currentModalbox.find('header').length > 0 && this.conf.$currentModalbox.find('header').text().trim() !== '') focusElement = 'header';
                else if (this.conf.$currentModalbox.find('article').length > 0) focusElement = 'article';
                if (hasNoAriaLabel && focusElement !== null) this.conf.$currentModalbox.one('transitionend', function() {
                    _this.conf.$currentModalbox.find(focusElement).attr('tabindex', '0').trigger('focus');
                });
                else this.conf.$currentModalbox.one('transitionend', function() {
                    jPar.util.setFocusOnFirstFocusableElement(_this.conf.$currentModalbox.find('article *'));
                });
            }
        },
        setPreviousFocus: function() {
            const _this = this;
            this.conf.$currentModalbox.one('transitionend', function() {
                _this.conf.previousActiveElement.focus();
            });
        },
        hide: function(fastHide) {
            const $modalboxObj = $j('.wdk-modalbox.is-open');
            if ($modalboxObj.length > 0) {
                const _this = this;
                const isModalInModalOpen = $modalboxObj.find('.layerInModalbox.is-open').length > 0;
                if (isModalInModalOpen) jPar.wdk.modalbox.layerInModalbox.hide();
                else {
                    const isAllowedToClose = this.conf.onBeforeClose === null || this.conf.onBeforeClose() === true;
                    if (isAllowedToClose) {
                        const $modalboxObj = $j('.wdk-modalbox.is-open');
                        $modalboxObj.one('transitionend', function() {
                            $j('html').removeClass('has-modalboxOpen');
                            // $j('html').removeClass('has-smallContentModalbox');
                            _this.moveModalboxDomToOriginalPosition();
                            $j('.wdk-modalbox.is-open').removeClass('is-open transition-out');
                            _this.removeEventListener();
                            window.setTimeout(function() {
                                // WTF, ohne das timeout geht das scrollback in S auf der supercard Seite nicht
                                window.scrollTo(0, _this.conf.originalPageScrollPosition);
                            }, 1);
                            document.dispatchEvent(new CustomEvent('wdk:modalbox:isHidden', {
                                detail: {
                                    $modalboxObj: $modalboxObj
                                }
                            }));
                        });
                        $modalboxObj[0].removeAttribute('popover');
                        $modalboxObj.removeClass('transition-in').addClass('transition-out');
                        this.setA11yForClosedModal();
                        this.setPreviousFocus();
                        this.showCloseButtonInApps();
                        if (fastHide || jPar.wdk.screensize.isBreakpoint([
                            'S',
                            'M'
                        ])) $modalboxObj.trigger('transitionend');
                        _this.modalboxAbortController.abort();
                    }
                }
            }
        },
        closeCurrentModalbox: function() {
            if ($j('.wdk-modalbox.is-open').length > 0) jPar.wdk.modalbox.hide(true);
        },
        moveModalboxDomToBottom: function() {
            $j('<div class="modalboxPlaceholder"></div>').insertBefore(this.conf.$currentModalbox);
            this.conf.$currentModalbox.detach().appendTo('body'); // Im DOM nach unten schieben
        },
        moveModalboxDomToOriginalPosition: function() {
            if (this.conf.isAjaxModalbox) {
                // reihenfolge wegen removeClass is-open
                $j('.wdk-modalbox.is-open').empty();
                $j('.wdk-modalbox.is-open').remove().insertAfter('.modalboxPlaceholder');
            } else $j('.wdk-modalbox.is-open').insertAfter('.modalboxPlaceholder');
            $j('.modalboxPlaceholder').remove();
        },
        removeEventListener: function() {
            $j(document).off('.modalboxEvent');
            // For iOS
            $j(document).off('touchmove');
            $j('body').off('touchstart', '.scrollable');
            $j('body').off('touchmove', '.scrollable');
        },
        setCloseEvents: function() {
            document.addEventListener('click', (event)=>{
                const closeSelector = '#' + this.conf.$currentModalbox.attr('id') + ' .js-closeModalbox';
                const closeElems = Array.from(document.querySelectorAll(closeSelector));
                if (closeElems.includes(event.target)) {
                    event.preventDefault();
                    this.hide();
                }
            }, {
                signal: this.modalboxAbortController.signal
            });
            this.conf.$currentModalbox[0].querySelector('.js-reloadPage')?.addEventListener('click', (event)=>{
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();
                document.location.reload();
            }, {
                signal: this.modalboxAbortController.signal
            });
            if (this.conf.closeOnBgClick === true) document.addEventListener('mousedown', (event)=>{
                const isClickedOnModalbox = event.target.matches('.wdk-modalbox .modalboxContent') || event.target.closest('.wdk-modalbox .modalboxContent');
                if (!isClickedOnModalbox) this.hide();
            }, {
                signal: this.modalboxAbortController.signal
            });
            if (this.conf.closeOnEsc === true) document.addEventListener('keyup', (event)=>{
                if (event.key === 'Escape') this.hide();
            }, {
                signal: this.modalboxAbortController.signal
            });
        },
        // webkit = {messageHandlers : {hideCloseButton :{postMessage: function() { console.log('pooost'); }}}}
        // Android = {hideCloseButton: function() {console.log('cloooooose in android');}
        showCloseButtonInApps: function() {
            // DEV-32164
            if (this.conf.$currentModalbox.hasClass('has-smallContent') === false) {
                // Just the Big Modals should hide the X of the NativeApp
                const hasIosAppWrapper = window.webkit?.messageHandlers?.showCloseButton !== undefined;
                if (hasIosAppWrapper) window.webkit.messageHandlers.showCloseButton.postMessage(true);
                const hasAndroidWrapper = window.Android?.showCloseButton !== undefined; // NOSONAR
                if (hasAndroidWrapper) Android.showCloseButton(); // NOSONAR
            }
        },
        hideCloseButtonInApps: function() {
            // DEV-32164
            if (this.conf.$currentModalbox.hasClass('has-smallContent') === false) {
                // Just the Big Modals should hide the X of the NativeApp
                const hasIosAppWrapper = window.webkit?.messageHandlers?.hideCloseButton !== undefined;
                if (hasIosAppWrapper) window.webkit.messageHandlers.hideCloseButton.postMessage(true);
                const hasAndroidWrapper = window.Android?.hideCloseButton !== undefined; // NOSONAR
                if (hasAndroidWrapper) Android.hideCloseButton(); // NOSONAR
            }
        },
        handleNetworkErrors: function(jqXHR, textStatus, errorThrown, $currentModalbox) {
            this.conf.jqxhr.fail(function() {
                if (textStatus === 'timeout') document.querySelector('wdk-snackbar#timeoutNotification').show();
                else {
                    jPar.wdk.modalbox.show({
                        modalboxId: 'errorModalbox500'
                    });
                    if (jqXHR.status !== 0) jPar.util.log.error($currentModalbox.attr('id') + ' on Page ' + $j('body').attr('id') + ' reported ' + jqXHR.status + ' - ' + errorThrown, 'Error opening wdkmodalbox');
                }
            });
        },
        handleSessionExpired: function(response) {
            if (jPar.util.network.hasValidSessionAndCsrfToken(response) === false) {
                jPar.util.network.reloadIfResponseInvalid(response);
                throw new Error('wdkmodalbox: Session expired'); // wichtig - sonst wird der ursprüngliche Layer weiter grendert und zeigt die login-seite an
            }
        },
        layerInModalbox: {
            previousActiveElementInModal: null,
            show: function(elemSelector) {
                const _this = this;
                const currentLayerInModal = document.querySelector('.wdk-modalbox.is-open ' + elemSelector);
                if (currentLayerInModal !== null) {
                    this.previousActiveElementInModal = document.activeElement;
                    currentLayerInModal.classList.add('is-open');
                    currentLayerInModal.querySelector('header h3')?.focus();
                    $j('.wdk-modalbox.is-open .js-closeLayerInLayer').on('click', function(event) {
                        event.preventDefault();
                        _this.hide();
                    });
                }
            },
            hide: function() {
                const layerInModalbox = document.querySelector('.wdk-modalbox.is-open .layerInModalbox.is-open');
                if (layerInModalbox !== null) {
                    layerInModalbox.classList.remove('is-open');
                    this.previousActiveElementInModal.focus();
                    $j('.wdk-modalbox.is-open .js-closeLayerInLayer').off('click');
                }
            }
        }
    }
});

});

parcelRegister("DhLhF", function(module, exports) {
jPar.wdk = jPar.wdk || {};
$j.extend(true, jPar.wdk, {
    hintbox: {
        addClassNoDisplay: function($element) {
            $element.addClass('noDisplay');
            $element.removeAttr('role');
            $element.attr('aria-hidden', 'true');
            $element.attr('inert', 'true');
        },
        removeClassNoDisplay: function($element) {
            $element.removeClass('noDisplay');
            $element.attr('role', 'alert');
            $element.attr('aria-hidden', 'false');
            $element.removeAttr('inert');
        },
        addClassIsVisible: function($element) {
            $element.addClass('is-visible');
            $element.attr('role', 'alert');
            $element.attr('aria-hidden', 'false');
            $element.removeAttr('inert');
        },
        removeClassIsVisible: function($element) {
            $element.removeClass('is-visible');
            $element.removeAttr('role');
            $element.attr('aria-hidden', 'true');
            $element.attr('inert', 'true');
        }
    }
});

});

parcelRegister("4oI1F", function(module, exports) {
jPar.wdk = jPar.wdk || {};
$j.extend(true, jPar.wdk, {
    forms: {
        props: {
            selector: ''
        },
        init: function init(forSelector) {
            this.textElement.init(forSelector);
        },
        showError: function showError($errorElement) {
            if ($errorElement instanceof jQuery) {
                $errorElement.addClass('is-visible');
                $errorElement.attr('role', 'alert');
                $errorElement.attr('aria-hidden', 'false');
                $errorElement.removeAttr('inert');
                const $row = $errorElement.parents('.wdk-form-text, .wdk-form-toggles, .wdk-form-dropdown, .wdk-form-customDropdown');
                if ($row.length > 0) {
                    $row.addClass('has-error');
                    $row.find('input,textarea').attr('aria-invalid', 'true');
                    $row.find('input,textarea').attr('aria-describedby', $errorElement.attr('id'));
                }
            } else if ($errorElement !== null && $errorElement.classList !== undefined) {
                // es gibt immer mal wieder einzelne User, die Fehler werfen, weil classList nicht da ist.
                $errorElement.classList.add('is-visible');
                $errorElement.setAttribute('role', 'alert');
                $errorElement.setAttribute('aria-hidden', 'false');
                $errorElement.removeAttribute('inert');
                const $row = $errorElement.closest('.wdk-form-text, .wdk-form-toggles, .wdk-form-dropdown, .wdk-form-customDropdown');
                if ($row !== null) {
                    $row.classList.add('has-error');
                    $row.querySelector('input,textarea,select').setAttribute('aria-invalid', 'true');
                    $row.querySelector('input,textarea,select').setAttribute('aria-describedby', $errorElement.getAttribute('id'));
                }
            }
        },
        hideError: function hideError($errorElement) {
            if ($errorElement instanceof jQuery) {
                $errorElement.removeClass('is-visible');
                $errorElement.removeAttr('role');
                $errorElement.attr('aria-hidden', 'true');
                $errorElement.attr('inert', 'true');
                const $row = $errorElement.parents('.wdk-form-text, .wdk-form-toggles, .wdk-form-dropdown, .wdk-form-customDropdown');
                if ($row.find('.error.is-visible').length === 0) {
                    // keine weiteren (und sichtbaren) Fehler mehr in der Reihe - für z.B. BE-Validierung / FE-Validierung in der selben Reihe
                    $row.removeClass('has-error');
                    $row.find('input,textarea').removeAttr('aria-invalid', 'false');
                    $row.find('input,textarea').removeAttr('aria-describedby');
                }
            } else if ($errorElement !== null && $errorElement.classList !== undefined) {
                // es gibt immer mal wieder einzelne User, die Fehler werfen, weil classList nicht da ist.
                $errorElement.classList.remove('is-visible');
                $errorElement.removeAttribute('role');
                $errorElement.setAttribute('aria-hidden', 'true');
                $errorElement.setAttribute('inert', 'true');
                const row = $errorElement.closest('.wdk-form-text, .wdk-form-toggles, .wdk-form-dropdown, .wdk-form-customDropdown');
                if (row !== null && row.querySelector('.error.is-visible') === null) {
                    row.classList.remove('has-error');
                    const inputElements = row.querySelectorAll('input,textarea,select');
                    inputElements.forEach((inputElement)=>{
                        inputElement.removeAttribute('aria-invalid');
                        inputElement.removeAttribute('aria-describedby');
                    });
                }
            }
        },
        hasVisibleErrors: function hasVisibleErrors($form) {
            if ($form instanceof jQuery) return $form.find('.wdk-styledHintBox[class*=" t-error"].is-visible').length > 0;
            else if ($form !== null && $form.classList !== undefined) {
                const hasWdkHintboxError = $form.querySelector('wdk-hintbox-error[show]') !== null;
                const hasLegacyHintboxError = $form.querySelectorAll('.wdk-styledHintBox[class*=" t-error"].is-visible').length > 0;
                return hasWdkHintboxError || hasLegacyHintboxError;
            }
        },
        textElement: {
            defaultSelector: '.wdk-form-text',
            selector: '',
            init: function init(forSelector) {
                this.setSelectorProperty(forSelector);
                this.initCharCounter();
            },
            setSelectorProperty: function(forSelector) {
                if (typeof forSelector !== 'undefined') this.selector = forSelector + ' ' + this.defaultSelector;
                else this.selector = this.defaultSelector;
            },
            initCharCounter: function() {
                const _this = this;
                const $textFormElements = $j(this.selector).find('textarea, input');
                $textFormElements.on('keyup blur change paste cut', function() {
                    const $textfield = $j(this);
                    window.setTimeout(function() {
                        _this.updateCounter($textfield);
                    }, 10); // Das paste Event braucht ein setTimeout
                });
                $textFormElements.each(function() {
                    // Initiale Counterwerte setzen
                    _this.updateCounter($j(this));
                });
            },
            updateCounter: function updateCounter($changedElement) {
                const hasMaxlength = $changedElement.attr('maxlength') !== undefined;
                if (hasMaxlength) {
                    const maxChars = $changedElement.attr('maxlength');
                    const nearLimitLength = maxChars / 100 * 80;
                    const changedValueLength = $changedElement.val().length;
                    const $changedInputRow = $changedElement.parents(this.selector);
                    const $limitReachedInfo = $changedInputRow.find('.limitReachedInfo');
                    $changedInputRow.find('.charCounter span').text(changedValueLength);
                    if (changedValueLength >= nearLimitLength) $changedInputRow.addClass('is-nearLimit');
                    else $changedInputRow.removeClass('is-nearLimit');
                    if (changedValueLength >= maxChars) {
                        $changedInputRow.addClass('is-limitReached');
                        if ($limitReachedInfo.length > 0) $limitReachedInfo.text($limitReachedInfo.data('alertText'));
                    } else {
                        $changedInputRow.removeClass('is-limitReached');
                        $limitReachedInfo.text('');
                    }
                }
            }
        },
        customDropdown: {
            callback: null,
            isAnimating: false,
            init: function init(forSelector, callback) {
                const _this = this;
                this.callback = callback;
                if ($j(forSelector).length > 0) {
                    $j(forSelector).find('.wdk-form-customDropdown a').off('click keydown').on('click keydown', function(event) {
                        // off um sicher zu sein, das das event nicht mehrfach angewendet wird
                        if (jPar.util.validate.isMouseclickEnterOrSpaceKey(event.keyCode)) {
                            // A11y
                            if (_this.isAnimating === true) return;
                            _this.isAnimating = true;
                            event.preventDefault();
                            _this.toggle(event);
                            setTimeout(function() {
                                _this.isAnimating = false;
                            }, 280);
                        }
                    });
                    $j(forSelector).find('.wdk-form-customDropdown li').off('click keydown').on('click keydown', function(event) {
                        if (jPar.util.validate.isMouseclickEnterOrSpaceKey(event.keyCode)) {
                            // A11y
                            event.preventDefault();
                            _this.selectCurrentElement(event);
                        }
                    });
                }
            },
            toggle: function toggle(event) {
                const $eventElement = $j(event.target);
                const $component = $eventElement.parents('.wdk-form-customDropdown');
                const $dropDown = $component.find('.selection');
                if ($component.hasClass('is-open')) $component.removeClass('is-open');
                else $component.addClass('is-open');
                $dropDown.slideToggle('fast');
            },
            selectCurrentElement: function selectCurrentElement(event) {
                const $item = $j(event.target);
                $item.parents('.wdk-form-customDropdown').find('.selection').find('li').removeClass('selectedListItem');
                $item.addClass('selectedListItem');
                $item.parents('.wdk-form-customDropdown').find('a').html($item.html());
                this.toggle(event);
                if (typeof this.callback === 'function') {
                    $item.parents('.wdk-form-customDropdown').find('input[name="selectedItem"]').val($item.data('value'));
                    this.callback(event);
                }
            }
        },
        autofillDropdown: {
            callback: null,
            initList: function init(forSelector, callback) {
                const _this = this;
                this.callback = callback;
                if ($j(forSelector).length > 0) $j(forSelector).find('.autofillDropdownDatalist li:not(.noResult)').off('click').on('click', function(event) {
                    event.preventDefault();
                    _this.selectCurrentElement(event);
                });
            },
            initTextfield: function(wrapperSelector, callback) {
                const _this = this;
                let liPosition = 1;
                this.callback = callback;
                this.preventEnterToSubmitForm(wrapperSelector);
                $j(wrapperSelector).find('.js-autofillDropdownTextfield').on('click', function(event) {
                    // beim Click auch triggern
                    if (typeof _this.callback === 'function') callback($j(event.target)); // do Ajax stuff
                });
                $j(wrapperSelector).find('.js-autofillDropdownTextfield').on('keyup', function(event) {
                    event.preventDefault();
                    const keyArrowUp = event.keyCode === 38;
                    const keyArrowDown = event.keyCode === 40;
                    const keyEnter = event.keyCode === 13;
                    const $keyboarSelectedItem = $j(wrapperSelector).find('.autofillDropdownDatalist .selection li.isKeyboardSelected');
                    if (keyArrowUp || keyArrowDown) {
                        const listLength = $j(wrapperSelector).find('.autofillDropdownDatalist .selection li').length;
                        if (listLength > 0) {
                            liPosition = $keyboarSelectedItem.index() + 1; // index beginnt bei 0 / nth-child bei 1
                            const notTopPositionOnKeyUp = keyArrowUp && liPosition > 1;
                            const notLastPositionOnKeyDown = keyArrowDown && liPosition < listLength;
                            if (notTopPositionOnKeyUp) liPosition = liPosition - 1;
                            else if (notLastPositionOnKeyDown) liPosition = liPosition + 1;
                            $keyboarSelectedItem.removeClass('isKeyboardSelected');
                            $j(wrapperSelector).find(`.autofillDropdownDatalist .selection li:nth-child(${liPosition})`).addClass('isKeyboardSelected');
                            $j(wrapperSelector).find('.js-autofillDropdownTextfield').attr('aria-activedescendant', 'autocompleteOption' + liPosition);
                            if ($j(wrapperSelector).find('.isKeyboardSelected').length) $j(wrapperSelector).find('.isKeyboardSelected')[0].scrollIntoView(true);
                        }
                    } else if (keyEnter && $keyboarSelectedItem.length === 1) $keyboarSelectedItem.trigger('click');
                    else // if(/[a-zA-Z0-9\s]/.test(stringFromCharCode) || deleteKeys){ //Android gibt keine richtigen keyCodes raus https://bugs.chromium.org/p/chromium/issues/detail?id=118639
                    if (typeof _this.callback === 'function') callback($j(event.target)); // do Ajax stuff
                });
            },
            preventEnterToSubmitForm: function(wrapperSelector) {
                $j(wrapperSelector).find('.js-autofillDropdownTextfield').on('keydown', function(event) {
                    if (event.keyCode === 13) event.preventDefault();
                });
            },
            open: function($component) {
                const $dropDown = $component.find('.selection');
                $component.parents('.row').find('.js-autofillDropdownTextfield').attr('aria-expanded', 'true');
                $component.addClass('is-open');
                $dropDown.slideDown('fast');
            },
            close: function($component) {
                const $dropDown = $component.find('.selection');
                $component.parents('.row').find('.js-autofillDropdownTextfield').attr('aria-expanded', 'false');
                $component.removeClass('is-open');
                $dropDown.slideUp('fast');
            },
            selectCurrentElement: function(event) {
                const $item = $j(event.target);
                this.close($item.parents('.wdk-form-autofillDropdown .autofillDropdownDatalist'));
                const itemText = $item.text();
                $item.parents('.wdk-form-autofillDropdown').find('.js-autofillDropdownTextfield').val(itemText);
                if (typeof this.callback === 'function') this.callback($item);
            }
        }
    }
});

});

parcelRegister("7mtHF", function(module, exports) {
jPar.wdk = jPar.wdk || {};
$j.extend(true, jPar.wdk, {
    loadingIndicator: {
        indicatorTimer: null,
        show: function show(clickedElement) {
            this.stopTimer();
            if (clickedElement !== null) {
                if (clickedElement.length > 1) {
                    // Kann auch eine nodeList übegeben werden
                    if (clickedElement instanceof jQuery) clickedElement = clickedElement.toArray();
                    clickedElement.forEach(function(elem) {
                        elem.classList.add('disabled');
                        elem.disabled = true;
                        this.indicatorTimer = window.setTimeout(function() {
                            elem.classList.add('is-loading');
                        }, 1500);
                    });
                } else {
                    if (clickedElement instanceof jQuery) clickedElement = clickedElement[0];
                    if (clickedElement !== undefined) {
                        // Nach dem casten aus einem jQuery Element kann sich herausstellen, das es das element doch gar nicht gibt.
                        clickedElement.classList.add('disabled');
                        clickedElement.disabled = true;
                        this.indicatorTimer = window.setTimeout(function() {
                            clickedElement.classList.add('is-loading');
                        }, 1500);
                    }
                }
            }
        },
        hide: function hide(clickedElement) {
            this.stopTimer();
            if (clickedElement !== null) {
                if (clickedElement.length > 1) {
                    // Kann auch eine nodeList übegeben werden
                    if (clickedElement instanceof jQuery) clickedElement = clickedElement.toArray();
                    clickedElement.forEach(function(elem) {
                        elem.classList.remove('disabled', 'is-loading');
                        elem.disabled = false;
                    });
                } else {
                    if (clickedElement instanceof jQuery) clickedElement = clickedElement[0];
                    if (clickedElement !== undefined) {
                        // Nach dem casten aus einem jQuery Element kann sich herausstellen, das es das element doch gar nicht gibt.
                        clickedElement.classList.remove('disabled', 'is-loading');
                        clickedElement.disabled = false;
                    }
                }
            }
        },
        stopTimer: function stopTimer() {
            window.clearTimeout(this.indicatorTimer);
        }
    }
});

});

parcelRegister("59Ooq", function(module, exports) {
jPar.wdk = jPar.wdk || {};
deepMerge(true, jPar.wdk, {
    buttonWithLottie: {
        show: function(clickedElement) {
            clickedElement.querySelector('.wdk-icon').classList.add('noDisplay');
            clickedElement.querySelector('wdk-lottie-animation').classList.remove('noDisplay');
            clickedElement.querySelector('wdk-lottie-animation').myAnimation?.play();
            clickedElement.querySelector('wdk-lottie-animation').myAnimation?.addEventListener('complete', ()=>{
                clickedElement.querySelector('.wdk-icon').classList.remove('noDisplay');
                window.setTimeout(()=>{
                    clickedElement.querySelector('wdk-lottie-animation').classList.add('noDisplay');
                    clickedElement.querySelector('wdk-lottie-animation').myAnimation?.stop();
                }, 200);
            });
        },
        showIfPossible: function(clickedElement) {
            if (clickedElement.classList.contains('t-lottieAnimation')) this.show(clickedElement);
        }
    }
});

});

parcelRegister("dNG6s", function(module, exports) {
jPar.wdk = jPar.wdk || {};
$j.extend(true, jPar.wdk, {
    passwordRestrictionBox: {
        conf: {
            boxName: '',
            emailNoticeInputs: '',
            passwordInputId: ''
        },
        init: function init() {
            const passwordRestrictionInputs = 'input.checkPassword';
            this.conf.boxName = '#wdk-passwordRestrictionBox';
            this.conf.emailNoticeInputs = '#regFormEmail';
            // IE8 nutzt das Placeholder-Plugin. Dieses erzeugt für die Default-Texte Text-Inputs. Diese fallen sonst auch in diesen Selektor mit rein!
            this.conf.passwordInputId = '#' + $j(passwordRestrictionInputs + '[type=password]:first').attr('id');
            const _this = this;
            if ($j(this.conf.boxName).data('showAlways') === false) {
                $j(passwordRestrictionInputs + '[type=password]').on('focus', function() {
                    _this.showRestrictionBox();
                });
                $j(passwordRestrictionInputs + '[type=password]').on('blur', function() {
                    _this.hideRestrictionBox();
                });
            }
            $j(passwordRestrictionInputs).on('keyup change', function() {
                _this.checkPasswordRestrictions();
            });
        },
        showRestrictionBox: function showRestrictionBox() {
            this.checkPasswordRestrictions();
            $j(this.conf.boxName).fadeIn(400);
        },
        hideRestrictionBox: function hideRestrictionBox() {
            $j(this.conf.boxName).fadeOut(400);
        },
        checkPasswordRestrictions: function checkPasswordRestrictions() {
            this.checkLength();
            this.checkLettersAndNumbers();
            if ($j('#partOfEmail').length) this.checkPartOfEmail();
            if ($j(this.conf.boxName + ' ul li').length === $j(this.conf.boxName + ' ul li.success').length) $j(this.conf.boxName).addClass('success');
            else $j(this.conf.boxName).removeClass('success');
        },
        checkLength: function checkLength() {
            if ($j(this.conf.passwordInputId).val().length >= 8) this.setRestrictionToSuccess('#minCharacters');
            else this.setRestrictionToError('#minCharacters');
        },
        checkLettersAndNumbers: function checkLettersAndNumbers() {
            const password = $j(this.conf.passwordInputId).val();
            const hasCharacter = /.*[a-zA-Z]+.*/g.test(password);
            const hasNumber = /.*[0-9]+.*/g.test(password);
            const hasSpecialCharacter = /.*[^a-zA-Z0-9\s]+.*/g.test(password);
            if (hasCharacter && hasNumber || hasCharacter && hasSpecialCharacter) this.setRestrictionToSuccess('#lettersAndNumbers');
            else this.setRestrictionToError('#lettersAndNumbers');
        },
        checkPartOfEmail: function checkPartOfEmail() {
            const frontEmailPart = $j(this.conf.emailNoticeInputs).val().split('@')[0];
            const passwordFilled = $j(this.conf.passwordInputId).val().length > 0;
            const passwordIsNotPartOfEmail = $j(this.conf.passwordInputId).val().indexOf(frontEmailPart) < 0;
            if (passwordFilled && (frontEmailPart === '' || passwordIsNotPartOfEmail)) this.setRestrictionToSuccess('#partOfEmail');
            else this.setRestrictionToError('#partOfEmail');
        },
        setRestrictionToSuccess: function setRestrictionToSuccess(element) {
            $j(element).removeClass('error');
            $j(element).addClass('success');
        },
        setRestrictionToError: function setRestrictionToError(element) {
            $j(element).removeClass('success');
            $j(element).addClass('error');
        },
        isPasswordValid: function isPasswordValid() {
            return $j(this.conf.boxName + ' ul li').length === $j(this.conf.boxName + ' ul li.success').length;
        }
    }
});

});

parcelRegister("hGPqC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce0e4080f4e5eb5b$export$2e2bcd8739ae039; });
class $ce0e4080f4e5eb5b$export$2e2bcd8739ae039 extends HTMLElement {
    static get observedAttributes() {
        return [
            'orientation'
        ];
    }
    async connectedCallback() {
        await jPar.util.waitForChildNodes();
        this.abortController = new AbortController();
        this.#createMarkup();
        this.#getDynamicConf();
        this.shadowRoot.querySelector('a').addEventListener('click', (event)=>{
            if (this.hasAttribute('disabled')) event.preventDefault();
        });
    }
    disconnectedCallback() {
        this.abortController?.abort();
    }
    #createMarkup() {
        const template = document.createElement('template');
        const shadowHtml = `<style>
					:host {
						overflow: hidden;
						display: block;
					}
					
					:host([disabled]) a {
						background-color: var(--COLOR_support_black_default); /* TODO 70% machen */
						opacity: .6;
						cursor: default;
					}
					
					:host a {
						position: relative;
						display: flex;
						justify-content: center;
						align-items: center;
						width: 100%;
						margin-top: 4px;
						height: 44px;
						color: var(--COLOR_support_white_default);
						border: 0;
						background-color: var(--COLOR_support_black_default);
						border-radius: var(--borderRadius_button);
						cursor: pointer;
						text-decoration: none;
					}
					
					::slotted([slot="icon"].wdk-icon) {
						margin-bottom: 2px;
						margin-right: 4px;
						fill: var(--COLOR_support_white_default) !important;
					}
					
					:host a span {
						font: var(--FONT_highlight_75);
					}
				</style>
				<a aria-label="Apple Login" role="button" href="#">
					<slot name="icon"></slot>
					<span class="text"><slot name="buttonText"></slot></span>
				</a>
			`;
        template.innerHTML = this.#sanitizeEvilHtml(shadowHtml);
        const clone = document.importNode(template.content, true);
        if (!this.shadowRoot) {
            this.attachShadow({
                mode: 'open'
            });
            this.shadowRoot.appendChild(clone);
        }
    }
    attributeChangedCallback(name, oldVal, newVal) {
        if (name === 'orientation' && oldVal !== newVal) this.#setHref(newVal);
    }
    #setHref(orientation) {
        const searchParam = orientation !== undefined ? `&search=${orientation}` : ''; // just for Registration
        const appleDomain = 'https://appleid.apple.com/auth/authorize';
        const appleCallbackPart = this.getAttribute('special-callback') !== null ? this.getAttribute('special-callback') : 'appleCallback';
        const clientIdParam = '?client_id=' + dynamicConf.apple.clientId;
        const redirectUriParam = `&redirect_uri=${encodeURIComponent(dynamicConf.apple.callbackDomain)}%2F${appleCallbackPart}`;
        const staticParams = `&response_type=${encodeURIComponent('code id_token')}&response_mode=form_post&scope=email`;
        const action = this.getAttribute('orientation') !== null ? 'reg' : 'login';
        const stateParam = `&state=action%3D${action}%26oid%3D${this.getAttribute('oid')}${encodeURIComponent(searchParam)}`;
        const stateAttr = this.getAttribute('social-provider-state');
        const socialProviderState = stateAttr !== null && stateAttr !== '' ? encodeURIComponent(`&socialProviderState=${stateAttr}`) : '';
        const fullUrl = appleDomain + clientIdParam + redirectUriParam + staticParams + stateParam + socialProviderState;
        this.shadowRoot.querySelector('a').setAttribute('href', fullUrl);
    }
    #getDynamicConf() {
        if (typeof dynamicConf === 'object') this.#setHref();
        else {
            const scriptTag = document.createElement('script');
            scriptTag.setAttribute('src', '/common/dynamicconf');
            this.shadowRoot.appendChild(scriptTag);
            if (!scriptTag.onloadDone) {
                scriptTag.onloadDone = true;
                scriptTag.onload = ()=>{
                    this.#setHref();
                };
            }
        }
    }
    #sanitizeEvilHtml(string) {
        // Das muss nochmal ein richtiger sanatizer werden
        return String(string).replace(/<script\b|\bonerror=|\bonload=|\bonmouseover=|\bonmouseout=|\bonpagehide=|\bonpageshow=|\bonmessage=|\bonhashchange=|\bonbeforeunload=|\bonpopstate=|\bonresize=|\bonunload=|\bonkeydown=|\bonkeyup=|\bonkeypress=|\bonfocus=|\bonblur=|\bonchange=|\bonsubmit=|\bonreset=|\bonselect=|\bondblclick=|\bondrag=|\bondragend=|\bondragenter=|\bondragleave=|\bondragover=|\bondragstart=|\bondrop=|\bonwheel=|\boncopy=|\boncut=|\bonpaste=|\bonanimationend=|\bonanimationiteration=|\bonanimationstart=|\bontransitionend=|\bontouchcancel=|\bontouchend=|\bontouchmove=|\bontouchstart=|\bonclick=/gi, '');
    }
}

});

parcelRegister("5WXf9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4550530a8c2aac7f$export$2e2bcd8739ae039; });
class $4550530a8c2aac7f$export$2e2bcd8739ae039 extends HTMLElement {
    async connectedCallback() {
        await jPar.util.waitForChildNodes();
        this.#createMarkup();
        this.#getDynamicConf();
    }
    #createMarkup() {
        const template = document.createElement('template');
        const shadowHtml = `<style>
					:host {
						display: flex;
						overflow: hidden;
					}
					
					:host a {
						position: relative;
						display: flex;
						justify-content: center;
						align-items: center;
						gap: 4px;
						width: calc(100% - 2px);
						height: 42px;
						color: var(--COLOR_support_black_default);
						background-color: var(--COLOR_support_white_default);
						border-radius: var(--borderRadius_button);
						border: var(--COLOR_support_black_default) 1px solid;
						cursor: pointer;
						text-decoration: none;
					}
					
					::slotted([slot="icon"].wdk-icon) {
						height: 16px !important;
						width: 16px !important;
						margin-right: 4px;
						fill: var(--COLOR_support_black_default) !important;
					}
					
					:host a span {
						font: var(--FONT_highlight_75);
					}
				</style>
				<a aria-label="Google Login" role="button" href="#">
					<slot name="icon"></slot>
					<span class="text"><slot name="buttonText"></slot></span>
				</a>
			`;
        template.innerHTML = this.#sanitizeEvilHtml(shadowHtml);
        const clone = document.importNode(template.content, true);
        if (!this.shadowRoot) {
            this.attachShadow({
                mode: 'open'
            });
            this.shadowRoot.appendChild(clone);
        }
    }
    #setHref() {
        const googleDomain = 'https://accounts.google.com/o/oauth2/v2/auth';
        const clientIdParam = '?client_id=' + dynamicConf.google.clientId;
        const stateAttr = this.getAttribute('social-provider-state');
        const state = stateAttr !== null && stateAttr !== '' ? '&state=' + encodeURIComponent(`socialProviderState=${stateAttr}`) : '';
        const redirectUriParam = '&redirect_uri=' + this.getAttribute('redirect-url');
        const staticParams = '&response_type=code&access_type=offline&scope=profile%20email';
        const fullUrl = googleDomain + clientIdParam + state + redirectUriParam + staticParams;
        this.shadowRoot.querySelector('a').setAttribute('href', fullUrl);
    }
    #getDynamicConf() {
        if (typeof dynamicConf === 'object') this.#setHref();
        else {
            const scriptTag = document.createElement('script');
            scriptTag.setAttribute('src', '/common/dynamicconf');
            this.shadowRoot.appendChild(scriptTag);
            if (!scriptTag.onloadDone) {
                scriptTag.onloadDone = true;
                scriptTag.onload = ()=>{
                    this.#setHref();
                };
            }
        }
    }
    #sanitizeEvilHtml(string) {
        // Das muss nochmal ein richtiger sanatizer werden
        return String(string).replace(/<script\b|\bonerror=|\bonload=|\bonmouseover=|\bonmouseout=|\bonpagehide=|\bonpageshow=|\bonmessage=|\bonhashchange=|\bonbeforeunload=|\bonpopstate=|\bonresize=|\bonunload=|\bonkeydown=|\bonkeyup=|\bonkeypress=|\bonfocus=|\bonblur=|\bonchange=|\bonsubmit=|\bonreset=|\bonselect=|\bondblclick=|\bondrag=|\bondragend=|\bondragenter=|\bondragleave=|\bondragover=|\bondragstart=|\bondrop=|\bonwheel=|\boncopy=|\boncut=|\bonpaste=|\bonanimationend=|\bonanimationiteration=|\bonanimationstart=|\bontransitionend=|\bontouchcancel=|\bontouchend=|\bontouchmove=|\bontouchstart=|\bonclick=/gi, '');
    }
}

});

parcelRegister("2FBCq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f1c9769daf72938$export$2e2bcd8739ae039; });
class $1f1c9769daf72938$export$2e2bcd8739ae039 extends HTMLElement {
    connectedCallback() {
        this.#setCookieIfUserIsAlreadyRegistered();
        this.#createMarkup();
        this.#init();
    }
    disconnectedCallback() {}
    #createMarkup() {
        const template = document.createElement('template');
        const shadowHtml = `<style>
					:host {
						display: none;
					}

					:host([open]) {
						container-type: inline-size;
						container-name: cookieBanner;
						display: flex;
						position: fixed;
						bottom: 0;
						left: 0;
						right: 0;
						z-index: 999;
						--COLOR_text: var(--COLOR_support_white_default);
						--COLOR_background: var(--COLOR_primary_default);
					}

					:host([brand="elitepartner"]) .inner {
						@container cookieBanner (min-width: 768px) {
							--COLOR_text: var(--COLOR_gray_200);
							--COLOR_background: var(--COLOR_support_white_default);
						}
					}

					:host([open]) .inner {
						display: flex;
						font-family: 'Open Sans', Arial, Helvetica, sans-serif;
						line-height: 14px;
						font-weight: normal;
						align-items: flex-start;
						padding: 10px 110px 10px 20px;
						width: 100%;
						max-height: 200px;
						overflow: auto;
						-webkit-overflow-scrolling: touch;
						font-size: 11px;
						border-top: 1px solid rgba(255,255,255, .2);
						background-color: var(--COLOR_background);
						color: var(--COLOR_text);
					}

					:host .inner span {
						padding: 6px 0 4px 0;
					}

					:host .inner a {
						color: var(--COLOR_text);
						text-decoration: underline;
						
						&:focus-visible {
							outline: 2px dashed currentColor;
							outline-offset: 2px;
						}
					}

					:host .inner button {
						position: fixed;
						right: 0;
						max-width: 80px;
						margin: 10px 20px 0 0;
						padding: 8px 12px;
						border: 2px solid var(--COLOR_text);
						color: var(--COLOR_text);
						border-radius: 4px; /* lokaler radius */
						text-decoration: none;
						text-align: center;
						font-weight: 600;
						font-size: 13px;
						z-index: 1000;
						background: none;
						cursor: pointer;
						
						&:focus-visible {
							outline: 2px dashed currentColor;
							outline-offset: 2px;
						}
					}
				</style>
				<div class="inner">
					<span data-target="bannertext"></span>
					<button></button>
				</div>
			`;
        template.innerHTML = this.#sanitizeEvilHtml(shadowHtml);
        const clone = document.importNode(template.content, true);
        if (!this.shadowRoot) {
            this.attachShadow({
                mode: 'open'
            });
            this.shadowRoot.appendChild(clone);
        }
    }
    #init() {
        const showBanner = getCookie('tms_infobanner') === null;
        if (showBanner) {
            this.setAttribute('open', '');
            this.shadowRoot.querySelector('[data-target="bannertext"]').innerHTML = this.#sanitizeEvilHtml(this.querySelector('[data-role="bannertext"]').innerHTML);
            this.shadowRoot.querySelector('button').innerText = this.querySelector('[data-role="buttontext"]').innerText;
            this.querySelector('[data-role="bannertext"]').remove();
            this.querySelector('[data-role="buttontext"]').remove();
            this.#trackBannerIsShown();
            this.shadowRoot.querySelector('button').addEventListener('click', ()=>{
                this.#setDismissCookie();
                this.#trackClickedOk();
                this.remove();
            }, {
                once: true
            });
        }
    }
    #setCookieIfUserIsAlreadyRegistered() {
        const isLoggedIn = this.getAttribute('is-loggedin') === 'true';
        if (isLoggedIn) this.#setDismissCookie();
    }
    #setDismissCookie() {
        setCookie('tms_infobanner', 'dismiss', '760');
    }
    #sanitizeEvilHtml(string) {
        // Das muss nochmal ein richtiger sanatizer werden
        return String(string).replace(/<script\b|\bonerror=|\bonload=|\bonmouseover=|\bonmouseout=|\bonpagehide=|\bonpageshow=|\bonmessage=|\bonhashchange=|\bonbeforeunload=|\bonpopstate=|\bonresize=|\bonunload=|\bonkeydown=|\bonkeyup=|\bonkeypress=|\bonfocus=|\bonblur=|\bonchange=|\bonsubmit=|\bonreset=|\bonselect=|\bondblclick=|\bondrag=|\bondragend=|\bondragenter=|\bondragleave=|\bondragover=|\bondragstart=|\bondrop=|\bonwheel=|\boncopy=|\boncut=|\bonpaste=|\bonanimationend=|\bonanimationiteration=|\bonanimationstart=|\bontransitionend=|\bontouchcancel=|\bontouchend=|\bontouchmove=|\bontouchstart=|\bonclick=/gi, '');
    }
    #trackBannerIsShown() {
        document.dispatchEvent(new CustomEvent('pegLogger-logWebAppEvents', {
            detail: {
                // Do not use jPar.wdk.logger.bigData here. Component is in base_combined, we don't have jPar yet.
                category: 'tracking_choice',
                subcategory: 'tracking_choice_dialog',
                targetId: 'dialog',
                action: 'show'
            }
        }));
    }
    #trackClickedOk() {
        // OptOut
        document.dispatchEvent(new CustomEvent('pegLogger-logWebAppEvents', {
            detail: {
                category: 'tracking_choice',
                subcategory: 'tracking_choice_dialog',
                targetId: 'ok_button',
                action: 'click'
            }
        }));
    }
}

});

parcelRegister("b4Kph", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $810410d157a487a6$export$2e2bcd8739ae039; });
class $810410d157a487a6$export$2e2bcd8739ae039 extends HTMLElement {
    #notifications;
    #abortController;
    #signal;
    async connectedCallback() {
        await new Promise(requestAnimationFrame);
        this.#abortController = new AbortController();
        this.#signal = this.#abortController.signal;
        this.#notifications = {
            offline: {
                element: this.querySelector('#offlineError'),
                show: ()=>this.#showNotification('offline')
            },
            lieFi: {
                element: this.querySelector('#lieFiNotification'),
                show: ()=>this.#showNotification('lieFi'),
                button: this.querySelector('#lieFiNotification a')
            }
        };
        this.#init();
    }
    async disconnectedCallback() {
        await new Promise(requestAnimationFrame);
        this.#abortController?.abort();
    }
    #init() {
        this.#checkOnlineState();
        document.addEventListener('ajaxShellPage:initDone', ()=>this.#checkCachedPage(), {
            signal: this.#signal
        });
        document.addEventListener('serviceworker:pageFromNetwork', ()=>{
            this.#hideAllNotifications();
            document.querySelector('html')?.removeAttribute('data-origin');
        }, {
            signal: this.#signal
        });
        document.addEventListener('serviceworker:triggerOfflineAttention', ()=>{
            this.#triggerOfflineAttention();
        }, {
            signal: this.#signal
        });
        // Setup animation end event
        this.#notifications.offline.element?.addEventListener('animationend', ()=>this.#notifications.offline.element.classList.remove('attention'), {
            signal: this.#signal
        });
        // Setup reload button
        this.#notifications.lieFi.button?.addEventListener('click', ()=>{
            this.#handleReloadClick(event);
        }, {
            signal: this.#signal
        });
    }
    #checkOnlineState() {
        if (!navigator.onLine) this.#handleOfflineMode();
        window.addEventListener('offline', ()=>this.#handleOfflineMode(), {
            signal: this.#signal
        });
        window.addEventListener('online', ()=>this.#handleOnlineMode(), {
            signal: this.#signal
        });
    }
    #handleOfflineMode() {
        document.documentElement.classList.add('is-offline');
        this.#notifications.offline.show();
        this.#setupOnlineOnlyElements(true);
    }
    #handleOnlineMode() {
        document.documentElement.classList.remove('is-offline');
        this.#hideAllNotifications();
        this.#setupOnlineOnlyElements(false);
    }
    #setupOnlineOnlyElements(add) {
        const onlineOnlyElements = document.querySelectorAll('.js-onlineOnly');
        onlineOnlyElements.forEach((element)=>{
            if (add) element.addEventListener('click', (event1)=>this.onOnlineOnlyElementClick(event1), {
                signal: this.#signal
            });
            else element.removeEventListener('click', this.onOnlineOnlyElementClick);
        });
    }
    onOnlineOnlyElementClick(event1) {
        event1.preventDefault();
        event1.stopPropagation();
        this.#triggerOfflineAttention();
    }
    #triggerOfflineAttention() {
        const element = this.#notifications.offline.element;
        if (!element) return;
        element.classList.remove('noDisplay');
        element.classList.remove('attention');
        // Force reflow to ensure animation can be triggered again
        element.offsetWidth;
        element.classList.add('attention');
    }
    // Shows the appropriate notification based on online/offline state
    #showNotification(type) {
        this.#hideAllNotifications();
        if (!this.#notifications[type]?.element) return;
        this.#notifications[type].element.classList.remove('noDisplay');
        if (type === 'lieFi') {
            // Add auto-hide behavior for lieFi
            document.addEventListener('scroll', ()=>this.#handlePageInteraction(), {
                once: true,
                signal: this.#signal
            });
            // Auto-hide notification after timeout
            setTimeout(()=>this.#handlePageInteraction(), 15000);
        }
    }
    #hideAllNotifications() {
        Object.values(this.#notifications).forEach((notification)=>{
            notification.element?.classList.add('noDisplay');
        });
    }
    // Check if we're on a cached page and show appropriate notification
    #checkCachedPage() {
        if (this.#isCachedPage()) {
            if (navigator.onLine) this.#notifications.lieFi.show();
            else this.#notifications.offline.show();
        }
    }
    #isCachedPage() {
        return document.querySelector('html[data-origin=cacheStorage]') !== null || document.querySelector('html[data-origin=cacheStorageAjax]') !== null;
    }
    #handlePageInteraction() {
        this.#hideAllNotifications();
        document.removeEventListener('scroll', ()=>this.#handlePageInteraction);
    }
    #handleReloadClick(event1) {
        event1.preventDefault();
        document.location.reload();
    }
}

});

parcelRegister("6Ts2t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $504da118683a17a6$export$2e2bcd8739ae039; });
class $504da118683a17a6$export$2e2bcd8739ae039 extends HTMLElement {
    connectedCallback() {
        const template = document.createElement('template');
        const lightDom = this.innerHTML;
        const shadowHtml = `<style>
					:host {
						/*position: absolute;*/
						z-index: 999;
					}
	
					code {
						display: inline-block;
						background-color: lightcoral;
						padding: 0;
						font-size: 12px;
						font-weight: normal;
						line-height: 18px;
						overflow: hidden;
						max-width: 16px;
						height: 16px;
						border-radius: var(--RADIUS_circle);
						cursor: copy;
						color: rgba(255, 255, 255, 0);
					}
						
					code.is-open {
						transition: max-width .5s ease-in-out, padding .5s ease-in, color ease-in .5s;
						padding: 4px;
						max-width: 700px;
						height: auto;
						color: rgba(255, 255, 255, 1);
						border-radius: 6px; /* lokaler radius */
						/*cursor: zoom-out;*/
					}
				</style>
				<code class="is-open">${lightDom}</code>
			`;
        // template.innerHTML = new Sanitizer().sanitizeFor('div', shadowHtml).innerHTML;
        template.innerHTML = this.sanitizeEvilHtml(shadowHtml);
        const clone = document.importNode(template.content, true);
        if (!this.shadowRoot) {
            this.attachShadow({
                mode: 'open'
            });
            this.shadowRoot.appendChild(clone);
        }
        this.addEventListener('click', async (event)=>{
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            const messageKey = lightDom.replaceAll('{', '').replaceAll('}', '');
            await navigator.clipboard.writeText(messageKey);
            // Add visual feedback for copy action
            const codeElement = this.shadowRoot.querySelector('code');
            const originalBackground = codeElement.style.backgroundColor;
            // Briefly change the background color to indicate successful copy
            codeElement.style.backgroundColor = '#4CAF50'; // Green color for success
            // Reset back to original color after a short delay
            setTimeout(()=>{
                codeElement.style.backgroundColor = originalBackground;
            }, 300); // 300ms flash
        });
    }
    sanitizeEvilHtml(string) {
        // Das muss nochmal ein richtiger sanatizer werden
        return String(string).replace(/<script|onerror|onload|onmouseover|onmouseout|onpagehide|onpageshow|onmessage|onhashchange|onbeforeunload|onpopstate|onresize|onunload/g, '');
    }
    disconnectedCallback() {}
}

});

parcelRegister("4LrRv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $378129ffe57d732c$export$2e2bcd8739ae039; });
class $378129ffe57d732c$export$2e2bcd8739ae039 extends HTMLElement {
    async connectedCallback() {
        await jPar.util.waitForChildNodes();
    }
    disconnectedCallback() {}
}

});

parcelRegister("hlI6t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca169bd8ab78694e$export$2e2bcd8739ae039; });

var $6eqaA = parcelRequire("6eqaA");
class $ca169bd8ab78694e$export$2e2bcd8739ae039 extends HTMLElement {
    async connectedCallback() {
        await new Promise(requestAnimationFrame); //wait a tick
        this.abortController = new AbortController();
        this.#setupEventListeners();
        this.#initDragAndDropFileSelection();
    }
    disconnectedCallback() {
        this.abortController.abort();
    }
    #setupEventListeners() {
        this.addEventListener('pegPhotoUploader:uploadFailed', ()=>{
            document.querySelector('#errorDialog500').openModal();
            this.#trackValidationError('unknown');
        }, {
            signal: this.abortController.signal
        });
        this.addEventListener('pegPhotoUploader:maxPhotosReached', ()=>{
            this.querySelector('#errorMaxImageReached').openModal();
            this.#trackValidationError('max_reached');
        }, {
            signal: this.abortController.signal
        });
        this.querySelector('#uploadPicture').addEventListener('click', ()=>{
            this.openPhotoPicker();
        }, {
            signal: this.abortController.signal
        });
        this.querySelector('#uploadPictureField').addEventListener('change', (event)=>{
            this.#validateAndPresentImage(event.target.files[0]);
        }, {
            signal: this.abortController.signal
        });
    }
    #initDragAndDropFileSelection() {
        const dragAndDropArea = this.querySelector('#dragDropArea');
        //this is needed to prevent the browser from opening the image inside another tab
        for (const eventNamesToStopBrowserDefaults of [
            'dragenter',
            'dragover',
            'dragleave',
            'drop'
        ])document.addEventListener(eventNamesToStopBrowserDefaults, (event)=>{
            event.preventDefault();
            event.stopPropagation();
        }, {
            signal: this.abortController.signal
        });
        dragAndDropArea.addEventListener('dragenter', ()=>{
            dragAndDropArea.classList.add('dragOver');
        }, {
            signal: this.abortController.signal
        });
        dragAndDropArea.addEventListener('dragover', ()=>{
            dragAndDropArea.classList.add('dragOver');
        }, {
            signal: this.abortController.signal
        });
        dragAndDropArea.addEventListener('dragleave', ()=>{
            dragAndDropArea.classList.remove('dragOver');
        }, {
            signal: this.abortController.signal
        });
        dragAndDropArea.addEventListener('drop', (event)=>{
            this.#validateAndPresentImage(event.dataTransfer.files[0]);
            this.#trackInitUploadButton();
        }, {
            signal: this.abortController.signal
        });
    }
    openPhotoPicker() {
        this.#hideAllUploadErrors();
        this.querySelector('#uploadPictureField').click();
        this.#trackInitUploadButton();
    }
    //todo: should be inside of the peg-photo-upload-dialog
    // it likely cant, as the template of the dialog will get copied
    async #startEditing(photo) {
        await this.querySelector('#photoEditorDialog').openModal();
        this.querySelector('peg-photo-editor').startCropper(photo);
    }
    async #validateAndPresentImage(imageFile) {
        try {
            this.#hideAllUploadErrors();
            if (!imageFile) throw {
                type: 'no_file'
            };
            if (!navigator.onLine) throw {
                type: 'offline'
            };
            this.#isValidFileType(imageFile);
            this.#isValidFileSize(imageFile);
            await this.#isValidImageDimensions(imageFile);
            const imageExif = await this.#readExif(imageFile);
            this.creationDate = this.#transformToIsoDate(imageExif?.DateTimeOriginal || imageExif?.DateTime);
            this.#trackPhotoSelected();
            await this.#presentImage(imageFile);
        } catch (error) {
            console.error(error);
            this.#handleValidationError(error);
        }
    }
    #handleValidationError(error) {
        switch(error?.type){
            case 'wrong_format':
                this.#showWrongFileTypeError();
                break;
            case 'file_too_big':
                this.#showFileSizeExceededError();
                break;
            case 'file_dimensions':
                this.#showImageToSmallError();
                break;
            case 'no_file':
            case 'file_unavailable':
                this.#showImageCorruptedError();
                break;
            case 'offline':
                this.#showOfflineError();
                break;
            default:
                this.#showUnknownError();
                break;
        }
    }
    #transformToIsoDate(creationDate) {
        // if the date is not in the data, we just assume it was created just now
        if (!creationDate) return new Date().toJSON();
        const splitDate = creationDate.split(/\D/);
        return new Date(splitDate[0], splitDate[1] - 1, splitDate[2], splitDate[3], splitDate[4], splitDate[5]).toJSON();
    }
    async #readExif(imageFile) {
        const buffer = await imageFile.arrayBuffer();
        return (0, (/*@__PURE__*/$parcel$interopDefault($6eqaA))).readFromBinaryFile(buffer);
    }
    #presentImage(imageFile) {
        return new Promise((resolve)=>{
            const reader = new FileReader();
            reader.onload = async (event)=>{
                await this.#startEditing(event.target.result);
                this.querySelector('#uploadPictureField').value = null;
                resolve();
            };
            reader.readAsDataURL(imageFile);
        });
    }
    #showWrongFileTypeError() {
        this.querySelector('#errorBox_wrongFiletype').setAttribute('show', 'true');
        this.querySelector('#uploadPictureField').value = '';
        this.#trackValidationError('wrong_format');
    }
    #showFileSizeExceededError() {
        this.querySelector('#errorBox_filesizeExceeded').setAttribute('show', 'true');
        this.querySelector('#uploadPictureField').value = '';
        this.#trackValidationError('file_too_big');
    }
    #showImageToSmallError() {
        this.querySelector('#errorBox_imageToSmall').setAttribute('show', 'true');
        this.querySelector('#uploadPictureField').value = '';
        this.#trackValidationError('file_dimensions');
    }
    #showImageCorruptedError() {
        this.querySelector('#errorBox_imageCorrupted').setAttribute('show', 'true');
        this.querySelector('#uploadPictureField').value = '';
        this.#trackValidationError('file_unavailable');
    }
    #showOfflineError() {
        this.querySelector('#errorBox_offline').setAttribute('show', 'true');
        this.querySelector('#uploadPictureField').value = '';
        this.#trackValidationError('offline');
    }
    #showUnknownError() {
        this.querySelector('#errorBox_unknown').setAttribute('show', 'true');
        this.querySelector('#uploadPictureField').value = '';
        this.#trackValidationError('unknown');
    }
    #isValidFileType(imageFile) {
        const validImageTypesRegex = new RegExp('gif|jpg|jpeg|png|webp');
        if (validImageTypesRegex.test(imageFile.type)) return true;
        throw {
            type: 'wrong_format'
        };
    }
    #isValidFileSize(imageFile) {
        if (imageFile.size <= 10485760) // 10 Megabyte
        return true;
        throw {
            type: 'file_too_big'
        };
    }
    #isValidImageDimensions(imageFile) {
        return new Promise((resolve, reject)=>{
            const reader = new FileReader();
            reader.onload = (event)=>{
                const tempImage = new Image();
                tempImage.onload = ()=>{
                    if (tempImage.width < 500 || tempImage.height < 500) reject({
                        type: 'file_dimensions'
                    });
                    else resolve(true);
                };
                tempImage.onerror = ()=>{
                    reject({
                        type: 'file_unavailable'
                    });
                };
                tempImage.src = event.target.result;
            };
            reader.onerror = ()=>{
                reject({
                    type: 'file_unavailable'
                });
            };
            reader.readAsDataURL(imageFile);
        });
    }
    #hideAllUploadErrors() {
        const errorMessages = this.querySelectorAll('* > wdk-hintbox-error');
        errorMessages.forEach((errorElement)=>{
            errorElement.removeAttribute('show');
        });
        this.querySelector('#dragDropArea').classList.remove('dragOver');
    }
    #trackValidationError(targetId) {
        jPar.util.log.bigData({
            category: this.getAttribute('tracking-category'),
            subcategory: this.getAttribute('tracking-subcategory'),
            targetId: targetId,
            action: 'error'
        });
    }
    #trackInitUploadButton() {
        jPar.util.log.bigData({
            category: this.getAttribute('tracking-category'),
            subcategory: this.getAttribute('tracking-subcategory'),
            action: 'click',
            targetId: this.getAttribute('tracking-target-id')
        });
    }
    #trackPhotoSelected() {
        jPar.util.log.bigData({
            category: this.getAttribute('tracking-category'),
            subcategory: this.getAttribute('tracking-subcategory'),
            action: 'click',
            targetId: 'button_select_photo'
        });
    }
}

});
parcelRegister("6eqaA", function(module, exports) {
(function() {
    var debug = false;
    var root = this;
    var EXIF = function(obj) {
        if (obj instanceof EXIF) return obj;
        if (!(this instanceof EXIF)) return new EXIF(obj);
        this.EXIFwrapped = obj;
    };
    if (module.exports) exports = module.exports = EXIF;
    exports.EXIF = EXIF;
    var ExifTags = EXIF.Tags = {
        // version tags
        0x9000: "ExifVersion",
        0xA000: "FlashpixVersion",
        // colorspace tags
        0xA001: "ColorSpace",
        // image configuration
        0xA002: "PixelXDimension",
        0xA003: "PixelYDimension",
        0x9101: "ComponentsConfiguration",
        0x9102: "CompressedBitsPerPixel",
        // user information
        0x927C: "MakerNote",
        0x9286: "UserComment",
        // related file
        0xA004: "RelatedSoundFile",
        // date and time
        0x9003: "DateTimeOriginal",
        0x9004: "DateTimeDigitized",
        0x9290: "SubsecTime",
        0x9291: "SubsecTimeOriginal",
        0x9292: "SubsecTimeDigitized",
        // picture-taking conditions
        0x829A: "ExposureTime",
        0x829D: "FNumber",
        0x8822: "ExposureProgram",
        0x8824: "SpectralSensitivity",
        0x8827: "ISOSpeedRatings",
        0x8828: "OECF",
        0x9201: "ShutterSpeedValue",
        0x9202: "ApertureValue",
        0x9203: "BrightnessValue",
        0x9204: "ExposureBias",
        0x9205: "MaxApertureValue",
        0x9206: "SubjectDistance",
        0x9207: "MeteringMode",
        0x9208: "LightSource",
        0x9209: "Flash",
        0x9214: "SubjectArea",
        0x920A: "FocalLength",
        0xA20B: "FlashEnergy",
        0xA20C: "SpatialFrequencyResponse",
        0xA20E: "FocalPlaneXResolution",
        0xA20F: "FocalPlaneYResolution",
        0xA210: "FocalPlaneResolutionUnit",
        0xA214: "SubjectLocation",
        0xA215: "ExposureIndex",
        0xA217: "SensingMethod",
        0xA300: "FileSource",
        0xA301: "SceneType",
        0xA302: "CFAPattern",
        0xA401: "CustomRendered",
        0xA402: "ExposureMode",
        0xA403: "WhiteBalance",
        0xA404: "DigitalZoomRation",
        0xA405: "FocalLengthIn35mmFilm",
        0xA406: "SceneCaptureType",
        0xA407: "GainControl",
        0xA408: "Contrast",
        0xA409: "Saturation",
        0xA40A: "Sharpness",
        0xA40B: "DeviceSettingDescription",
        0xA40C: "SubjectDistanceRange",
        // other tags
        0xA005: "InteroperabilityIFDPointer",
        0xA420: "ImageUniqueID" // Identifier assigned uniquely to each image
    };
    var TiffTags = EXIF.TiffTags = {
        0x0100: "ImageWidth",
        0x0101: "ImageHeight",
        0x8769: "ExifIFDPointer",
        0x8825: "GPSInfoIFDPointer",
        0xA005: "InteroperabilityIFDPointer",
        0x0102: "BitsPerSample",
        0x0103: "Compression",
        0x0106: "PhotometricInterpretation",
        0x0112: "Orientation",
        0x0115: "SamplesPerPixel",
        0x011C: "PlanarConfiguration",
        0x0212: "YCbCrSubSampling",
        0x0213: "YCbCrPositioning",
        0x011A: "XResolution",
        0x011B: "YResolution",
        0x0128: "ResolutionUnit",
        0x0111: "StripOffsets",
        0x0116: "RowsPerStrip",
        0x0117: "StripByteCounts",
        0x0201: "JPEGInterchangeFormat",
        0x0202: "JPEGInterchangeFormatLength",
        0x012D: "TransferFunction",
        0x013E: "WhitePoint",
        0x013F: "PrimaryChromaticities",
        0x0211: "YCbCrCoefficients",
        0x0214: "ReferenceBlackWhite",
        0x0132: "DateTime",
        0x010E: "ImageDescription",
        0x010F: "Make",
        0x0110: "Model",
        0x0131: "Software",
        0x013B: "Artist",
        0x8298: "Copyright"
    };
    var GPSTags = EXIF.GPSTags = {
        0x0000: "GPSVersionID",
        0x0001: "GPSLatitudeRef",
        0x0002: "GPSLatitude",
        0x0003: "GPSLongitudeRef",
        0x0004: "GPSLongitude",
        0x0005: "GPSAltitudeRef",
        0x0006: "GPSAltitude",
        0x0007: "GPSTimeStamp",
        0x0008: "GPSSatellites",
        0x0009: "GPSStatus",
        0x000A: "GPSMeasureMode",
        0x000B: "GPSDOP",
        0x000C: "GPSSpeedRef",
        0x000D: "GPSSpeed",
        0x000E: "GPSTrackRef",
        0x000F: "GPSTrack",
        0x0010: "GPSImgDirectionRef",
        0x0011: "GPSImgDirection",
        0x0012: "GPSMapDatum",
        0x0013: "GPSDestLatitudeRef",
        0x0014: "GPSDestLatitude",
        0x0015: "GPSDestLongitudeRef",
        0x0016: "GPSDestLongitude",
        0x0017: "GPSDestBearingRef",
        0x0018: "GPSDestBearing",
        0x0019: "GPSDestDistanceRef",
        0x001A: "GPSDestDistance",
        0x001B: "GPSProcessingMethod",
        0x001C: "GPSAreaInformation",
        0x001D: "GPSDateStamp",
        0x001E: "GPSDifferential"
    };
    // EXIF 2.3 Spec
    var IFD1Tags = EXIF.IFD1Tags = {
        0x0100: "ImageWidth",
        0x0101: "ImageHeight",
        0x0102: "BitsPerSample",
        0x0103: "Compression",
        0x0106: "PhotometricInterpretation",
        0x0111: "StripOffsets",
        0x0112: "Orientation",
        0x0115: "SamplesPerPixel",
        0x0116: "RowsPerStrip",
        0x0117: "StripByteCounts",
        0x011A: "XResolution",
        0x011B: "YResolution",
        0x011C: "PlanarConfiguration",
        0x0128: "ResolutionUnit",
        0x0201: "JpegIFOffset",
        0x0202: "JpegIFByteCount",
        0x0211: "YCbCrCoefficients",
        0x0212: "YCbCrSubSampling",
        0x0213: "YCbCrPositioning",
        0x0214: "ReferenceBlackWhite"
    };
    var StringValues = EXIF.StringValues = {
        ExposureProgram: {
            0: "Not defined",
            1: "Manual",
            2: "Normal program",
            3: "Aperture priority",
            4: "Shutter priority",
            5: "Creative program",
            6: "Action program",
            7: "Portrait mode",
            8: "Landscape mode"
        },
        MeteringMode: {
            0: "Unknown",
            1: "Average",
            2: "CenterWeightedAverage",
            3: "Spot",
            4: "MultiSpot",
            5: "Pattern",
            6: "Partial",
            255: "Other"
        },
        LightSource: {
            0: "Unknown",
            1: "Daylight",
            2: "Fluorescent",
            3: "Tungsten (incandescent light)",
            4: "Flash",
            9: "Fine weather",
            10: "Cloudy weather",
            11: "Shade",
            12: "Daylight fluorescent (D 5700 - 7100K)",
            13: "Day white fluorescent (N 4600 - 5400K)",
            14: "Cool white fluorescent (W 3900 - 4500K)",
            15: "White fluorescent (WW 3200 - 3700K)",
            17: "Standard light A",
            18: "Standard light B",
            19: "Standard light C",
            20: "D55",
            21: "D65",
            22: "D75",
            23: "D50",
            24: "ISO studio tungsten",
            255: "Other"
        },
        Flash: {
            0x0000: "Flash did not fire",
            0x0001: "Flash fired",
            0x0005: "Strobe return light not detected",
            0x0007: "Strobe return light detected",
            0x0009: "Flash fired, compulsory flash mode",
            0x000D: "Flash fired, compulsory flash mode, return light not detected",
            0x000F: "Flash fired, compulsory flash mode, return light detected",
            0x0010: "Flash did not fire, compulsory flash mode",
            0x0018: "Flash did not fire, auto mode",
            0x0019: "Flash fired, auto mode",
            0x001D: "Flash fired, auto mode, return light not detected",
            0x001F: "Flash fired, auto mode, return light detected",
            0x0020: "No flash function",
            0x0041: "Flash fired, red-eye reduction mode",
            0x0045: "Flash fired, red-eye reduction mode, return light not detected",
            0x0047: "Flash fired, red-eye reduction mode, return light detected",
            0x0049: "Flash fired, compulsory flash mode, red-eye reduction mode",
            0x004D: "Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected",
            0x004F: "Flash fired, compulsory flash mode, red-eye reduction mode, return light detected",
            0x0059: "Flash fired, auto mode, red-eye reduction mode",
            0x005D: "Flash fired, auto mode, return light not detected, red-eye reduction mode",
            0x005F: "Flash fired, auto mode, return light detected, red-eye reduction mode"
        },
        SensingMethod: {
            1: "Not defined",
            2: "One-chip color area sensor",
            3: "Two-chip color area sensor",
            4: "Three-chip color area sensor",
            5: "Color sequential area sensor",
            7: "Trilinear sensor",
            8: "Color sequential linear sensor"
        },
        SceneCaptureType: {
            0: "Standard",
            1: "Landscape",
            2: "Portrait",
            3: "Night scene"
        },
        SceneType: {
            1: "Directly photographed"
        },
        CustomRendered: {
            0: "Normal process",
            1: "Custom process"
        },
        WhiteBalance: {
            0: "Auto white balance",
            1: "Manual white balance"
        },
        GainControl: {
            0: "None",
            1: "Low gain up",
            2: "High gain up",
            3: "Low gain down",
            4: "High gain down"
        },
        Contrast: {
            0: "Normal",
            1: "Soft",
            2: "Hard"
        },
        Saturation: {
            0: "Normal",
            1: "Low saturation",
            2: "High saturation"
        },
        Sharpness: {
            0: "Normal",
            1: "Soft",
            2: "Hard"
        },
        SubjectDistanceRange: {
            0: "Unknown",
            1: "Macro",
            2: "Close view",
            3: "Distant view"
        },
        FileSource: {
            3: "DSC"
        },
        Components: {
            0: "",
            1: "Y",
            2: "Cb",
            3: "Cr",
            4: "R",
            5: "G",
            6: "B"
        }
    };
    function addEvent(element, event, handler) {
        if (element.addEventListener) element.addEventListener(event, handler, false);
        else if (element.attachEvent) element.attachEvent("on" + event, handler);
    }
    function imageHasData(img) {
        return !!img.exifdata;
    }
    function base64ToArrayBuffer(base64, contentType) {
        contentType = contentType || base64.match(/^data\:([^\;]+)\;base64,/mi)[1] || ''; // e.g. 'data:image/jpeg;base64,...' => 'image/jpeg'
        base64 = base64.replace(/^data\:([^\;]+)\;base64,/gmi, '');
        var binary = atob(base64);
        var len = binary.length;
        var buffer = new ArrayBuffer(len);
        var view = new Uint8Array(buffer);
        for(var i = 0; i < len; i++)view[i] = binary.charCodeAt(i);
        return buffer;
    }
    function objectURLToBlob(url, callback) {
        var http = new XMLHttpRequest();
        http.open("GET", url, true);
        http.responseType = "blob";
        http.onload = function(e) {
            if (this.status == 200 || this.status === 0) callback(this.response);
        };
        http.send();
    }
    function getImageData(img, callback) {
        function handleBinaryFile(binFile) {
            var data = findEXIFinJPEG(binFile);
            img.exifdata = data || {};
            var iptcdata = findIPTCinJPEG(binFile);
            img.iptcdata = iptcdata || {};
            if (EXIF.isXmpEnabled) {
                var xmpdata = findXMPinJPEG(binFile);
                img.xmpdata = xmpdata || {};
            }
            if (callback) callback.call(img);
        }
        if (img.src) {
            if (/^data\:/i.test(img.src)) {
                var arrayBuffer = base64ToArrayBuffer(img.src);
                handleBinaryFile(arrayBuffer);
            } else if (/^blob\:/i.test(img.src)) {
                var fileReader = new FileReader();
                fileReader.onload = function(e) {
                    handleBinaryFile(e.target.result);
                };
                objectURLToBlob(img.src, function(blob) {
                    fileReader.readAsArrayBuffer(blob);
                });
            } else {
                var http = new XMLHttpRequest();
                http.onload = function() {
                    if (this.status == 200 || this.status === 0) handleBinaryFile(http.response);
                    else throw "Could not load image";
                    http = null;
                };
                http.open("GET", img.src, true);
                http.responseType = "arraybuffer";
                http.send(null);
            }
        } else if (self.FileReader && (img instanceof self.Blob || img instanceof self.File)) {
            var fileReader = new FileReader();
            fileReader.onload = function(e) {
                if (debug) console.log("Got file of length " + e.target.result.byteLength);
                handleBinaryFile(e.target.result);
            };
            fileReader.readAsArrayBuffer(img);
        }
    }
    function findEXIFinJPEG(file) {
        var dataView = new DataView(file);
        if (debug) console.log("Got file of length " + file.byteLength);
        if (dataView.getUint8(0) != 0xFF || dataView.getUint8(1) != 0xD8) {
            if (debug) console.log("Not a valid JPEG");
            return false; // not a valid jpeg
        }
        var offset = 2, length = file.byteLength, marker;
        while(offset < length){
            if (dataView.getUint8(offset) != 0xFF) {
                if (debug) console.log("Not a valid marker at offset " + offset + ", found: " + dataView.getUint8(offset));
                return false; // not a valid marker, something is wrong
            }
            marker = dataView.getUint8(offset + 1);
            if (debug) console.log(marker);
            // we could implement handling for other markers here,
            // but we're only looking for 0xFFE1 for EXIF data
            if (marker == 225) {
                if (debug) console.log("Found 0xFFE1 marker");
                return readEXIFData(dataView, offset + 4, dataView.getUint16(offset + 2) - 2);
            // offset += 2 + file.getShortAt(offset+2, true);
            } else offset += 2 + dataView.getUint16(offset + 2);
        }
    }
    function findIPTCinJPEG(file) {
        var dataView = new DataView(file);
        if (debug) console.log("Got file of length " + file.byteLength);
        if (dataView.getUint8(0) != 0xFF || dataView.getUint8(1) != 0xD8) {
            if (debug) console.log("Not a valid JPEG");
            return false; // not a valid jpeg
        }
        var offset = 2, length = file.byteLength;
        var isFieldSegmentStart = function(dataView, offset) {
            return dataView.getUint8(offset) === 0x38 && dataView.getUint8(offset + 1) === 0x42 && dataView.getUint8(offset + 2) === 0x49 && dataView.getUint8(offset + 3) === 0x4D && dataView.getUint8(offset + 4) === 0x04 && dataView.getUint8(offset + 5) === 0x04;
        };
        while(offset < length){
            if (isFieldSegmentStart(dataView, offset)) {
                // Get the length of the name header (which is padded to an even number of bytes)
                var nameHeaderLength = dataView.getUint8(offset + 7);
                if (nameHeaderLength % 2 !== 0) nameHeaderLength += 1;
                // Check for pre photoshop 6 format
                if (nameHeaderLength === 0) // Always 4
                nameHeaderLength = 4;
                var startOffset = offset + 8 + nameHeaderLength;
                var sectionLength = dataView.getUint16(offset + 6 + nameHeaderLength);
                return readIPTCData(file, startOffset, sectionLength);
            }
            // Not the marker, continue searching
            offset++;
        }
    }
    var IptcFieldMap = {
        0x78: 'caption',
        0x6E: 'credit',
        0x19: 'keywords',
        0x37: 'dateCreated',
        0x50: 'byline',
        0x55: 'bylineTitle',
        0x7A: 'captionWriter',
        0x69: 'headline',
        0x74: 'copyright',
        0x0F: 'category'
    };
    function readIPTCData(file, startOffset, sectionLength) {
        var dataView = new DataView(file);
        var data = {};
        var fieldValue, fieldName, dataSize, segmentType, segmentSize;
        var segmentStartPos = startOffset;
        while(segmentStartPos < startOffset + sectionLength){
            if (dataView.getUint8(segmentStartPos) === 0x1C && dataView.getUint8(segmentStartPos + 1) === 0x02) {
                segmentType = dataView.getUint8(segmentStartPos + 2);
                if (segmentType in IptcFieldMap) {
                    dataSize = dataView.getInt16(segmentStartPos + 3);
                    segmentSize = dataSize + 5;
                    fieldName = IptcFieldMap[segmentType];
                    fieldValue = getStringFromDB(dataView, segmentStartPos + 5, dataSize);
                    // Check if we already stored a value with this name
                    if (data.hasOwnProperty(fieldName)) {
                        // Value already stored with this name, create multivalue field
                        if (data[fieldName] instanceof Array) data[fieldName].push(fieldValue);
                        else data[fieldName] = [
                            data[fieldName],
                            fieldValue
                        ];
                    } else data[fieldName] = fieldValue;
                }
            }
            segmentStartPos++;
        }
        return data;
    }
    function readTags(file, tiffStart, dirStart, strings, bigEnd) {
        var entries = file.getUint16(dirStart, !bigEnd), tags = {}, entryOffset, tag, i;
        for(i = 0; i < entries; i++){
            entryOffset = dirStart + i * 12 + 2;
            tag = strings[file.getUint16(entryOffset, !bigEnd)];
            if (!tag && debug) console.log("Unknown tag: " + file.getUint16(entryOffset, !bigEnd));
            tags[tag] = readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd);
        }
        return tags;
    }
    function readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd) {
        var type = file.getUint16(entryOffset + 2, !bigEnd), numValues = file.getUint32(entryOffset + 4, !bigEnd), valueOffset = file.getUint32(entryOffset + 8, !bigEnd) + tiffStart, offset, vals, val, n, numerator, denominator;
        switch(type){
            case 1:
            case 7:
                if (numValues == 1) return file.getUint8(entryOffset + 8, !bigEnd);
                else {
                    offset = numValues > 4 ? valueOffset : entryOffset + 8;
                    vals = [];
                    for(n = 0; n < numValues; n++)vals[n] = file.getUint8(offset + n);
                    return vals;
                }
            case 2:
                offset = numValues > 4 ? valueOffset : entryOffset + 8;
                return getStringFromDB(file, offset, numValues - 1);
            case 3:
                if (numValues == 1) return file.getUint16(entryOffset + 8, !bigEnd);
                else {
                    offset = numValues > 2 ? valueOffset : entryOffset + 8;
                    vals = [];
                    for(n = 0; n < numValues; n++)vals[n] = file.getUint16(offset + 2 * n, !bigEnd);
                    return vals;
                }
            case 4:
                if (numValues == 1) return file.getUint32(entryOffset + 8, !bigEnd);
                else {
                    vals = [];
                    for(n = 0; n < numValues; n++)vals[n] = file.getUint32(valueOffset + 4 * n, !bigEnd);
                    return vals;
                }
            case 5:
                if (numValues == 1) {
                    numerator = file.getUint32(valueOffset, !bigEnd);
                    denominator = file.getUint32(valueOffset + 4, !bigEnd);
                    val = new Number(numerator / denominator);
                    val.numerator = numerator;
                    val.denominator = denominator;
                    return val;
                } else {
                    vals = [];
                    for(n = 0; n < numValues; n++){
                        numerator = file.getUint32(valueOffset + 8 * n, !bigEnd);
                        denominator = file.getUint32(valueOffset + 4 + 8 * n, !bigEnd);
                        vals[n] = new Number(numerator / denominator);
                        vals[n].numerator = numerator;
                        vals[n].denominator = denominator;
                    }
                    return vals;
                }
            case 9:
                if (numValues == 1) return file.getInt32(entryOffset + 8, !bigEnd);
                else {
                    vals = [];
                    for(n = 0; n < numValues; n++)vals[n] = file.getInt32(valueOffset + 4 * n, !bigEnd);
                    return vals;
                }
            case 10:
                if (numValues == 1) return file.getInt32(valueOffset, !bigEnd) / file.getInt32(valueOffset + 4, !bigEnd);
                else {
                    vals = [];
                    for(n = 0; n < numValues; n++)vals[n] = file.getInt32(valueOffset + 8 * n, !bigEnd) / file.getInt32(valueOffset + 4 + 8 * n, !bigEnd);
                    return vals;
                }
        }
    }
    /**
	 * Given an IFD (Image File Directory) start offset
	 * returns an offset to next IFD or 0 if it's the last IFD.
	 */ function getNextIFDOffset(dataView, dirStart, bigEnd) {
        //the first 2bytes means the number of directory entries contains in this IFD
        var entries = dataView.getUint16(dirStart, !bigEnd);
        // After last directory entry, there is a 4bytes of data,
        // it means an offset to next IFD.
        // If its value is '0x00000000', it means this is the last IFD and there is no linked IFD.
        return dataView.getUint32(dirStart + 2 + entries * 12, !bigEnd); // each entry is 12 bytes long
    }
    function readThumbnailImage(dataView, tiffStart, firstIFDOffset, bigEnd) {
        // get the IFD1 offset
        var IFD1OffsetPointer = getNextIFDOffset(dataView, tiffStart + firstIFDOffset, bigEnd);
        if (!IFD1OffsetPointer) // console.log('******** IFD1Offset is empty, image thumb not found ********');
        return {};
        else if (IFD1OffsetPointer > dataView.byteLength) // console.log('******** IFD1Offset is outside the bounds of the DataView ********');
        return {};
        // console.log('*******  thumbnail IFD offset (IFD1) is: %s', IFD1OffsetPointer);
        var thumbTags = readTags(dataView, tiffStart, tiffStart + IFD1OffsetPointer, IFD1Tags, bigEnd);
        // EXIF 2.3 specification for JPEG format thumbnail
        // If the value of Compression(0x0103) Tag in IFD1 is '6', thumbnail image format is JPEG.
        // Most of Exif image uses JPEG format for thumbnail. In that case, you can get offset of thumbnail
        // by JpegIFOffset(0x0201) Tag in IFD1, size of thumbnail by JpegIFByteCount(0x0202) Tag.
        // Data format is ordinary JPEG format, starts from 0xFFD8 and ends by 0xFFD9. It seems that
        // JPEG format and 160x120pixels of size are recommended thumbnail format for Exif2.1 or later.
        if (thumbTags['Compression']) // console.log('Thumbnail image found!');
        switch(thumbTags['Compression']){
            case 6:
                // console.log('Thumbnail image format is JPEG');
                if (thumbTags.JpegIFOffset && thumbTags.JpegIFByteCount) {
                    // extract the thumbnail
                    var tOffset = tiffStart + thumbTags.JpegIFOffset;
                    var tLength = thumbTags.JpegIFByteCount;
                    thumbTags['blob'] = new Blob([
                        new Uint8Array(dataView.buffer, tOffset, tLength)
                    ], {
                        type: 'image/jpeg'
                    });
                }
                break;
            case 1:
                console.log("Thumbnail image format is TIFF, which is not implemented.");
                break;
            default:
                console.log("Unknown thumbnail image format '%s'", thumbTags['Compression']);
        }
        else if (thumbTags['PhotometricInterpretation'] == 2) console.log("Thumbnail image format is RGB, which is not implemented.");
        return thumbTags;
    }
    function getStringFromDB(buffer, start, length) {
        var outstr = "";
        for(var n = start; n < start + length; n++)outstr += String.fromCharCode(buffer.getUint8(n));
        return outstr;
    }
    function readEXIFData(file, start) {
        if (getStringFromDB(file, start, 4) != "Exif") {
            if (debug) console.log("Not valid EXIF data! " + getStringFromDB(file, start, 4));
            return false;
        }
        var bigEnd, tags, tag, exifData, gpsData, tiffOffset = start + 6;
        // test for TIFF validity and endianness
        if (file.getUint16(tiffOffset) == 0x4949) bigEnd = false;
        else if (file.getUint16(tiffOffset) == 0x4D4D) bigEnd = true;
        else {
            if (debug) console.log("Not valid TIFF data! (no 0x4949 or 0x4D4D)");
            return false;
        }
        if (file.getUint16(tiffOffset + 2, !bigEnd) != 0x002A) {
            if (debug) console.log("Not valid TIFF data! (no 0x002A)");
            return false;
        }
        var firstIFDOffset = file.getUint32(tiffOffset + 4, !bigEnd);
        if (firstIFDOffset < 0x00000008) {
            if (debug) console.log("Not valid TIFF data! (First offset less than 8)", file.getUint32(tiffOffset + 4, !bigEnd));
            return false;
        }
        tags = readTags(file, tiffOffset, tiffOffset + firstIFDOffset, TiffTags, bigEnd);
        if (tags.ExifIFDPointer) {
            exifData = readTags(file, tiffOffset, tiffOffset + tags.ExifIFDPointer, ExifTags, bigEnd);
            for(tag in exifData){
                switch(tag){
                    case "LightSource":
                    case "Flash":
                    case "MeteringMode":
                    case "ExposureProgram":
                    case "SensingMethod":
                    case "SceneCaptureType":
                    case "SceneType":
                    case "CustomRendered":
                    case "WhiteBalance":
                    case "GainControl":
                    case "Contrast":
                    case "Saturation":
                    case "Sharpness":
                    case "SubjectDistanceRange":
                    case "FileSource":
                        exifData[tag] = StringValues[tag][exifData[tag]];
                        break;
                    case "ExifVersion":
                    case "FlashpixVersion":
                        exifData[tag] = String.fromCharCode(exifData[tag][0], exifData[tag][1], exifData[tag][2], exifData[tag][3]);
                        break;
                    case "ComponentsConfiguration":
                        exifData[tag] = StringValues.Components[exifData[tag][0]] + StringValues.Components[exifData[tag][1]] + StringValues.Components[exifData[tag][2]] + StringValues.Components[exifData[tag][3]];
                        break;
                }
                tags[tag] = exifData[tag];
            }
        }
        if (tags.GPSInfoIFDPointer) {
            gpsData = readTags(file, tiffOffset, tiffOffset + tags.GPSInfoIFDPointer, GPSTags, bigEnd);
            for(tag in gpsData){
                switch(tag){
                    case "GPSVersionID":
                        gpsData[tag] = gpsData[tag][0] + "." + gpsData[tag][1] + "." + gpsData[tag][2] + "." + gpsData[tag][3];
                        break;
                }
                tags[tag] = gpsData[tag];
            }
        }
        // extract thumbnail
        tags['thumbnail'] = readThumbnailImage(file, tiffOffset, firstIFDOffset, bigEnd);
        return tags;
    }
    function findXMPinJPEG(file) {
        if (!('DOMParser' in self)) // console.warn('XML parsing not supported without DOMParser');
        return;
        var dataView = new DataView(file);
        if (debug) console.log("Got file of length " + file.byteLength);
        if (dataView.getUint8(0) != 0xFF || dataView.getUint8(1) != 0xD8) {
            if (debug) console.log("Not a valid JPEG");
            return false; // not a valid jpeg
        }
        var offset = 2, length = file.byteLength, dom = new DOMParser();
        while(offset < length - 4)if (getStringFromDB(dataView, offset, 4) == "http") {
            var startOffset = offset - 1;
            var sectionLength = dataView.getUint16(offset - 2) - 1;
            var xmpString = getStringFromDB(dataView, startOffset, sectionLength);
            var xmpEndIndex = xmpString.indexOf('xmpmeta>') + 8;
            xmpString = xmpString.substring(xmpString.indexOf('<x:xmpmeta'), xmpEndIndex);
            var indexOfXmp = xmpString.indexOf('x:xmpmeta') + 10;
            //Many custom written programs embed xmp/xml without any namespace. Following are some of them.
            //Without these namespaces, XML is thought to be invalid by parsers
            xmpString = xmpString.slice(0, indexOfXmp) + 'xmlns:Iptc4xmpCore="http://iptc.org/std/Iptc4xmpCore/1.0/xmlns/" ' + 'xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" ' + 'xmlns:tiff="http://ns.adobe.com/tiff/1.0/" ' + 'xmlns:plus="http://schemas.android.com/apk/lib/com.google.android.gms.plus" ' + 'xmlns:ext="http://www.gettyimages.com/xsltExtension/1.0" ' + 'xmlns:exif="http://ns.adobe.com/exif/1.0/" ' + 'xmlns:stEvt="http://ns.adobe.com/xap/1.0/sType/ResourceEvent#" ' + 'xmlns:stRef="http://ns.adobe.com/xap/1.0/sType/ResourceRef#" ' + 'xmlns:crs="http://ns.adobe.com/camera-raw-settings/1.0/" ' + 'xmlns:xapGImg="http://ns.adobe.com/xap/1.0/g/img/" ' + 'xmlns:Iptc4xmpExt="http://iptc.org/std/Iptc4xmpExt/2008-02-29/" ' + xmpString.slice(indexOfXmp);
            var domDocument = dom.parseFromString(xmpString, 'text/xml');
            return xml2Object(domDocument);
        } else offset++;
    }
    function xml2json(xml) {
        var json = {};
        if (xml.nodeType == 1) {
            if (xml.attributes.length > 0) {
                json['@attributes'] = {};
                for(var j = 0; j < xml.attributes.length; j++){
                    var attribute = xml.attributes.item(j);
                    json['@attributes'][attribute.nodeName] = attribute.nodeValue;
                }
            }
        } else if (xml.nodeType == 3) return xml.nodeValue;
        // deal with children
        if (xml.hasChildNodes()) for(var i = 0; i < xml.childNodes.length; i++){
            var child = xml.childNodes.item(i);
            var nodeName = child.nodeName;
            if (json[nodeName] == null) json[nodeName] = xml2json(child);
            else {
                if (json[nodeName].push == null) {
                    var old = json[nodeName];
                    json[nodeName] = [];
                    json[nodeName].push(old);
                }
                json[nodeName].push(xml2json(child));
            }
        }
        return json;
    }
    function xml2Object(xml) {
        try {
            var obj = {};
            if (xml.children.length > 0) for(var i = 0; i < xml.children.length; i++){
                var item = xml.children.item(i);
                var attributes = item.attributes;
                for(var idx in attributes){
                    var itemAtt = attributes[idx];
                    var dataKey = itemAtt.nodeName;
                    var dataValue = itemAtt.nodeValue;
                    if (dataKey !== undefined) obj[dataKey] = dataValue;
                }
                var nodeName = item.nodeName;
                if (typeof obj[nodeName] === "undefined") obj[nodeName] = xml2json(item);
                else {
                    if (typeof obj[nodeName].push === "undefined") {
                        var old = obj[nodeName];
                        obj[nodeName] = [];
                        obj[nodeName].push(old);
                    }
                    obj[nodeName].push(xml2json(item));
                }
            }
            else obj = xml.textContent;
            return obj;
        } catch (e) {
            console.log(e.message);
        }
    }
    EXIF.enableXmp = function() {
        EXIF.isXmpEnabled = true;
    };
    EXIF.disableXmp = function() {
        EXIF.isXmpEnabled = false;
    };
    EXIF.getData = function(img, callback) {
        if ((self.Image && img instanceof self.Image || self.HTMLImageElement && img instanceof self.HTMLImageElement) && !img.complete) return false;
        if (!imageHasData(img)) getImageData(img, callback);
        else if (callback) callback.call(img);
        return true;
    };
    EXIF.getTag = function(img, tag) {
        if (!imageHasData(img)) return;
        return img.exifdata[tag];
    };
    EXIF.getIptcTag = function(img, tag) {
        if (!imageHasData(img)) return;
        return img.iptcdata[tag];
    };
    EXIF.getAllTags = function(img) {
        if (!imageHasData(img)) return {};
        var a, data = img.exifdata, tags = {};
        for(a in data)if (data.hasOwnProperty(a)) tags[a] = data[a];
        return tags;
    };
    EXIF.getAllIptcTags = function(img) {
        if (!imageHasData(img)) return {};
        var a, data = img.iptcdata, tags = {};
        for(a in data)if (data.hasOwnProperty(a)) tags[a] = data[a];
        return tags;
    };
    EXIF.pretty = function(img) {
        if (!imageHasData(img)) return "";
        var a, data = img.exifdata, strPretty = "";
        for(a in data)if (data.hasOwnProperty(a)) {
            if (typeof data[a] === "object") {
                if (data[a] instanceof Number) strPretty += a + " : " + data[a] + " [" + data[a].numerator + "/" + data[a].denominator + "]\r\n";
                else strPretty += a + " : [" + data[a].length + " values]\r\n";
            } else strPretty += a + " : " + data[a] + "\r\n";
        }
        return strPretty;
    };
    EXIF.readFromBinaryFile = function(file) {
        return findEXIFinJPEG(file);
    };
    if (typeof define === 'function' && define.amd) define('exif-js', [], function() {
        return EXIF;
    });
}).call(this);

});


parcelRegister("af8Hs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01ecada40b62365b$export$2e2bcd8739ae039; });
class $01ecada40b62365b$export$2e2bcd8739ae039 extends HTMLElement {
    connectedCallback() {}
    async startPhotoUpload(photo, photoDescription) {
        try {
            this.#show();
            this.#trackUploadProcessStarted();
            await this.#post(photo, photoDescription);
            this.#trackUploadProcessFinished();
            this.#handleSuccess();
            this.#hide();
        } catch (error) {
            if (error.type === 'max_photos_reached') this.dispatchEvent(new CustomEvent('pegPhotoUploader:maxPhotosReached', {
                detail: error.error,
                bubbles: true
            }));
            else this.dispatchEvent(new CustomEvent('pegPhotoUploader:uploadFailed', {
                detail: error.error,
                bubbles: true
            }));
        }
    }
    #handleSuccess() {
        this.dispatchEvent(new CustomEvent('pegPhotoUploader:uploadSuccess', {
            bubbles: true
        }));
    }
    #show() {
        this.removeAttribute('hidden');
    }
    #hide() {
        this.setAttribute('hidden', '');
    }
    async #post(photo, photoDescription) {
        const uploadProgressBar = this.querySelector('#uploadProgressBar');
        const csrfToken = jPar.wdk.security.csrf.getToken();
        const creationDate = this.closest('peg-photo-selector')?.creationDate || '';
        const formData = new FormData();
        formData.append('file', photo, 'image.jpeg');
        formData.append('caption', photoDescription);
        formData.append('creationDate', creationDate);
        return new Promise((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            uploadProgressBar.setAttribute('aria-live', 'assertive');
            uploadProgressBar.setAttribute('aria-busy', 'true');
            uploadProgressBar.setAttribute('aria-atomic', 'true');
            xhr.upload.addEventListener('progress', (event)=>{
                const { lengthComputable: lengthComputable, loaded: loaded, total: total } = event;
                if (lengthComputable) {
                    const percentage = loaded / total * 100;
                    uploadProgressBar.value = percentage;
                    uploadProgressBar.setAttribute('aria-valuenow', percentage);
                }
            });
            xhr.addEventListener('loadend', ()=>{
                uploadProgressBar.setAttribute('aria-busy', 'false');
                if (xhr.readyState === XMLHttpRequest.DONE) {
                    if (xhr.status === 200) {
                        resolve();
                        return;
                    }
                    uploadProgressBar.value = 0;
                    uploadProgressBar.removeAttribute('aria-valuenow');
                    this.#hide();
                    if (xhr.responseText?.includes('Maximum number of photos reached')) reject({
                        error: new Error('Maximum number of photos reached'),
                        type: 'max_photos_reached'
                    });
                    else reject({
                        error: new Error(`server error:${xhr.status}`),
                        type: '500'
                    });
                }
            });
            xhr.open('POST', '/photos', true);
            xhr.setRequestHeader('x-csrf-token', csrfToken);
            xhr.send(formData);
        });
    }
    #trackUploadProcessStarted() {
        jPar.util.log.bigData({
            category: this.getAttribute('tracking-category'),
            subcategory: this.getAttribute('tracking-subcategory'),
            targetId: 'button_upload',
            action: 'upload_started'
        });
    }
    #trackUploadProcessFinished() {
        jPar.util.log.bigData({
            category: this.getAttribute('tracking-category'),
            subcategory: this.getAttribute('tracking-subcategory'),
            action: 'upload_finished'
        });
    }
}

});

parcelRegister("1fstn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e8d473ff5ba5320$export$2e2bcd8739ae039; });

var $6hlOn = parcelRequire("6hlOn");
class $0e8d473ff5ba5320$export$2e2bcd8739ae039 extends HTMLElement {
    //TODO:is this still needed?
    constructor(){
        super();
        this.cropper = null;
        this.abortController = null;
    }
    connectedCallback() {
        this.abortController = new AbortController();
    }
    disconnectedCallback() {
        this.destroyCropper();
        this.abortController.abort();
    }
    startCropper(photo) {
        this.initCropperPlugin(photo);
        const signal = this.abortController.signal;
        document.body.addEventListener('keydown', (event1)=>this.onArrowKeys(event1.code), {
            signal: signal
        });
        this.querySelector('#rotateLeft').addEventListener('click', ()=>this.cropper.rotate(-90), {
            signal: signal
        });
        this.querySelector('#rotateRight').addEventListener('click', ()=>this.cropper.rotate(90), {
            signal: signal
        });
        this.querySelector('#zoomPlus').addEventListener('click', ()=>this.cropper.zoom(0.1), {
            signal: signal
        });
        this.querySelector('#zoomMinus').addEventListener('click', ()=>this.cropper.zoom(-0.1), {
            signal: signal
        });
    }
    destroyCropper() {
        this.cropper?.destroy();
        this.querySelector('#imageContainer img')?.remove();
    }
    initCropperPlugin(photo) {
        const image = Object.assign(document.createElement('img'), {
            src: '',
            alt: ''
        });
        this.querySelector('#imageContainer').appendChild(image);
        image.onload = ()=>{
            this.cropper = new (0, $6hlOn.default)(image, {
                aspectRatio: 2 / 3,
                minCropBoxHeight: 280,
                minContainerHeight: 380,
                viewMode: 1,
                checkCrossOrigin: false,
                dragMode: 'move',
                cropBoxMovable: false,
                cropBoxResizable: false
            });
        };
        image.src = photo;
    }
    onArrowKeys(keyCode) {
        switch(keyCode){
            case 'ArrowLeft':
                event.preventDefault();
                this.cropper.move(1, 0);
                break;
            case 'ArrowUp':
                event.preventDefault();
                this.cropper.move(0, 1);
                break;
            case 'ArrowRight':
                event.preventDefault();
                this.cropper.move(-1, 0);
                break;
            case 'ArrowDown':
                event.preventDefault();
                this.cropper.move(0, -1);
                break;
        }
    }
    saveAsImage() {
        return new Promise((resolve, reject)=>{
            try {
                // do not delete following line: BUG-16950 https://github.com/fengyuanchen/cropperjs/issues/1036#issuecomment-1500289959
                this.cropper.getCroppedCanvas({
                    imageSmoothingEnabled: false,
                    maxHeight: 2880
                });
                const croppedCanvas = this.cropper.getCroppedCanvas({
                    imageSmoothingEnabled: false,
                    maxHeight: 2880
                });
                croppedCanvas.toBlob(resolve, 'image/jpeg');
            } catch (error) {
                reject(error);
            }
        });
    }
}

});
parcelRegister("6hlOn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49253feac3b9f034$export$2e2bcd8739ae039; });

var $7jQ8x = parcelRequire("7jQ8x");
window.Cropper = (0, (/*@__PURE__*/$parcel$interopDefault($7jQ8x)));
var /*!
 * jQuery Cropper v1.0.2
 * https://fengyuanchen.github.io/jquery-cropper
 *
 * Copyright 2018-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2025-03-08T08:35:16.178Z
 */ $49253feac3b9f034$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($7jQ8x)));
const $49253feac3b9f034$var$oldFunc = window.Cropper.prototype.getCroppedCanvas;
window.Cropper.prototype.getCroppedCanvas = function(...args) {
    const oldFloorFunc = Math.floor;
    let count = 0;
    Math.floor = function(num) {
        return count++ < 2 ? num : oldFloorFunc.apply(this, arguments);
    };
    const res = $49253feac3b9f034$var$oldFunc.apply(this, args);
    Math.floor = oldFloorFunc;
    return res;
};

});
parcelRegister("7jQ8x", function(module, exports) {
/*!
 * Cropper.js v1.6.2
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2024-04-21T07:43:05.335Z
 */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    function ownKeys(e, r) {
        var t = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            r && (o = o.filter(function(r) {
                return Object.getOwnPropertyDescriptor(e, r).enumerable;
            })), t.push.apply(t, o);
        }
        return t;
    }
    function _objectSpread2(e) {
        for(var r = 1; r < arguments.length; r++){
            var t = null != arguments[r] ? arguments[r] : {};
            r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
                _defineProperty(e, r, t[r]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
            });
        }
        return e;
    }
    function _toPrimitive(t, r) {
        if ("object" !== typeof t || !t) return t;
        var e = t[Symbol.toPrimitive];
        if (void 0 !== e) {
            var i = e.call(t, r || "default");
            if ("object" !== typeof i) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === r ? String : Number)(t);
    }
    function _toPropertyKey(t) {
        var i = _toPrimitive(t, "string");
        return "symbol" === typeof i ? i : i + "";
    }
    function _typeof(o) {
        "@babel/helpers - typeof";
        return _typeof = "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" === typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, _typeof(o);
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        Object.defineProperty(Constructor, "prototype", {
            writable: false
        });
        return Constructor;
    }
    function _defineProperty(obj, key, value) {
        key = _toPropertyKey(key);
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var IS_BROWSER = typeof window !== 'undefined' && typeof window.document !== 'undefined';
    var WINDOW = IS_BROWSER ? window : {};
    var IS_TOUCH_DEVICE = IS_BROWSER && WINDOW.document.documentElement ? 'ontouchstart' in WINDOW.document.documentElement : false;
    var HAS_POINTER_EVENT = IS_BROWSER ? 'PointerEvent' in WINDOW : false;
    var NAMESPACE = 'cropper';
    // Actions
    var ACTION_ALL = 'all';
    var ACTION_CROP = 'crop';
    var ACTION_MOVE = 'move';
    var ACTION_ZOOM = 'zoom';
    var ACTION_EAST = 'e';
    var ACTION_WEST = 'w';
    var ACTION_SOUTH = 's';
    var ACTION_NORTH = 'n';
    var ACTION_NORTH_EAST = 'ne';
    var ACTION_NORTH_WEST = 'nw';
    var ACTION_SOUTH_EAST = 'se';
    var ACTION_SOUTH_WEST = 'sw';
    // Classes
    var CLASS_CROP = "".concat(NAMESPACE, "-crop");
    var CLASS_DISABLED = "".concat(NAMESPACE, "-disabled");
    var CLASS_HIDDEN = "".concat(NAMESPACE, "-hidden");
    var CLASS_HIDE = "".concat(NAMESPACE, "-hide");
    var CLASS_INVISIBLE = "".concat(NAMESPACE, "-invisible");
    var CLASS_MODAL = "".concat(NAMESPACE, "-modal");
    var CLASS_MOVE = "".concat(NAMESPACE, "-move");
    // Data keys
    var DATA_ACTION = "".concat(NAMESPACE, "Action");
    var DATA_PREVIEW = "".concat(NAMESPACE, "Preview");
    // Drag modes
    var DRAG_MODE_CROP = 'crop';
    var DRAG_MODE_MOVE = 'move';
    var DRAG_MODE_NONE = 'none';
    // Events
    var EVENT_CROP = 'crop';
    var EVENT_CROP_END = 'cropend';
    var EVENT_CROP_MOVE = 'cropmove';
    var EVENT_CROP_START = 'cropstart';
    var EVENT_DBLCLICK = 'dblclick';
    var EVENT_TOUCH_START = IS_TOUCH_DEVICE ? 'touchstart' : 'mousedown';
    var EVENT_TOUCH_MOVE = IS_TOUCH_DEVICE ? 'touchmove' : 'mousemove';
    var EVENT_TOUCH_END = IS_TOUCH_DEVICE ? 'touchend touchcancel' : 'mouseup';
    var EVENT_POINTER_DOWN = HAS_POINTER_EVENT ? 'pointerdown' : EVENT_TOUCH_START;
    var EVENT_POINTER_MOVE = HAS_POINTER_EVENT ? 'pointermove' : EVENT_TOUCH_MOVE;
    var EVENT_POINTER_UP = HAS_POINTER_EVENT ? 'pointerup pointercancel' : EVENT_TOUCH_END;
    var EVENT_READY = 'ready';
    var EVENT_RESIZE = 'resize';
    var EVENT_WHEEL = 'wheel';
    var EVENT_ZOOM = 'zoom';
    // Mime types
    var MIME_TYPE_JPEG = 'image/jpeg';
    // RegExps
    var REGEXP_ACTIONS = /^e|w|s|n|se|sw|ne|nw|all|crop|move|zoom$/;
    var REGEXP_DATA_URL = /^data:/;
    var REGEXP_DATA_URL_JPEG = /^data:image\/jpeg;base64,/;
    var REGEXP_TAG_NAME = /^img|canvas$/i;
    // Misc
    // Inspired by the default width and height of a canvas element.
    var MIN_CONTAINER_WIDTH = 200;
    var MIN_CONTAINER_HEIGHT = 100;
    var DEFAULTS = {
        // Define the view mode of the cropper
        viewMode: 0,
        // 0, 1, 2, 3
        // Define the dragging mode of the cropper
        dragMode: DRAG_MODE_CROP,
        // 'crop', 'move' or 'none'
        // Define the initial aspect ratio of the crop box
        initialAspectRatio: NaN,
        // Define the aspect ratio of the crop box
        aspectRatio: NaN,
        // An object with the previous cropping result data
        data: null,
        // A selector for adding extra containers to preview
        preview: '',
        // Re-render the cropper when resize the window
        responsive: true,
        // Restore the cropped area after resize the window
        restore: true,
        // Check if the current image is a cross-origin image
        checkCrossOrigin: true,
        // Check the current image's Exif Orientation information
        checkOrientation: true,
        // Show the black modal
        modal: true,
        // Show the dashed lines for guiding
        guides: true,
        // Show the center indicator for guiding
        center: true,
        // Show the white modal to highlight the crop box
        highlight: true,
        // Show the grid background
        background: true,
        // Enable to crop the image automatically when initialize
        autoCrop: true,
        // Define the percentage of automatic cropping area when initializes
        autoCropArea: 0.8,
        // Enable to move the image
        movable: true,
        // Enable to rotate the image
        rotatable: true,
        // Enable to scale the image
        scalable: true,
        // Enable to zoom the image
        zoomable: true,
        // Enable to zoom the image by dragging touch
        zoomOnTouch: true,
        // Enable to zoom the image by wheeling mouse
        zoomOnWheel: true,
        // Define zoom ratio when zoom the image by wheeling mouse
        wheelZoomRatio: 0.1,
        // Enable to move the crop box
        cropBoxMovable: true,
        // Enable to resize the crop box
        cropBoxResizable: true,
        // Toggle drag mode between "crop" and "move" when click twice on the cropper
        toggleDragModeOnDblclick: true,
        // Size limitation
        minCanvasWidth: 0,
        minCanvasHeight: 0,
        minCropBoxWidth: 0,
        minCropBoxHeight: 0,
        minContainerWidth: MIN_CONTAINER_WIDTH,
        minContainerHeight: MIN_CONTAINER_HEIGHT,
        // Shortcuts of events
        ready: null,
        cropstart: null,
        cropmove: null,
        cropend: null,
        crop: null,
        zoom: null
    };
    var TEMPLATE = '<div class="cropper-container" touch-action="none"><div class="cropper-wrap-box"><div class="cropper-canvas"></div></div><div class="cropper-drag-box"></div><div class="cropper-crop-box"><span class="cropper-view-box"></span><span class="cropper-dashed dashed-h"></span><span class="cropper-dashed dashed-v"></span><span class="cropper-center"></span><span class="cropper-face"></span><span class="cropper-line line-e" data-cropper-action="e"></span><span class="cropper-line line-n" data-cropper-action="n"></span><span class="cropper-line line-w" data-cropper-action="w"></span><span class="cropper-line line-s" data-cropper-action="s"></span><span class="cropper-point point-e" data-cropper-action="e"></span><span class="cropper-point point-n" data-cropper-action="n"></span><span class="cropper-point point-w" data-cropper-action="w"></span><span class="cropper-point point-s" data-cropper-action="s"></span><span class="cropper-point point-ne" data-cropper-action="ne"></span><span class="cropper-point point-nw" data-cropper-action="nw"></span><span class="cropper-point point-sw" data-cropper-action="sw"></span><span class="cropper-point point-se" data-cropper-action="se"></span></div></div>';
    /**
   * Check if the given value is not a number.
   */ var isNaN = Number.isNaN || WINDOW.isNaN;
    /**
   * Check if the given value is a number.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a number, else `false`.
   */ function isNumber(value) {
        return typeof value === 'number' && !isNaN(value);
    }
    /**
   * Check if the given value is a positive number.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a positive number, else `false`.
   */ var isPositiveNumber = function isPositiveNumber(value) {
        return value > 0 && value < Infinity;
    };
    /**
   * Check if the given value is undefined.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is undefined, else `false`.
   */ function isUndefined(value) {
        return typeof value === 'undefined';
    }
    /**
   * Check if the given value is an object.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is an object, else `false`.
   */ function isObject(value) {
        return _typeof(value) === 'object' && value !== null;
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /**
   * Check if the given value is a plain object.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a plain object, else `false`.
   */ function isPlainObject(value) {
        if (!isObject(value)) return false;
        try {
            var _constructor = value.constructor;
            var prototype = _constructor.prototype;
            return _constructor && prototype && hasOwnProperty.call(prototype, 'isPrototypeOf');
        } catch (error) {
            return false;
        }
    }
    /**
   * Check if the given value is a function.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a function, else `false`.
   */ function isFunction(value) {
        return typeof value === 'function';
    }
    var slice = Array.prototype.slice;
    /**
   * Convert array-like or iterable object to an array.
   * @param {*} value - The value to convert.
   * @returns {Array} Returns a new array.
   */ function toArray(value) {
        return Array.from ? Array.from(value) : slice.call(value);
    }
    /**
   * Iterate the given data.
   * @param {*} data - The data to iterate.
   * @param {Function} callback - The process function for each element.
   * @returns {*} The original data.
   */ function forEach(data, callback) {
        if (data && isFunction(callback)) {
            if (Array.isArray(data) || isNumber(data.length)) toArray(data).forEach(function(value, key) {
                callback.call(data, value, key, data);
            });
            else if (isObject(data)) Object.keys(data).forEach(function(key) {
                callback.call(data, data[key], key, data);
            });
        }
        return data;
    }
    /**
   * Extend the given object.
   * @param {*} target - The target object to extend.
   * @param {*} args - The rest objects for merging to the target object.
   * @returns {Object} The extended object.
   */ var assign = Object.assign || function assign(target) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (isObject(target) && args.length > 0) args.forEach(function(arg) {
            if (isObject(arg)) Object.keys(arg).forEach(function(key) {
                target[key] = arg[key];
            });
        });
        return target;
    };
    var REGEXP_DECIMALS = /\.\d*(?:0|9){12}\d*$/;
    /**
   * Normalize decimal number.
   * Check out {@link https://0.30000000000000004.com/}
   * @param {number} value - The value to normalize.
   * @param {number} [times=100000000000] - The times for normalizing.
   * @returns {number} Returns the normalized number.
   */ function normalizeDecimalNumber(value) {
        var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100000000000;
        return REGEXP_DECIMALS.test(value) ? Math.round(value * times) / times : value;
    }
    var REGEXP_SUFFIX = /^width|height|left|top|marginLeft|marginTop$/;
    /**
   * Apply styles to the given element.
   * @param {Element} element - The target element.
   * @param {Object} styles - The styles for applying.
   */ function setStyle(element, styles) {
        var style = element.style;
        forEach(styles, function(value, property) {
            if (REGEXP_SUFFIX.test(property) && isNumber(value)) value = "".concat(value, "px");
            style[property] = value;
        });
    }
    /**
   * Check if the given element has a special class.
   * @param {Element} element - The element to check.
   * @param {string} value - The class to search.
   * @returns {boolean} Returns `true` if the special class was found.
   */ function hasClass(element, value) {
        return element.classList ? element.classList.contains(value) : element.className.indexOf(value) > -1;
    }
    /**
   * Add classes to the given element.
   * @param {Element} element - The target element.
   * @param {string} value - The classes to be added.
   */ function addClass(element, value) {
        if (!value) return;
        if (isNumber(element.length)) {
            forEach(element, function(elem) {
                addClass(elem, value);
            });
            return;
        }
        if (element.classList) {
            element.classList.add(value);
            return;
        }
        var className = element.className.trim();
        if (!className) element.className = value;
        else if (className.indexOf(value) < 0) element.className = "".concat(className, " ").concat(value);
    }
    /**
   * Remove classes from the given element.
   * @param {Element} element - The target element.
   * @param {string} value - The classes to be removed.
   */ function removeClass(element, value) {
        if (!value) return;
        if (isNumber(element.length)) {
            forEach(element, function(elem) {
                removeClass(elem, value);
            });
            return;
        }
        if (element.classList) {
            element.classList.remove(value);
            return;
        }
        if (element.className.indexOf(value) >= 0) element.className = element.className.replace(value, '');
    }
    /**
   * Add or remove classes from the given element.
   * @param {Element} element - The target element.
   * @param {string} value - The classes to be toggled.
   * @param {boolean} added - Add only.
   */ function toggleClass(element, value, added) {
        if (!value) return;
        if (isNumber(element.length)) {
            forEach(element, function(elem) {
                toggleClass(elem, value, added);
            });
            return;
        }
        // IE10-11 doesn't support the second parameter of `classList.toggle`
        if (added) addClass(element, value);
        else removeClass(element, value);
    }
    var REGEXP_CAMEL_CASE = /([a-z\d])([A-Z])/g;
    /**
   * Transform the given string from camelCase to kebab-case
   * @param {string} value - The value to transform.
   * @returns {string} The transformed value.
   */ function toParamCase(value) {
        return value.replace(REGEXP_CAMEL_CASE, '$1-$2').toLowerCase();
    }
    /**
   * Get data from the given element.
   * @param {Element} element - The target element.
   * @param {string} name - The data key to get.
   * @returns {string} The data value.
   */ function getData(element, name) {
        if (isObject(element[name])) return element[name];
        if (element.dataset) return element.dataset[name];
        return element.getAttribute("data-".concat(toParamCase(name)));
    }
    /**
   * Set data to the given element.
   * @param {Element} element - The target element.
   * @param {string} name - The data key to set.
   * @param {string} data - The data value.
   */ function setData(element, name, data) {
        if (isObject(data)) element[name] = data;
        else if (element.dataset) element.dataset[name] = data;
        else element.setAttribute("data-".concat(toParamCase(name)), data);
    }
    /**
   * Remove data from the given element.
   * @param {Element} element - The target element.
   * @param {string} name - The data key to remove.
   */ function removeData(element, name) {
        if (isObject(element[name])) try {
            delete element[name];
        } catch (error) {
            element[name] = undefined;
        }
        else if (element.dataset) // #128 Safari not allows to delete dataset property
        try {
            delete element.dataset[name];
        } catch (error) {
            element.dataset[name] = undefined;
        }
        else element.removeAttribute("data-".concat(toParamCase(name)));
    }
    var REGEXP_SPACES = /\s\s*/;
    var onceSupported = function() {
        var supported = false;
        if (IS_BROWSER) {
            var once = false;
            var listener = function listener() {};
            var options = Object.defineProperty({}, 'once', {
                get: function get() {
                    supported = true;
                    return once;
                },
                /**
         * This setter can fix a `TypeError` in strict mode
         * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only}
         * @param {boolean} value - The value to set
         */ set: function set(value) {
                    once = value;
                }
            });
            WINDOW.addEventListener('test', listener, options);
            WINDOW.removeEventListener('test', listener, options);
        }
        return supported;
    }();
    /**
   * Remove event listener from the target element.
   * @param {Element} element - The event target.
   * @param {string} type - The event type(s).
   * @param {Function} listener - The event listener.
   * @param {Object} options - The event options.
   */ function removeListener(element, type, listener) {
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var handler = listener;
        type.trim().split(REGEXP_SPACES).forEach(function(event) {
            if (!onceSupported) {
                var listeners = element.listeners;
                if (listeners && listeners[event] && listeners[event][listener]) {
                    handler = listeners[event][listener];
                    delete listeners[event][listener];
                    if (Object.keys(listeners[event]).length === 0) delete listeners[event];
                    if (Object.keys(listeners).length === 0) delete element.listeners;
                }
            }
            element.removeEventListener(event, handler, options);
        });
    }
    /**
   * Add event listener to the target element.
   * @param {Element} element - The event target.
   * @param {string} type - The event type(s).
   * @param {Function} listener - The event listener.
   * @param {Object} options - The event options.
   */ function addListener(element, type, listener) {
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var _handler = listener;
        type.trim().split(REGEXP_SPACES).forEach(function(event) {
            if (options.once && !onceSupported) {
                var _element$listeners = element.listeners, listeners = _element$listeners === void 0 ? {} : _element$listeners;
                _handler = function handler() {
                    delete listeners[event][listener];
                    element.removeEventListener(event, _handler, options);
                    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                    listener.apply(element, args);
                };
                if (!listeners[event]) listeners[event] = {};
                if (listeners[event][listener]) element.removeEventListener(event, listeners[event][listener], options);
                listeners[event][listener] = _handler;
                element.listeners = listeners;
            }
            element.addEventListener(event, _handler, options);
        });
    }
    /**
   * Dispatch event on the target element.
   * @param {Element} element - The event target.
   * @param {string} type - The event type(s).
   * @param {Object} data - The additional event data.
   * @returns {boolean} Indicate if the event is default prevented or not.
   */ function dispatchEvent(element, type, data) {
        var event;
        // Event and CustomEvent on IE9-11 are global objects, not constructors
        if (isFunction(Event) && isFunction(CustomEvent)) event = new CustomEvent(type, {
            detail: data,
            bubbles: true,
            cancelable: true
        });
        else {
            event = document.createEvent('CustomEvent');
            event.initCustomEvent(type, true, true, data);
        }
        return element.dispatchEvent(event);
    }
    /**
   * Get the offset base on the document.
   * @param {Element} element - The target element.
   * @returns {Object} The offset data.
   */ function getOffset(element) {
        var box = element.getBoundingClientRect();
        return {
            left: box.left + (window.pageXOffset - document.documentElement.clientLeft),
            top: box.top + (window.pageYOffset - document.documentElement.clientTop)
        };
    }
    var location = WINDOW.location;
    var REGEXP_ORIGINS = /^(\w+:)\/\/([^:/?#]*):?(\d*)/i;
    /**
   * Check if the given URL is a cross origin URL.
   * @param {string} url - The target URL.
   * @returns {boolean} Returns `true` if the given URL is a cross origin URL, else `false`.
   */ function isCrossOriginURL(url) {
        var parts = url.match(REGEXP_ORIGINS);
        return parts !== null && (parts[1] !== location.protocol || parts[2] !== location.hostname || parts[3] !== location.port);
    }
    /**
   * Add timestamp to the given URL.
   * @param {string} url - The target URL.
   * @returns {string} The result URL.
   */ function addTimestamp(url) {
        var timestamp = "timestamp=".concat(new Date().getTime());
        return url + (url.indexOf('?') === -1 ? '?' : '&') + timestamp;
    }
    /**
   * Get transforms base on the given object.
   * @param {Object} obj - The target object.
   * @returns {string} A string contains transform values.
   */ function getTransforms(_ref) {
        var rotate = _ref.rotate, scaleX = _ref.scaleX, scaleY = _ref.scaleY, translateX = _ref.translateX, translateY = _ref.translateY;
        var values = [];
        if (isNumber(translateX) && translateX !== 0) values.push("translateX(".concat(translateX, "px)"));
        if (isNumber(translateY) && translateY !== 0) values.push("translateY(".concat(translateY, "px)"));
        // Rotate should come first before scale to match orientation transform
        if (isNumber(rotate) && rotate !== 0) values.push("rotate(".concat(rotate, "deg)"));
        if (isNumber(scaleX) && scaleX !== 1) values.push("scaleX(".concat(scaleX, ")"));
        if (isNumber(scaleY) && scaleY !== 1) values.push("scaleY(".concat(scaleY, ")"));
        var transform = values.length ? values.join(' ') : 'none';
        return {
            WebkitTransform: transform,
            msTransform: transform,
            transform: transform
        };
    }
    /**
   * Get the max ratio of a group of pointers.
   * @param {string} pointers - The target pointers.
   * @returns {number} The result ratio.
   */ function getMaxZoomRatio(pointers) {
        var pointers2 = _objectSpread2({}, pointers);
        var maxRatio = 0;
        forEach(pointers, function(pointer, pointerId) {
            delete pointers2[pointerId];
            forEach(pointers2, function(pointer2) {
                var x1 = Math.abs(pointer.startX - pointer2.startX);
                var y1 = Math.abs(pointer.startY - pointer2.startY);
                var x2 = Math.abs(pointer.endX - pointer2.endX);
                var y2 = Math.abs(pointer.endY - pointer2.endY);
                var z1 = Math.sqrt(x1 * x1 + y1 * y1);
                var z2 = Math.sqrt(x2 * x2 + y2 * y2);
                var ratio = (z2 - z1) / z1;
                if (Math.abs(ratio) > Math.abs(maxRatio)) maxRatio = ratio;
            });
        });
        return maxRatio;
    }
    /**
   * Get a pointer from an event object.
   * @param {Object} event - The target event object.
   * @param {boolean} endOnly - Indicates if only returns the end point coordinate or not.
   * @returns {Object} The result pointer contains start and/or end point coordinates.
   */ function getPointer(_ref2, endOnly) {
        var pageX = _ref2.pageX, pageY = _ref2.pageY;
        var end = {
            endX: pageX,
            endY: pageY
        };
        return endOnly ? end : _objectSpread2({
            startX: pageX,
            startY: pageY
        }, end);
    }
    /**
   * Get the center point coordinate of a group of pointers.
   * @param {Object} pointers - The target pointers.
   * @returns {Object} The center point coordinate.
   */ function getPointersCenter(pointers) {
        var pageX = 0;
        var pageY = 0;
        var count = 0;
        forEach(pointers, function(_ref3) {
            var startX = _ref3.startX, startY = _ref3.startY;
            pageX += startX;
            pageY += startY;
            count += 1;
        });
        pageX /= count;
        pageY /= count;
        return {
            pageX: pageX,
            pageY: pageY
        };
    }
    /**
   * Get the max sizes in a rectangle under the given aspect ratio.
   * @param {Object} data - The original sizes.
   * @param {string} [type='contain'] - The adjust type.
   * @returns {Object} The result sizes.
   */ function getAdjustedSizes(_ref4) {
        var aspectRatio = _ref4.aspectRatio, height = _ref4.height, width = _ref4.width;
        var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'contain';
        var isValidWidth = isPositiveNumber(width);
        var isValidHeight = isPositiveNumber(height);
        if (isValidWidth && isValidHeight) {
            var adjustedWidth = height * aspectRatio;
            if (type === 'contain' && adjustedWidth > width || type === 'cover' && adjustedWidth < width) height = width / aspectRatio;
            else width = height * aspectRatio;
        } else if (isValidWidth) height = width / aspectRatio;
        else if (isValidHeight) width = height * aspectRatio;
        return {
            width: width,
            height: height
        };
    }
    /**
   * Get the new sizes of a rectangle after rotated.
   * @param {Object} data - The original sizes.
   * @returns {Object} The result sizes.
   */ function getRotatedSizes(_ref5) {
        var width = _ref5.width, height = _ref5.height, degree = _ref5.degree;
        degree = Math.abs(degree) % 180;
        if (degree === 90) return {
            width: height,
            height: width
        };
        var arc = degree % 90 * Math.PI / 180;
        var sinArc = Math.sin(arc);
        var cosArc = Math.cos(arc);
        var newWidth = width * cosArc + height * sinArc;
        var newHeight = width * sinArc + height * cosArc;
        return degree > 90 ? {
            width: newHeight,
            height: newWidth
        } : {
            width: newWidth,
            height: newHeight
        };
    }
    /**
   * Get a canvas which drew the given image.
   * @param {HTMLImageElement} image - The image for drawing.
   * @param {Object} imageData - The image data.
   * @param {Object} canvasData - The canvas data.
   * @param {Object} options - The options.
   * @returns {HTMLCanvasElement} The result canvas.
   */ function getSourceCanvas(image, _ref6, _ref7, _ref8) {
        var imageAspectRatio = _ref6.aspectRatio, imageNaturalWidth = _ref6.naturalWidth, imageNaturalHeight = _ref6.naturalHeight, _ref6$rotate = _ref6.rotate, rotate = _ref6$rotate === void 0 ? 0 : _ref6$rotate, _ref6$scaleX = _ref6.scaleX, scaleX = _ref6$scaleX === void 0 ? 1 : _ref6$scaleX, _ref6$scaleY = _ref6.scaleY, scaleY = _ref6$scaleY === void 0 ? 1 : _ref6$scaleY;
        var aspectRatio = _ref7.aspectRatio, naturalWidth = _ref7.naturalWidth, naturalHeight = _ref7.naturalHeight;
        var _ref8$fillColor = _ref8.fillColor, fillColor = _ref8$fillColor === void 0 ? 'transparent' : _ref8$fillColor, _ref8$imageSmoothingE = _ref8.imageSmoothingEnabled, imageSmoothingEnabled = _ref8$imageSmoothingE === void 0 ? true : _ref8$imageSmoothingE, _ref8$imageSmoothingQ = _ref8.imageSmoothingQuality, imageSmoothingQuality = _ref8$imageSmoothingQ === void 0 ? 'low' : _ref8$imageSmoothingQ, _ref8$maxWidth = _ref8.maxWidth, maxWidth = _ref8$maxWidth === void 0 ? Infinity : _ref8$maxWidth, _ref8$maxHeight = _ref8.maxHeight, maxHeight = _ref8$maxHeight === void 0 ? Infinity : _ref8$maxHeight, _ref8$minWidth = _ref8.minWidth, minWidth = _ref8$minWidth === void 0 ? 0 : _ref8$minWidth, _ref8$minHeight = _ref8.minHeight, minHeight = _ref8$minHeight === void 0 ? 0 : _ref8$minHeight;
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');
        var maxSizes = getAdjustedSizes({
            aspectRatio: aspectRatio,
            width: maxWidth,
            height: maxHeight
        });
        var minSizes = getAdjustedSizes({
            aspectRatio: aspectRatio,
            width: minWidth,
            height: minHeight
        }, 'cover');
        var width = Math.min(maxSizes.width, Math.max(minSizes.width, naturalWidth));
        var height = Math.min(maxSizes.height, Math.max(minSizes.height, naturalHeight));
        // Note: should always use image's natural sizes for drawing as
        // imageData.naturalWidth === canvasData.naturalHeight when rotate % 180 === 90
        var destMaxSizes = getAdjustedSizes({
            aspectRatio: imageAspectRatio,
            width: maxWidth,
            height: maxHeight
        });
        var destMinSizes = getAdjustedSizes({
            aspectRatio: imageAspectRatio,
            width: minWidth,
            height: minHeight
        }, 'cover');
        var destWidth = Math.min(destMaxSizes.width, Math.max(destMinSizes.width, imageNaturalWidth));
        var destHeight = Math.min(destMaxSizes.height, Math.max(destMinSizes.height, imageNaturalHeight));
        var params = [
            -destWidth / 2,
            -destHeight / 2,
            destWidth,
            destHeight
        ];
        canvas.width = normalizeDecimalNumber(width);
        canvas.height = normalizeDecimalNumber(height);
        context.fillStyle = fillColor;
        context.fillRect(0, 0, width, height);
        context.save();
        context.translate(width / 2, height / 2);
        context.rotate(rotate * Math.PI / 180);
        context.scale(scaleX, scaleY);
        context.imageSmoothingEnabled = imageSmoothingEnabled;
        context.imageSmoothingQuality = imageSmoothingQuality;
        context.drawImage.apply(context, [
            image
        ].concat(_toConsumableArray(params.map(function(param) {
            return Math.floor(normalizeDecimalNumber(param));
        }))));
        context.restore();
        return canvas;
    }
    var fromCharCode = String.fromCharCode;
    /**
   * Get string from char code in data view.
   * @param {DataView} dataView - The data view for read.
   * @param {number} start - The start index.
   * @param {number} length - The read length.
   * @returns {string} The read result.
   */ function getStringFromCharCode(dataView, start, length) {
        var str = '';
        length += start;
        for(var i = start; i < length; i += 1)str += fromCharCode(dataView.getUint8(i));
        return str;
    }
    var REGEXP_DATA_URL_HEAD = /^data:.*,/;
    /**
   * Transform Data URL to array buffer.
   * @param {string} dataURL - The Data URL to transform.
   * @returns {ArrayBuffer} The result array buffer.
   */ function dataURLToArrayBuffer(dataURL) {
        var base64 = dataURL.replace(REGEXP_DATA_URL_HEAD, '');
        var binary = atob(base64);
        var arrayBuffer = new ArrayBuffer(binary.length);
        var uint8 = new Uint8Array(arrayBuffer);
        forEach(uint8, function(value, i) {
            uint8[i] = binary.charCodeAt(i);
        });
        return arrayBuffer;
    }
    /**
   * Transform array buffer to Data URL.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to transform.
   * @param {string} mimeType - The mime type of the Data URL.
   * @returns {string} The result Data URL.
   */ function arrayBufferToDataURL(arrayBuffer, mimeType) {
        var chunks = [];
        // Chunk Typed Array for better performance (#435)
        var chunkSize = 8192;
        var uint8 = new Uint8Array(arrayBuffer);
        while(uint8.length > 0){
            // XXX: Babel's `toConsumableArray` helper will throw error in IE or Safari 9
             
            chunks.push(fromCharCode.apply(null, toArray(uint8.subarray(0, chunkSize))));
            uint8 = uint8.subarray(chunkSize);
        }
        return "data:".concat(mimeType, ";base64,").concat(btoa(chunks.join('')));
    }
    /**
   * Get orientation value from given array buffer.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to read.
   * @returns {number} The read orientation value.
   */ function resetAndGetOrientation(arrayBuffer) {
        var dataView = new DataView(arrayBuffer);
        var orientation;
        // Ignores range error when the image does not have correct Exif information
        try {
            var littleEndian;
            var app1Start;
            var ifdStart;
            // Only handle JPEG image (start by 0xFFD8)
            if (dataView.getUint8(0) === 0xFF && dataView.getUint8(1) === 0xD8) {
                var length = dataView.byteLength;
                var offset = 2;
                while(offset + 1 < length){
                    if (dataView.getUint8(offset) === 0xFF && dataView.getUint8(offset + 1) === 0xE1) {
                        app1Start = offset;
                        break;
                    }
                    offset += 1;
                }
            }
            if (app1Start) {
                var exifIDCode = app1Start + 4;
                var tiffOffset = app1Start + 10;
                if (getStringFromCharCode(dataView, exifIDCode, 4) === 'Exif') {
                    var endianness = dataView.getUint16(tiffOffset);
                    littleEndian = endianness === 0x4949;
                    if (littleEndian || endianness === 0x4D4D /* bigEndian */ ) {
                        if (dataView.getUint16(tiffOffset + 2, littleEndian) === 0x002A) {
                            var firstIFDOffset = dataView.getUint32(tiffOffset + 4, littleEndian);
                            if (firstIFDOffset >= 0x00000008) ifdStart = tiffOffset + firstIFDOffset;
                        }
                    }
                }
            }
            if (ifdStart) {
                var _length = dataView.getUint16(ifdStart, littleEndian);
                var _offset;
                var i;
                for(i = 0; i < _length; i += 1){
                    _offset = ifdStart + i * 12 + 2;
                    if (dataView.getUint16(_offset, littleEndian) === 0x0112 /* Orientation */ ) {
                        // 8 is the offset of the current tag's value
                        _offset += 8;
                        // Get the original orientation value
                        orientation = dataView.getUint16(_offset, littleEndian);
                        // Override the orientation with its default value
                        dataView.setUint16(_offset, 1, littleEndian);
                        break;
                    }
                }
            }
        } catch (error) {
            orientation = 1;
        }
        return orientation;
    }
    /**
   * Parse Exif Orientation value.
   * @param {number} orientation - The orientation to parse.
   * @returns {Object} The parsed result.
   */ function parseOrientation(orientation) {
        var rotate = 0;
        var scaleX = 1;
        var scaleY = 1;
        switch(orientation){
            // Flip horizontal
            case 2:
                scaleX = -1;
                break;
            // Rotate left 180°
            case 3:
                rotate = -180;
                break;
            // Flip vertical
            case 4:
                scaleY = -1;
                break;
            // Flip vertical and rotate right 90°
            case 5:
                rotate = 90;
                scaleY = -1;
                break;
            // Rotate right 90°
            case 6:
                rotate = 90;
                break;
            // Flip horizontal and rotate right 90°
            case 7:
                rotate = 90;
                scaleX = -1;
                break;
            // Rotate left 90°
            case 8:
                rotate = -90;
                break;
        }
        return {
            rotate: rotate,
            scaleX: scaleX,
            scaleY: scaleY
        };
    }
    var render = {
        render: function render() {
            this.initContainer();
            this.initCanvas();
            this.initCropBox();
            this.renderCanvas();
            if (this.cropped) this.renderCropBox();
        },
        initContainer: function initContainer() {
            var element = this.element, options = this.options, container = this.container, cropper = this.cropper;
            var minWidth = Number(options.minContainerWidth);
            var minHeight = Number(options.minContainerHeight);
            addClass(cropper, CLASS_HIDDEN);
            removeClass(element, CLASS_HIDDEN);
            var containerData = {
                width: Math.max(container.offsetWidth, minWidth >= 0 ? minWidth : MIN_CONTAINER_WIDTH),
                height: Math.max(container.offsetHeight, minHeight >= 0 ? minHeight : MIN_CONTAINER_HEIGHT)
            };
            this.containerData = containerData;
            setStyle(cropper, {
                width: containerData.width,
                height: containerData.height
            });
            addClass(element, CLASS_HIDDEN);
            removeClass(cropper, CLASS_HIDDEN);
        },
        // Canvas (image wrapper)
        initCanvas: function initCanvas() {
            var containerData = this.containerData, imageData = this.imageData;
            var viewMode = this.options.viewMode;
            var rotated = Math.abs(imageData.rotate) % 180 === 90;
            var naturalWidth = rotated ? imageData.naturalHeight : imageData.naturalWidth;
            var naturalHeight = rotated ? imageData.naturalWidth : imageData.naturalHeight;
            var aspectRatio = naturalWidth / naturalHeight;
            var canvasWidth = containerData.width;
            var canvasHeight = containerData.height;
            if (containerData.height * aspectRatio > containerData.width) {
                if (viewMode === 3) canvasWidth = containerData.height * aspectRatio;
                else canvasHeight = containerData.width / aspectRatio;
            } else if (viewMode === 3) canvasHeight = containerData.width / aspectRatio;
            else canvasWidth = containerData.height * aspectRatio;
            var canvasData = {
                aspectRatio: aspectRatio,
                naturalWidth: naturalWidth,
                naturalHeight: naturalHeight,
                width: canvasWidth,
                height: canvasHeight
            };
            this.canvasData = canvasData;
            this.limited = viewMode === 1 || viewMode === 2;
            this.limitCanvas(true, true);
            canvasData.width = Math.min(Math.max(canvasData.width, canvasData.minWidth), canvasData.maxWidth);
            canvasData.height = Math.min(Math.max(canvasData.height, canvasData.minHeight), canvasData.maxHeight);
            canvasData.left = (containerData.width - canvasData.width) / 2;
            canvasData.top = (containerData.height - canvasData.height) / 2;
            canvasData.oldLeft = canvasData.left;
            canvasData.oldTop = canvasData.top;
            this.initialCanvasData = assign({}, canvasData);
        },
        limitCanvas: function limitCanvas(sizeLimited, positionLimited) {
            var options = this.options, containerData = this.containerData, canvasData = this.canvasData, cropBoxData = this.cropBoxData;
            var viewMode = options.viewMode;
            var aspectRatio = canvasData.aspectRatio;
            var cropped = this.cropped && cropBoxData;
            if (sizeLimited) {
                var minCanvasWidth = Number(options.minCanvasWidth) || 0;
                var minCanvasHeight = Number(options.minCanvasHeight) || 0;
                if (viewMode > 1) {
                    minCanvasWidth = Math.max(minCanvasWidth, containerData.width);
                    minCanvasHeight = Math.max(minCanvasHeight, containerData.height);
                    if (viewMode === 3) {
                        if (minCanvasHeight * aspectRatio > minCanvasWidth) minCanvasWidth = minCanvasHeight * aspectRatio;
                        else minCanvasHeight = minCanvasWidth / aspectRatio;
                    }
                } else if (viewMode > 0) {
                    if (minCanvasWidth) minCanvasWidth = Math.max(minCanvasWidth, cropped ? cropBoxData.width : 0);
                    else if (minCanvasHeight) minCanvasHeight = Math.max(minCanvasHeight, cropped ? cropBoxData.height : 0);
                    else if (cropped) {
                        minCanvasWidth = cropBoxData.width;
                        minCanvasHeight = cropBoxData.height;
                        if (minCanvasHeight * aspectRatio > minCanvasWidth) minCanvasWidth = minCanvasHeight * aspectRatio;
                        else minCanvasHeight = minCanvasWidth / aspectRatio;
                    }
                }
                var _getAdjustedSizes = getAdjustedSizes({
                    aspectRatio: aspectRatio,
                    width: minCanvasWidth,
                    height: minCanvasHeight
                });
                minCanvasWidth = _getAdjustedSizes.width;
                minCanvasHeight = _getAdjustedSizes.height;
                canvasData.minWidth = minCanvasWidth;
                canvasData.minHeight = minCanvasHeight;
                canvasData.maxWidth = Infinity;
                canvasData.maxHeight = Infinity;
            }
            if (positionLimited) {
                if (viewMode > (cropped ? 0 : 1)) {
                    var newCanvasLeft = containerData.width - canvasData.width;
                    var newCanvasTop = containerData.height - canvasData.height;
                    canvasData.minLeft = Math.min(0, newCanvasLeft);
                    canvasData.minTop = Math.min(0, newCanvasTop);
                    canvasData.maxLeft = Math.max(0, newCanvasLeft);
                    canvasData.maxTop = Math.max(0, newCanvasTop);
                    if (cropped && this.limited) {
                        canvasData.minLeft = Math.min(cropBoxData.left, cropBoxData.left + (cropBoxData.width - canvasData.width));
                        canvasData.minTop = Math.min(cropBoxData.top, cropBoxData.top + (cropBoxData.height - canvasData.height));
                        canvasData.maxLeft = cropBoxData.left;
                        canvasData.maxTop = cropBoxData.top;
                        if (viewMode === 2) {
                            if (canvasData.width >= containerData.width) {
                                canvasData.minLeft = Math.min(0, newCanvasLeft);
                                canvasData.maxLeft = Math.max(0, newCanvasLeft);
                            }
                            if (canvasData.height >= containerData.height) {
                                canvasData.minTop = Math.min(0, newCanvasTop);
                                canvasData.maxTop = Math.max(0, newCanvasTop);
                            }
                        }
                    }
                } else {
                    canvasData.minLeft = -canvasData.width;
                    canvasData.minTop = -canvasData.height;
                    canvasData.maxLeft = containerData.width;
                    canvasData.maxTop = containerData.height;
                }
            }
        },
        renderCanvas: function renderCanvas(changed, transformed) {
            var canvasData = this.canvasData, imageData = this.imageData;
            if (transformed) {
                var _getRotatedSizes = getRotatedSizes({
                    width: imageData.naturalWidth * Math.abs(imageData.scaleX || 1),
                    height: imageData.naturalHeight * Math.abs(imageData.scaleY || 1),
                    degree: imageData.rotate || 0
                }), naturalWidth = _getRotatedSizes.width, naturalHeight = _getRotatedSizes.height;
                var width = canvasData.width * (naturalWidth / canvasData.naturalWidth);
                var height = canvasData.height * (naturalHeight / canvasData.naturalHeight);
                canvasData.left -= (width - canvasData.width) / 2;
                canvasData.top -= (height - canvasData.height) / 2;
                canvasData.width = width;
                canvasData.height = height;
                canvasData.aspectRatio = naturalWidth / naturalHeight;
                canvasData.naturalWidth = naturalWidth;
                canvasData.naturalHeight = naturalHeight;
                this.limitCanvas(true, false);
            }
            if (canvasData.width > canvasData.maxWidth || canvasData.width < canvasData.minWidth) canvasData.left = canvasData.oldLeft;
            if (canvasData.height > canvasData.maxHeight || canvasData.height < canvasData.minHeight) canvasData.top = canvasData.oldTop;
            canvasData.width = Math.min(Math.max(canvasData.width, canvasData.minWidth), canvasData.maxWidth);
            canvasData.height = Math.min(Math.max(canvasData.height, canvasData.minHeight), canvasData.maxHeight);
            this.limitCanvas(false, true);
            canvasData.left = Math.min(Math.max(canvasData.left, canvasData.minLeft), canvasData.maxLeft);
            canvasData.top = Math.min(Math.max(canvasData.top, canvasData.minTop), canvasData.maxTop);
            canvasData.oldLeft = canvasData.left;
            canvasData.oldTop = canvasData.top;
            setStyle(this.canvas, assign({
                width: canvasData.width,
                height: canvasData.height
            }, getTransforms({
                translateX: canvasData.left,
                translateY: canvasData.top
            })));
            this.renderImage(changed);
            if (this.cropped && this.limited) this.limitCropBox(true, true);
        },
        renderImage: function renderImage(changed) {
            var canvasData = this.canvasData, imageData = this.imageData;
            var width = imageData.naturalWidth * (canvasData.width / canvasData.naturalWidth);
            var height = imageData.naturalHeight * (canvasData.height / canvasData.naturalHeight);
            assign(imageData, {
                width: width,
                height: height,
                left: (canvasData.width - width) / 2,
                top: (canvasData.height - height) / 2
            });
            setStyle(this.image, assign({
                width: imageData.width,
                height: imageData.height
            }, getTransforms(assign({
                translateX: imageData.left,
                translateY: imageData.top
            }, imageData))));
            if (changed) this.output();
        },
        initCropBox: function initCropBox() {
            var options = this.options, canvasData = this.canvasData;
            var aspectRatio = options.aspectRatio || options.initialAspectRatio;
            var autoCropArea = Number(options.autoCropArea) || 0.8;
            var cropBoxData = {
                width: canvasData.width,
                height: canvasData.height
            };
            if (aspectRatio) {
                if (canvasData.height * aspectRatio > canvasData.width) cropBoxData.height = cropBoxData.width / aspectRatio;
                else cropBoxData.width = cropBoxData.height * aspectRatio;
            }
            this.cropBoxData = cropBoxData;
            this.limitCropBox(true, true);
            // Initialize auto crop area
            cropBoxData.width = Math.min(Math.max(cropBoxData.width, cropBoxData.minWidth), cropBoxData.maxWidth);
            cropBoxData.height = Math.min(Math.max(cropBoxData.height, cropBoxData.minHeight), cropBoxData.maxHeight);
            // The width/height of auto crop area must large than "minWidth/Height"
            cropBoxData.width = Math.max(cropBoxData.minWidth, cropBoxData.width * autoCropArea);
            cropBoxData.height = Math.max(cropBoxData.minHeight, cropBoxData.height * autoCropArea);
            cropBoxData.left = canvasData.left + (canvasData.width - cropBoxData.width) / 2;
            cropBoxData.top = canvasData.top + (canvasData.height - cropBoxData.height) / 2;
            cropBoxData.oldLeft = cropBoxData.left;
            cropBoxData.oldTop = cropBoxData.top;
            this.initialCropBoxData = assign({}, cropBoxData);
        },
        limitCropBox: function limitCropBox(sizeLimited, positionLimited) {
            var options = this.options, containerData = this.containerData, canvasData = this.canvasData, cropBoxData = this.cropBoxData, limited = this.limited;
            var aspectRatio = options.aspectRatio;
            if (sizeLimited) {
                var minCropBoxWidth = Number(options.minCropBoxWidth) || 0;
                var minCropBoxHeight = Number(options.minCropBoxHeight) || 0;
                var maxCropBoxWidth = limited ? Math.min(containerData.width, canvasData.width, canvasData.width + canvasData.left, containerData.width - canvasData.left) : containerData.width;
                var maxCropBoxHeight = limited ? Math.min(containerData.height, canvasData.height, canvasData.height + canvasData.top, containerData.height - canvasData.top) : containerData.height;
                // The min/maxCropBoxWidth/Height must be less than container's width/height
                minCropBoxWidth = Math.min(minCropBoxWidth, containerData.width);
                minCropBoxHeight = Math.min(minCropBoxHeight, containerData.height);
                if (aspectRatio) {
                    if (minCropBoxWidth && minCropBoxHeight) {
                        if (minCropBoxHeight * aspectRatio > minCropBoxWidth) minCropBoxHeight = minCropBoxWidth / aspectRatio;
                        else minCropBoxWidth = minCropBoxHeight * aspectRatio;
                    } else if (minCropBoxWidth) minCropBoxHeight = minCropBoxWidth / aspectRatio;
                    else if (minCropBoxHeight) minCropBoxWidth = minCropBoxHeight * aspectRatio;
                    if (maxCropBoxHeight * aspectRatio > maxCropBoxWidth) maxCropBoxHeight = maxCropBoxWidth / aspectRatio;
                    else maxCropBoxWidth = maxCropBoxHeight * aspectRatio;
                }
                // The minWidth/Height must be less than maxWidth/Height
                cropBoxData.minWidth = Math.min(minCropBoxWidth, maxCropBoxWidth);
                cropBoxData.minHeight = Math.min(minCropBoxHeight, maxCropBoxHeight);
                cropBoxData.maxWidth = maxCropBoxWidth;
                cropBoxData.maxHeight = maxCropBoxHeight;
            }
            if (positionLimited) {
                if (limited) {
                    cropBoxData.minLeft = Math.max(0, canvasData.left);
                    cropBoxData.minTop = Math.max(0, canvasData.top);
                    cropBoxData.maxLeft = Math.min(containerData.width, canvasData.left + canvasData.width) - cropBoxData.width;
                    cropBoxData.maxTop = Math.min(containerData.height, canvasData.top + canvasData.height) - cropBoxData.height;
                } else {
                    cropBoxData.minLeft = 0;
                    cropBoxData.minTop = 0;
                    cropBoxData.maxLeft = containerData.width - cropBoxData.width;
                    cropBoxData.maxTop = containerData.height - cropBoxData.height;
                }
            }
        },
        renderCropBox: function renderCropBox() {
            var options = this.options, containerData = this.containerData, cropBoxData = this.cropBoxData;
            if (cropBoxData.width > cropBoxData.maxWidth || cropBoxData.width < cropBoxData.minWidth) cropBoxData.left = cropBoxData.oldLeft;
            if (cropBoxData.height > cropBoxData.maxHeight || cropBoxData.height < cropBoxData.minHeight) cropBoxData.top = cropBoxData.oldTop;
            cropBoxData.width = Math.min(Math.max(cropBoxData.width, cropBoxData.minWidth), cropBoxData.maxWidth);
            cropBoxData.height = Math.min(Math.max(cropBoxData.height, cropBoxData.minHeight), cropBoxData.maxHeight);
            this.limitCropBox(false, true);
            cropBoxData.left = Math.min(Math.max(cropBoxData.left, cropBoxData.minLeft), cropBoxData.maxLeft);
            cropBoxData.top = Math.min(Math.max(cropBoxData.top, cropBoxData.minTop), cropBoxData.maxTop);
            cropBoxData.oldLeft = cropBoxData.left;
            cropBoxData.oldTop = cropBoxData.top;
            if (options.movable && options.cropBoxMovable) // Turn to move the canvas when the crop box is equal to the container
            setData(this.face, DATA_ACTION, cropBoxData.width >= containerData.width && cropBoxData.height >= containerData.height ? ACTION_MOVE : ACTION_ALL);
            setStyle(this.cropBox, assign({
                width: cropBoxData.width,
                height: cropBoxData.height
            }, getTransforms({
                translateX: cropBoxData.left,
                translateY: cropBoxData.top
            })));
            if (this.cropped && this.limited) this.limitCanvas(true, true);
            if (!this.disabled) this.output();
        },
        output: function output() {
            this.preview();
            dispatchEvent(this.element, EVENT_CROP, this.getData());
        }
    };
    var preview = {
        initPreview: function initPreview() {
            var element = this.element, crossOrigin = this.crossOrigin;
            var preview = this.options.preview;
            var url = crossOrigin ? this.crossOriginUrl : this.url;
            var alt = element.alt || 'The image to preview';
            var image = document.createElement('img');
            if (crossOrigin) image.crossOrigin = crossOrigin;
            image.src = url;
            image.alt = alt;
            this.viewBox.appendChild(image);
            this.viewBoxImage = image;
            if (!preview) return;
            var previews = preview;
            if (typeof preview === 'string') previews = element.ownerDocument.querySelectorAll(preview);
            else if (preview.querySelector) previews = [
                preview
            ];
            this.previews = previews;
            forEach(previews, function(el) {
                var img = document.createElement('img');
                // Save the original size for recover
                setData(el, DATA_PREVIEW, {
                    width: el.offsetWidth,
                    height: el.offsetHeight,
                    html: el.innerHTML
                });
                if (crossOrigin) img.crossOrigin = crossOrigin;
                img.src = url;
                img.alt = alt;
                /**
         * Override img element styles
         * Add `display:block` to avoid margin top issue
         * Add `height:auto` to override `height` attribute on IE8
         * (Occur only when margin-top <= -height)
         */ img.style.cssText = 'display:block;width:100%;height:auto;min-width:0!important;min-height:0!important;max-width:none!important;max-height:none!important;image-orientation:0deg!important;"';
                el.innerHTML = '';
                el.appendChild(img);
            });
        },
        resetPreview: function resetPreview() {
            forEach(this.previews, function(element) {
                var data = getData(element, DATA_PREVIEW);
                setStyle(element, {
                    width: data.width,
                    height: data.height
                });
                element.innerHTML = data.html;
                removeData(element, DATA_PREVIEW);
            });
        },
        preview: function preview() {
            var imageData = this.imageData, canvasData = this.canvasData, cropBoxData = this.cropBoxData;
            var cropBoxWidth = cropBoxData.width, cropBoxHeight = cropBoxData.height;
            var width = imageData.width, height = imageData.height;
            var left = cropBoxData.left - canvasData.left - imageData.left;
            var top = cropBoxData.top - canvasData.top - imageData.top;
            if (!this.cropped || this.disabled) return;
            setStyle(this.viewBoxImage, assign({
                width: width,
                height: height
            }, getTransforms(assign({
                translateX: -left,
                translateY: -top
            }, imageData))));
            forEach(this.previews, function(element) {
                var data = getData(element, DATA_PREVIEW);
                var originalWidth = data.width;
                var originalHeight = data.height;
                var newWidth = originalWidth;
                var newHeight = originalHeight;
                var ratio = 1;
                if (cropBoxWidth) {
                    ratio = originalWidth / cropBoxWidth;
                    newHeight = cropBoxHeight * ratio;
                }
                if (cropBoxHeight && newHeight > originalHeight) {
                    ratio = originalHeight / cropBoxHeight;
                    newWidth = cropBoxWidth * ratio;
                    newHeight = originalHeight;
                }
                setStyle(element, {
                    width: newWidth,
                    height: newHeight
                });
                setStyle(element.getElementsByTagName('img')[0], assign({
                    width: width * ratio,
                    height: height * ratio
                }, getTransforms(assign({
                    translateX: -left * ratio,
                    translateY: -top * ratio
                }, imageData))));
            });
        }
    };
    var events = {
        bind: function bind() {
            var element = this.element, options = this.options, cropper = this.cropper;
            if (isFunction(options.cropstart)) addListener(element, EVENT_CROP_START, options.cropstart);
            if (isFunction(options.cropmove)) addListener(element, EVENT_CROP_MOVE, options.cropmove);
            if (isFunction(options.cropend)) addListener(element, EVENT_CROP_END, options.cropend);
            if (isFunction(options.crop)) addListener(element, EVENT_CROP, options.crop);
            if (isFunction(options.zoom)) addListener(element, EVENT_ZOOM, options.zoom);
            addListener(cropper, EVENT_POINTER_DOWN, this.onCropStart = this.cropStart.bind(this));
            if (options.zoomable && options.zoomOnWheel) addListener(cropper, EVENT_WHEEL, this.onWheel = this.wheel.bind(this), {
                passive: false,
                capture: true
            });
            if (options.toggleDragModeOnDblclick) addListener(cropper, EVENT_DBLCLICK, this.onDblclick = this.dblclick.bind(this));
            addListener(element.ownerDocument, EVENT_POINTER_MOVE, this.onCropMove = this.cropMove.bind(this));
            addListener(element.ownerDocument, EVENT_POINTER_UP, this.onCropEnd = this.cropEnd.bind(this));
            if (options.responsive) addListener(window, EVENT_RESIZE, this.onResize = this.resize.bind(this));
        },
        unbind: function unbind() {
            var element = this.element, options = this.options, cropper = this.cropper;
            if (isFunction(options.cropstart)) removeListener(element, EVENT_CROP_START, options.cropstart);
            if (isFunction(options.cropmove)) removeListener(element, EVENT_CROP_MOVE, options.cropmove);
            if (isFunction(options.cropend)) removeListener(element, EVENT_CROP_END, options.cropend);
            if (isFunction(options.crop)) removeListener(element, EVENT_CROP, options.crop);
            if (isFunction(options.zoom)) removeListener(element, EVENT_ZOOM, options.zoom);
            removeListener(cropper, EVENT_POINTER_DOWN, this.onCropStart);
            if (options.zoomable && options.zoomOnWheel) removeListener(cropper, EVENT_WHEEL, this.onWheel, {
                passive: false,
                capture: true
            });
            if (options.toggleDragModeOnDblclick) removeListener(cropper, EVENT_DBLCLICK, this.onDblclick);
            removeListener(element.ownerDocument, EVENT_POINTER_MOVE, this.onCropMove);
            removeListener(element.ownerDocument, EVENT_POINTER_UP, this.onCropEnd);
            if (options.responsive) removeListener(window, EVENT_RESIZE, this.onResize);
        }
    };
    var handlers = {
        resize: function resize() {
            if (this.disabled) return;
            var options = this.options, container = this.container, containerData = this.containerData;
            var ratioX = container.offsetWidth / containerData.width;
            var ratioY = container.offsetHeight / containerData.height;
            var ratio = Math.abs(ratioX - 1) > Math.abs(ratioY - 1) ? ratioX : ratioY;
            // Resize when width changed or height changed
            if (ratio !== 1) {
                var canvasData;
                var cropBoxData;
                if (options.restore) {
                    canvasData = this.getCanvasData();
                    cropBoxData = this.getCropBoxData();
                }
                this.render();
                if (options.restore) {
                    this.setCanvasData(forEach(canvasData, function(n, i) {
                        canvasData[i] = n * ratio;
                    }));
                    this.setCropBoxData(forEach(cropBoxData, function(n, i) {
                        cropBoxData[i] = n * ratio;
                    }));
                }
            }
        },
        dblclick: function dblclick() {
            if (this.disabled || this.options.dragMode === DRAG_MODE_NONE) return;
            this.setDragMode(hasClass(this.dragBox, CLASS_CROP) ? DRAG_MODE_MOVE : DRAG_MODE_CROP);
        },
        wheel: function wheel(event) {
            var _this = this;
            var ratio = Number(this.options.wheelZoomRatio) || 0.1;
            var delta = 1;
            if (this.disabled) return;
            event.preventDefault();
            // Limit wheel speed to prevent zoom too fast (#21)
            if (this.wheeling) return;
            this.wheeling = true;
            setTimeout(function() {
                _this.wheeling = false;
            }, 50);
            if (event.deltaY) delta = event.deltaY > 0 ? 1 : -1;
            else if (event.wheelDelta) delta = -event.wheelDelta / 120;
            else if (event.detail) delta = event.detail > 0 ? 1 : -1;
            this.zoom(-delta * ratio, event);
        },
        cropStart: function cropStart(event) {
            var buttons = event.buttons, button = event.button;
            if (this.disabled || (event.type === 'mousedown' || event.type === 'pointerdown' && event.pointerType === 'mouse') && // No primary button (Usually the left button)
            (isNumber(buttons) && buttons !== 1 || isNumber(button) && button !== 0 || event.ctrlKey)) return;
            var options = this.options, pointers = this.pointers;
            var action;
            if (event.changedTouches) // Handle touch event
            forEach(event.changedTouches, function(touch) {
                pointers[touch.identifier] = getPointer(touch);
            });
            else // Handle mouse event and pointer event
            pointers[event.pointerId || 0] = getPointer(event);
            if (Object.keys(pointers).length > 1 && options.zoomable && options.zoomOnTouch) action = ACTION_ZOOM;
            else action = getData(event.target, DATA_ACTION);
            if (!REGEXP_ACTIONS.test(action)) return;
            if (dispatchEvent(this.element, EVENT_CROP_START, {
                originalEvent: event,
                action: action
            }) === false) return;
            // This line is required for preventing page zooming in iOS browsers
            event.preventDefault();
            this.action = action;
            this.cropping = false;
            if (action === ACTION_CROP) {
                this.cropping = true;
                addClass(this.dragBox, CLASS_MODAL);
            }
        },
        cropMove: function cropMove(event) {
            var action = this.action;
            if (this.disabled || !action) return;
            var pointers = this.pointers;
            event.preventDefault();
            if (dispatchEvent(this.element, EVENT_CROP_MOVE, {
                originalEvent: event,
                action: action
            }) === false) return;
            if (event.changedTouches) forEach(event.changedTouches, function(touch) {
                // The first parameter should not be undefined (#432)
                assign(pointers[touch.identifier] || {}, getPointer(touch, true));
            });
            else assign(pointers[event.pointerId || 0] || {}, getPointer(event, true));
            this.change(event);
        },
        cropEnd: function cropEnd(event) {
            if (this.disabled) return;
            var action = this.action, pointers = this.pointers;
            if (event.changedTouches) forEach(event.changedTouches, function(touch) {
                delete pointers[touch.identifier];
            });
            else delete pointers[event.pointerId || 0];
            if (!action) return;
            event.preventDefault();
            if (!Object.keys(pointers).length) this.action = '';
            if (this.cropping) {
                this.cropping = false;
                toggleClass(this.dragBox, CLASS_MODAL, this.cropped && this.options.modal);
            }
            dispatchEvent(this.element, EVENT_CROP_END, {
                originalEvent: event,
                action: action
            });
        }
    };
    var change = {
        change: function change(event) {
            var options = this.options, canvasData = this.canvasData, containerData = this.containerData, cropBoxData = this.cropBoxData, pointers = this.pointers;
            var action = this.action;
            var aspectRatio = options.aspectRatio;
            var left = cropBoxData.left, top = cropBoxData.top, width = cropBoxData.width, height = cropBoxData.height;
            var right = left + width;
            var bottom = top + height;
            var minLeft = 0;
            var minTop = 0;
            var maxWidth = containerData.width;
            var maxHeight = containerData.height;
            var renderable = true;
            var offset;
            // Locking aspect ratio in "free mode" by holding shift key
            if (!aspectRatio && event.shiftKey) aspectRatio = width && height ? width / height : 1;
            if (this.limited) {
                minLeft = cropBoxData.minLeft;
                minTop = cropBoxData.minTop;
                maxWidth = minLeft + Math.min(containerData.width, canvasData.width, canvasData.left + canvasData.width);
                maxHeight = minTop + Math.min(containerData.height, canvasData.height, canvasData.top + canvasData.height);
            }
            var pointer = pointers[Object.keys(pointers)[0]];
            var range = {
                x: pointer.endX - pointer.startX,
                y: pointer.endY - pointer.startY
            };
            var check = function check(side) {
                switch(side){
                    case ACTION_EAST:
                        if (right + range.x > maxWidth) range.x = maxWidth - right;
                        break;
                    case ACTION_WEST:
                        if (left + range.x < minLeft) range.x = minLeft - left;
                        break;
                    case ACTION_NORTH:
                        if (top + range.y < minTop) range.y = minTop - top;
                        break;
                    case ACTION_SOUTH:
                        if (bottom + range.y > maxHeight) range.y = maxHeight - bottom;
                        break;
                }
            };
            switch(action){
                // Move crop box
                case ACTION_ALL:
                    left += range.x;
                    top += range.y;
                    break;
                // Resize crop box
                case ACTION_EAST:
                    if (range.x >= 0 && (right >= maxWidth || aspectRatio && (top <= minTop || bottom >= maxHeight))) {
                        renderable = false;
                        break;
                    }
                    check(ACTION_EAST);
                    width += range.x;
                    if (width < 0) {
                        action = ACTION_WEST;
                        width = -width;
                        left -= width;
                    }
                    if (aspectRatio) {
                        height = width / aspectRatio;
                        top += (cropBoxData.height - height) / 2;
                    }
                    break;
                case ACTION_NORTH:
                    if (range.y <= 0 && (top <= minTop || aspectRatio && (left <= minLeft || right >= maxWidth))) {
                        renderable = false;
                        break;
                    }
                    check(ACTION_NORTH);
                    height -= range.y;
                    top += range.y;
                    if (height < 0) {
                        action = ACTION_SOUTH;
                        height = -height;
                        top -= height;
                    }
                    if (aspectRatio) {
                        width = height * aspectRatio;
                        left += (cropBoxData.width - width) / 2;
                    }
                    break;
                case ACTION_WEST:
                    if (range.x <= 0 && (left <= minLeft || aspectRatio && (top <= minTop || bottom >= maxHeight))) {
                        renderable = false;
                        break;
                    }
                    check(ACTION_WEST);
                    width -= range.x;
                    left += range.x;
                    if (width < 0) {
                        action = ACTION_EAST;
                        width = -width;
                        left -= width;
                    }
                    if (aspectRatio) {
                        height = width / aspectRatio;
                        top += (cropBoxData.height - height) / 2;
                    }
                    break;
                case ACTION_SOUTH:
                    if (range.y >= 0 && (bottom >= maxHeight || aspectRatio && (left <= minLeft || right >= maxWidth))) {
                        renderable = false;
                        break;
                    }
                    check(ACTION_SOUTH);
                    height += range.y;
                    if (height < 0) {
                        action = ACTION_NORTH;
                        height = -height;
                        top -= height;
                    }
                    if (aspectRatio) {
                        width = height * aspectRatio;
                        left += (cropBoxData.width - width) / 2;
                    }
                    break;
                case ACTION_NORTH_EAST:
                    if (aspectRatio) {
                        if (range.y <= 0 && (top <= minTop || right >= maxWidth)) {
                            renderable = false;
                            break;
                        }
                        check(ACTION_NORTH);
                        height -= range.y;
                        top += range.y;
                        width = height * aspectRatio;
                    } else {
                        check(ACTION_NORTH);
                        check(ACTION_EAST);
                        if (range.x >= 0) {
                            if (right < maxWidth) width += range.x;
                            else if (range.y <= 0 && top <= minTop) renderable = false;
                        } else width += range.x;
                        if (range.y <= 0) {
                            if (top > minTop) {
                                height -= range.y;
                                top += range.y;
                            }
                        } else {
                            height -= range.y;
                            top += range.y;
                        }
                    }
                    if (width < 0 && height < 0) {
                        action = ACTION_SOUTH_WEST;
                        height = -height;
                        width = -width;
                        top -= height;
                        left -= width;
                    } else if (width < 0) {
                        action = ACTION_NORTH_WEST;
                        width = -width;
                        left -= width;
                    } else if (height < 0) {
                        action = ACTION_SOUTH_EAST;
                        height = -height;
                        top -= height;
                    }
                    break;
                case ACTION_NORTH_WEST:
                    if (aspectRatio) {
                        if (range.y <= 0 && (top <= minTop || left <= minLeft)) {
                            renderable = false;
                            break;
                        }
                        check(ACTION_NORTH);
                        height -= range.y;
                        top += range.y;
                        width = height * aspectRatio;
                        left += cropBoxData.width - width;
                    } else {
                        check(ACTION_NORTH);
                        check(ACTION_WEST);
                        if (range.x <= 0) {
                            if (left > minLeft) {
                                width -= range.x;
                                left += range.x;
                            } else if (range.y <= 0 && top <= minTop) renderable = false;
                        } else {
                            width -= range.x;
                            left += range.x;
                        }
                        if (range.y <= 0) {
                            if (top > minTop) {
                                height -= range.y;
                                top += range.y;
                            }
                        } else {
                            height -= range.y;
                            top += range.y;
                        }
                    }
                    if (width < 0 && height < 0) {
                        action = ACTION_SOUTH_EAST;
                        height = -height;
                        width = -width;
                        top -= height;
                        left -= width;
                    } else if (width < 0) {
                        action = ACTION_NORTH_EAST;
                        width = -width;
                        left -= width;
                    } else if (height < 0) {
                        action = ACTION_SOUTH_WEST;
                        height = -height;
                        top -= height;
                    }
                    break;
                case ACTION_SOUTH_WEST:
                    if (aspectRatio) {
                        if (range.x <= 0 && (left <= minLeft || bottom >= maxHeight)) {
                            renderable = false;
                            break;
                        }
                        check(ACTION_WEST);
                        width -= range.x;
                        left += range.x;
                        height = width / aspectRatio;
                    } else {
                        check(ACTION_SOUTH);
                        check(ACTION_WEST);
                        if (range.x <= 0) {
                            if (left > minLeft) {
                                width -= range.x;
                                left += range.x;
                            } else if (range.y >= 0 && bottom >= maxHeight) renderable = false;
                        } else {
                            width -= range.x;
                            left += range.x;
                        }
                        if (range.y >= 0) {
                            if (bottom < maxHeight) height += range.y;
                        } else height += range.y;
                    }
                    if (width < 0 && height < 0) {
                        action = ACTION_NORTH_EAST;
                        height = -height;
                        width = -width;
                        top -= height;
                        left -= width;
                    } else if (width < 0) {
                        action = ACTION_SOUTH_EAST;
                        width = -width;
                        left -= width;
                    } else if (height < 0) {
                        action = ACTION_NORTH_WEST;
                        height = -height;
                        top -= height;
                    }
                    break;
                case ACTION_SOUTH_EAST:
                    if (aspectRatio) {
                        if (range.x >= 0 && (right >= maxWidth || bottom >= maxHeight)) {
                            renderable = false;
                            break;
                        }
                        check(ACTION_EAST);
                        width += range.x;
                        height = width / aspectRatio;
                    } else {
                        check(ACTION_SOUTH);
                        check(ACTION_EAST);
                        if (range.x >= 0) {
                            if (right < maxWidth) width += range.x;
                            else if (range.y >= 0 && bottom >= maxHeight) renderable = false;
                        } else width += range.x;
                        if (range.y >= 0) {
                            if (bottom < maxHeight) height += range.y;
                        } else height += range.y;
                    }
                    if (width < 0 && height < 0) {
                        action = ACTION_NORTH_WEST;
                        height = -height;
                        width = -width;
                        top -= height;
                        left -= width;
                    } else if (width < 0) {
                        action = ACTION_SOUTH_WEST;
                        width = -width;
                        left -= width;
                    } else if (height < 0) {
                        action = ACTION_NORTH_EAST;
                        height = -height;
                        top -= height;
                    }
                    break;
                // Move canvas
                case ACTION_MOVE:
                    this.move(range.x, range.y);
                    renderable = false;
                    break;
                // Zoom canvas
                case ACTION_ZOOM:
                    this.zoom(getMaxZoomRatio(pointers), event);
                    renderable = false;
                    break;
                // Create crop box
                case ACTION_CROP:
                    if (!range.x || !range.y) {
                        renderable = false;
                        break;
                    }
                    offset = getOffset(this.cropper);
                    left = pointer.startX - offset.left;
                    top = pointer.startY - offset.top;
                    width = cropBoxData.minWidth;
                    height = cropBoxData.minHeight;
                    if (range.x > 0) action = range.y > 0 ? ACTION_SOUTH_EAST : ACTION_NORTH_EAST;
                    else if (range.x < 0) {
                        left -= width;
                        action = range.y > 0 ? ACTION_SOUTH_WEST : ACTION_NORTH_WEST;
                    }
                    if (range.y < 0) top -= height;
                    // Show the crop box if is hidden
                    if (!this.cropped) {
                        removeClass(this.cropBox, CLASS_HIDDEN);
                        this.cropped = true;
                        if (this.limited) this.limitCropBox(true, true);
                    }
                    break;
            }
            if (renderable) {
                cropBoxData.width = width;
                cropBoxData.height = height;
                cropBoxData.left = left;
                cropBoxData.top = top;
                this.action = action;
                this.renderCropBox();
            }
            // Override
            forEach(pointers, function(p) {
                p.startX = p.endX;
                p.startY = p.endY;
            });
        }
    };
    var methods = {
        // Show the crop box manually
        crop: function crop() {
            if (this.ready && !this.cropped && !this.disabled) {
                this.cropped = true;
                this.limitCropBox(true, true);
                if (this.options.modal) addClass(this.dragBox, CLASS_MODAL);
                removeClass(this.cropBox, CLASS_HIDDEN);
                this.setCropBoxData(this.initialCropBoxData);
            }
            return this;
        },
        // Reset the image and crop box to their initial states
        reset: function reset() {
            if (this.ready && !this.disabled) {
                this.imageData = assign({}, this.initialImageData);
                this.canvasData = assign({}, this.initialCanvasData);
                this.cropBoxData = assign({}, this.initialCropBoxData);
                this.renderCanvas();
                if (this.cropped) this.renderCropBox();
            }
            return this;
        },
        // Clear the crop box
        clear: function clear() {
            if (this.cropped && !this.disabled) {
                assign(this.cropBoxData, {
                    left: 0,
                    top: 0,
                    width: 0,
                    height: 0
                });
                this.cropped = false;
                this.renderCropBox();
                this.limitCanvas(true, true);
                // Render canvas after crop box rendered
                this.renderCanvas();
                removeClass(this.dragBox, CLASS_MODAL);
                addClass(this.cropBox, CLASS_HIDDEN);
            }
            return this;
        },
        /**
     * Replace the image's src and rebuild the cropper
     * @param {string} url - The new URL.
     * @param {boolean} [hasSameSize] - Indicate if the new image has the same size as the old one.
     * @returns {Cropper} this
     */ replace: function replace(url) {
            var hasSameSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            if (!this.disabled && url) {
                if (this.isImg) this.element.src = url;
                if (hasSameSize) {
                    this.url = url;
                    this.image.src = url;
                    if (this.ready) {
                        this.viewBoxImage.src = url;
                        forEach(this.previews, function(element) {
                            element.getElementsByTagName('img')[0].src = url;
                        });
                    }
                } else {
                    if (this.isImg) this.replaced = true;
                    this.options.data = null;
                    this.uncreate();
                    this.load(url);
                }
            }
            return this;
        },
        // Enable (unfreeze) the cropper
        enable: function enable() {
            if (this.ready && this.disabled) {
                this.disabled = false;
                removeClass(this.cropper, CLASS_DISABLED);
            }
            return this;
        },
        // Disable (freeze) the cropper
        disable: function disable() {
            if (this.ready && !this.disabled) {
                this.disabled = true;
                addClass(this.cropper, CLASS_DISABLED);
            }
            return this;
        },
        /**
     * Destroy the cropper and remove the instance from the image
     * @returns {Cropper} this
     */ destroy: function destroy() {
            var element = this.element;
            if (!element[NAMESPACE]) return this;
            element[NAMESPACE] = undefined;
            if (this.isImg && this.replaced) element.src = this.originalUrl;
            this.uncreate();
            return this;
        },
        /**
     * Move the canvas with relative offsets
     * @param {number} offsetX - The relative offset distance on the x-axis.
     * @param {number} [offsetY=offsetX] - The relative offset distance on the y-axis.
     * @returns {Cropper} this
     */ move: function move(offsetX) {
            var offsetY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : offsetX;
            var _this$canvasData = this.canvasData, left = _this$canvasData.left, top = _this$canvasData.top;
            return this.moveTo(isUndefined(offsetX) ? offsetX : left + Number(offsetX), isUndefined(offsetY) ? offsetY : top + Number(offsetY));
        },
        /**
     * Move the canvas to an absolute point
     * @param {number} x - The x-axis coordinate.
     * @param {number} [y=x] - The y-axis coordinate.
     * @returns {Cropper} this
     */ moveTo: function moveTo(x) {
            var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;
            var canvasData = this.canvasData;
            var changed = false;
            x = Number(x);
            y = Number(y);
            if (this.ready && !this.disabled && this.options.movable) {
                if (isNumber(x)) {
                    canvasData.left = x;
                    changed = true;
                }
                if (isNumber(y)) {
                    canvasData.top = y;
                    changed = true;
                }
                if (changed) this.renderCanvas(true);
            }
            return this;
        },
        /**
     * Zoom the canvas with a relative ratio
     * @param {number} ratio - The target ratio.
     * @param {Event} _originalEvent - The original event if any.
     * @returns {Cropper} this
     */ zoom: function zoom(ratio, _originalEvent) {
            var canvasData = this.canvasData;
            ratio = Number(ratio);
            if (ratio < 0) ratio = 1 / (1 - ratio);
            else ratio = 1 + ratio;
            return this.zoomTo(canvasData.width * ratio / canvasData.naturalWidth, null, _originalEvent);
        },
        /**
     * Zoom the canvas to an absolute ratio
     * @param {number} ratio - The target ratio.
     * @param {Object} pivot - The zoom pivot point coordinate.
     * @param {Event} _originalEvent - The original event if any.
     * @returns {Cropper} this
     */ zoomTo: function zoomTo(ratio, pivot, _originalEvent) {
            var options = this.options, canvasData = this.canvasData;
            var width = canvasData.width, height = canvasData.height, naturalWidth = canvasData.naturalWidth, naturalHeight = canvasData.naturalHeight;
            ratio = Number(ratio);
            if (ratio >= 0 && this.ready && !this.disabled && options.zoomable) {
                var newWidth = naturalWidth * ratio;
                var newHeight = naturalHeight * ratio;
                if (dispatchEvent(this.element, EVENT_ZOOM, {
                    ratio: ratio,
                    oldRatio: width / naturalWidth,
                    originalEvent: _originalEvent
                }) === false) return this;
                if (_originalEvent) {
                    var pointers = this.pointers;
                    var offset = getOffset(this.cropper);
                    var center = pointers && Object.keys(pointers).length ? getPointersCenter(pointers) : {
                        pageX: _originalEvent.pageX,
                        pageY: _originalEvent.pageY
                    };
                    // Zoom from the triggering point of the event
                    canvasData.left -= (newWidth - width) * ((center.pageX - offset.left - canvasData.left) / width);
                    canvasData.top -= (newHeight - height) * ((center.pageY - offset.top - canvasData.top) / height);
                } else if (isPlainObject(pivot) && isNumber(pivot.x) && isNumber(pivot.y)) {
                    canvasData.left -= (newWidth - width) * ((pivot.x - canvasData.left) / width);
                    canvasData.top -= (newHeight - height) * ((pivot.y - canvasData.top) / height);
                } else {
                    // Zoom from the center of the canvas
                    canvasData.left -= (newWidth - width) / 2;
                    canvasData.top -= (newHeight - height) / 2;
                }
                canvasData.width = newWidth;
                canvasData.height = newHeight;
                this.renderCanvas(true);
            }
            return this;
        },
        /**
     * Rotate the canvas with a relative degree
     * @param {number} degree - The rotate degree.
     * @returns {Cropper} this
     */ rotate: function rotate(degree) {
            return this.rotateTo((this.imageData.rotate || 0) + Number(degree));
        },
        /**
     * Rotate the canvas to an absolute degree
     * @param {number} degree - The rotate degree.
     * @returns {Cropper} this
     */ rotateTo: function rotateTo(degree) {
            degree = Number(degree);
            if (isNumber(degree) && this.ready && !this.disabled && this.options.rotatable) {
                this.imageData.rotate = degree % 360;
                this.renderCanvas(true, true);
            }
            return this;
        },
        /**
     * Scale the image on the x-axis.
     * @param {number} scaleX - The scale ratio on the x-axis.
     * @returns {Cropper} this
     */ scaleX: function scaleX(_scaleX) {
            var scaleY = this.imageData.scaleY;
            return this.scale(_scaleX, isNumber(scaleY) ? scaleY : 1);
        },
        /**
     * Scale the image on the y-axis.
     * @param {number} scaleY - The scale ratio on the y-axis.
     * @returns {Cropper} this
     */ scaleY: function scaleY(_scaleY) {
            var scaleX = this.imageData.scaleX;
            return this.scale(isNumber(scaleX) ? scaleX : 1, _scaleY);
        },
        /**
     * Scale the image
     * @param {number} scaleX - The scale ratio on the x-axis.
     * @param {number} [scaleY=scaleX] - The scale ratio on the y-axis.
     * @returns {Cropper} this
     */ scale: function scale(scaleX) {
            var scaleY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : scaleX;
            var imageData = this.imageData;
            var transformed = false;
            scaleX = Number(scaleX);
            scaleY = Number(scaleY);
            if (this.ready && !this.disabled && this.options.scalable) {
                if (isNumber(scaleX)) {
                    imageData.scaleX = scaleX;
                    transformed = true;
                }
                if (isNumber(scaleY)) {
                    imageData.scaleY = scaleY;
                    transformed = true;
                }
                if (transformed) this.renderCanvas(true, true);
            }
            return this;
        },
        /**
     * Get the cropped area position and size data (base on the original image)
     * @param {boolean} [rounded=false] - Indicate if round the data values or not.
     * @returns {Object} The result cropped data.
     */ getData: function getData() {
            var rounded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var options = this.options, imageData = this.imageData, canvasData = this.canvasData, cropBoxData = this.cropBoxData;
            var data;
            if (this.ready && this.cropped) {
                data = {
                    x: cropBoxData.left - canvasData.left,
                    y: cropBoxData.top - canvasData.top,
                    width: cropBoxData.width,
                    height: cropBoxData.height
                };
                var ratio = imageData.width / imageData.naturalWidth;
                forEach(data, function(n, i) {
                    data[i] = n / ratio;
                });
                if (rounded) {
                    // In case rounding off leads to extra 1px in right or bottom border
                    // we should round the top-left corner and the dimension (#343).
                    var bottom = Math.round(data.y + data.height);
                    var right = Math.round(data.x + data.width);
                    data.x = Math.round(data.x);
                    data.y = Math.round(data.y);
                    data.width = right - data.x;
                    data.height = bottom - data.y;
                }
            } else data = {
                x: 0,
                y: 0,
                width: 0,
                height: 0
            };
            if (options.rotatable) data.rotate = imageData.rotate || 0;
            if (options.scalable) {
                data.scaleX = imageData.scaleX || 1;
                data.scaleY = imageData.scaleY || 1;
            }
            return data;
        },
        /**
     * Set the cropped area position and size with new data
     * @param {Object} data - The new data.
     * @returns {Cropper} this
     */ setData: function setData(data) {
            var options = this.options, imageData = this.imageData, canvasData = this.canvasData;
            var cropBoxData = {};
            if (this.ready && !this.disabled && isPlainObject(data)) {
                var transformed = false;
                if (options.rotatable) {
                    if (isNumber(data.rotate) && data.rotate !== imageData.rotate) {
                        imageData.rotate = data.rotate;
                        transformed = true;
                    }
                }
                if (options.scalable) {
                    if (isNumber(data.scaleX) && data.scaleX !== imageData.scaleX) {
                        imageData.scaleX = data.scaleX;
                        transformed = true;
                    }
                    if (isNumber(data.scaleY) && data.scaleY !== imageData.scaleY) {
                        imageData.scaleY = data.scaleY;
                        transformed = true;
                    }
                }
                if (transformed) this.renderCanvas(true, true);
                var ratio = imageData.width / imageData.naturalWidth;
                if (isNumber(data.x)) cropBoxData.left = data.x * ratio + canvasData.left;
                if (isNumber(data.y)) cropBoxData.top = data.y * ratio + canvasData.top;
                if (isNumber(data.width)) cropBoxData.width = data.width * ratio;
                if (isNumber(data.height)) cropBoxData.height = data.height * ratio;
                this.setCropBoxData(cropBoxData);
            }
            return this;
        },
        /**
     * Get the container size data.
     * @returns {Object} The result container data.
     */ getContainerData: function getContainerData() {
            return this.ready ? assign({}, this.containerData) : {};
        },
        /**
     * Get the image position and size data.
     * @returns {Object} The result image data.
     */ getImageData: function getImageData() {
            return this.sized ? assign({}, this.imageData) : {};
        },
        /**
     * Get the canvas position and size data.
     * @returns {Object} The result canvas data.
     */ getCanvasData: function getCanvasData() {
            var canvasData = this.canvasData;
            var data = {};
            if (this.ready) forEach([
                'left',
                'top',
                'width',
                'height',
                'naturalWidth',
                'naturalHeight'
            ], function(n) {
                data[n] = canvasData[n];
            });
            return data;
        },
        /**
     * Set the canvas position and size with new data.
     * @param {Object} data - The new canvas data.
     * @returns {Cropper} this
     */ setCanvasData: function setCanvasData(data) {
            var canvasData = this.canvasData;
            var aspectRatio = canvasData.aspectRatio;
            if (this.ready && !this.disabled && isPlainObject(data)) {
                if (isNumber(data.left)) canvasData.left = data.left;
                if (isNumber(data.top)) canvasData.top = data.top;
                if (isNumber(data.width)) {
                    canvasData.width = data.width;
                    canvasData.height = data.width / aspectRatio;
                } else if (isNumber(data.height)) {
                    canvasData.height = data.height;
                    canvasData.width = data.height * aspectRatio;
                }
                this.renderCanvas(true);
            }
            return this;
        },
        /**
     * Get the crop box position and size data.
     * @returns {Object} The result crop box data.
     */ getCropBoxData: function getCropBoxData() {
            var cropBoxData = this.cropBoxData;
            var data;
            if (this.ready && this.cropped) data = {
                left: cropBoxData.left,
                top: cropBoxData.top,
                width: cropBoxData.width,
                height: cropBoxData.height
            };
            return data || {};
        },
        /**
     * Set the crop box position and size with new data.
     * @param {Object} data - The new crop box data.
     * @returns {Cropper} this
     */ setCropBoxData: function setCropBoxData(data) {
            var cropBoxData = this.cropBoxData;
            var aspectRatio = this.options.aspectRatio;
            var widthChanged;
            var heightChanged;
            if (this.ready && this.cropped && !this.disabled && isPlainObject(data)) {
                if (isNumber(data.left)) cropBoxData.left = data.left;
                if (isNumber(data.top)) cropBoxData.top = data.top;
                if (isNumber(data.width) && data.width !== cropBoxData.width) {
                    widthChanged = true;
                    cropBoxData.width = data.width;
                }
                if (isNumber(data.height) && data.height !== cropBoxData.height) {
                    heightChanged = true;
                    cropBoxData.height = data.height;
                }
                if (aspectRatio) {
                    if (widthChanged) cropBoxData.height = cropBoxData.width / aspectRatio;
                    else if (heightChanged) cropBoxData.width = cropBoxData.height * aspectRatio;
                }
                this.renderCropBox();
            }
            return this;
        },
        /**
     * Get a canvas drawn the cropped image.
     * @param {Object} [options={}] - The config options.
     * @returns {HTMLCanvasElement} - The result canvas.
     */ getCroppedCanvas: function getCroppedCanvas() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (!this.ready || !window.HTMLCanvasElement) return null;
            var canvasData = this.canvasData;
            var source = getSourceCanvas(this.image, this.imageData, canvasData, options);
            // Returns the source canvas if it is not cropped.
            if (!this.cropped) return source;
            var _this$getData = this.getData(options.rounded), initialX = _this$getData.x, initialY = _this$getData.y, initialWidth = _this$getData.width, initialHeight = _this$getData.height;
            var ratio = source.width / Math.floor(canvasData.naturalWidth);
            if (ratio !== 1) {
                initialX *= ratio;
                initialY *= ratio;
                initialWidth *= ratio;
                initialHeight *= ratio;
            }
            var aspectRatio = initialWidth / initialHeight;
            var maxSizes = getAdjustedSizes({
                aspectRatio: aspectRatio,
                width: options.maxWidth || Infinity,
                height: options.maxHeight || Infinity
            });
            var minSizes = getAdjustedSizes({
                aspectRatio: aspectRatio,
                width: options.minWidth || 0,
                height: options.minHeight || 0
            }, 'cover');
            var _getAdjustedSizes = getAdjustedSizes({
                aspectRatio: aspectRatio,
                width: options.width || (ratio !== 1 ? source.width : initialWidth),
                height: options.height || (ratio !== 1 ? source.height : initialHeight)
            }), width = _getAdjustedSizes.width, height = _getAdjustedSizes.height;
            width = Math.min(maxSizes.width, Math.max(minSizes.width, width));
            height = Math.min(maxSizes.height, Math.max(minSizes.height, height));
            var canvas = document.createElement('canvas');
            var context = canvas.getContext('2d');
            canvas.width = normalizeDecimalNumber(width);
            canvas.height = normalizeDecimalNumber(height);
            context.fillStyle = options.fillColor || 'transparent';
            context.fillRect(0, 0, width, height);
            var _options$imageSmoothi = options.imageSmoothingEnabled, imageSmoothingEnabled = _options$imageSmoothi === void 0 ? true : _options$imageSmoothi, imageSmoothingQuality = options.imageSmoothingQuality;
            context.imageSmoothingEnabled = imageSmoothingEnabled;
            if (imageSmoothingQuality) context.imageSmoothingQuality = imageSmoothingQuality;
            // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D.drawImage
            var sourceWidth = source.width;
            var sourceHeight = source.height;
            // Source canvas parameters
            var srcX = initialX;
            var srcY = initialY;
            var srcWidth;
            var srcHeight;
            // Destination canvas parameters
            var dstX;
            var dstY;
            var dstWidth;
            var dstHeight;
            if (srcX <= -initialWidth || srcX > sourceWidth) {
                srcX = 0;
                srcWidth = 0;
                dstX = 0;
                dstWidth = 0;
            } else if (srcX <= 0) {
                dstX = -srcX;
                srcX = 0;
                srcWidth = Math.min(sourceWidth, initialWidth + srcX);
                dstWidth = srcWidth;
            } else if (srcX <= sourceWidth) {
                dstX = 0;
                srcWidth = Math.min(initialWidth, sourceWidth - srcX);
                dstWidth = srcWidth;
            }
            if (srcWidth <= 0 || srcY <= -initialHeight || srcY > sourceHeight) {
                srcY = 0;
                srcHeight = 0;
                dstY = 0;
                dstHeight = 0;
            } else if (srcY <= 0) {
                dstY = -srcY;
                srcY = 0;
                srcHeight = Math.min(sourceHeight, initialHeight + srcY);
                dstHeight = srcHeight;
            } else if (srcY <= sourceHeight) {
                dstY = 0;
                srcHeight = Math.min(initialHeight, sourceHeight - srcY);
                dstHeight = srcHeight;
            }
            var params = [
                srcX,
                srcY,
                srcWidth,
                srcHeight
            ];
            // Avoid "IndexSizeError"
            if (dstWidth > 0 && dstHeight > 0) {
                var scale = width / initialWidth;
                params.push(dstX * scale, dstY * scale, dstWidth * scale, dstHeight * scale);
            }
            // All the numerical parameters should be integer for `drawImage`
            // https://github.com/fengyuanchen/cropper/issues/476
            context.drawImage.apply(context, [
                source
            ].concat(_toConsumableArray(params.map(function(param) {
                return Math.floor(normalizeDecimalNumber(param));
            }))));
            return canvas;
        },
        /**
     * Change the aspect ratio of the crop box.
     * @param {number} aspectRatio - The new aspect ratio.
     * @returns {Cropper} this
     */ setAspectRatio: function setAspectRatio(aspectRatio) {
            var options = this.options;
            if (!this.disabled && !isUndefined(aspectRatio)) {
                // 0 -> NaN
                options.aspectRatio = Math.max(0, aspectRatio) || NaN;
                if (this.ready) {
                    this.initCropBox();
                    if (this.cropped) this.renderCropBox();
                }
            }
            return this;
        },
        /**
     * Change the drag mode.
     * @param {string} mode - The new drag mode.
     * @returns {Cropper} this
     */ setDragMode: function setDragMode(mode) {
            var options = this.options, dragBox = this.dragBox, face = this.face;
            if (this.ready && !this.disabled) {
                var croppable = mode === DRAG_MODE_CROP;
                var movable = options.movable && mode === DRAG_MODE_MOVE;
                mode = croppable || movable ? mode : DRAG_MODE_NONE;
                options.dragMode = mode;
                setData(dragBox, DATA_ACTION, mode);
                toggleClass(dragBox, CLASS_CROP, croppable);
                toggleClass(dragBox, CLASS_MOVE, movable);
                if (!options.cropBoxMovable) {
                    // Sync drag mode to crop box when it is not movable
                    setData(face, DATA_ACTION, mode);
                    toggleClass(face, CLASS_CROP, croppable);
                    toggleClass(face, CLASS_MOVE, movable);
                }
            }
            return this;
        }
    };
    var AnotherCropper = WINDOW.Cropper;
    var Cropper = /*#__PURE__*/ function() {
        /**
     * Create a new Cropper.
     * @param {Element} element - The target element for cropping.
     * @param {Object} [options={}] - The configuration options.
     */ function Cropper(element) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            _classCallCheck(this, Cropper);
            if (!element || !REGEXP_TAG_NAME.test(element.tagName)) throw new Error('The first argument is required and must be an <img> or <canvas> element.');
            this.element = element;
            this.options = assign({}, DEFAULTS, isPlainObject(options) && options);
            this.cropped = false;
            this.disabled = false;
            this.pointers = {};
            this.ready = false;
            this.reloading = false;
            this.replaced = false;
            this.sized = false;
            this.sizing = false;
            this.init();
        }
        return _createClass(Cropper, [
            {
                key: "init",
                value: function init() {
                    var element = this.element;
                    var tagName = element.tagName.toLowerCase();
                    var url;
                    if (element[NAMESPACE]) return;
                    element[NAMESPACE] = this;
                    if (tagName === 'img') {
                        this.isImg = true;
                        // e.g.: "img/picture.jpg"
                        url = element.getAttribute('src') || '';
                        this.originalUrl = url;
                        // Stop when it's a blank image
                        if (!url) return;
                        // e.g.: "https://example.com/img/picture.jpg"
                        url = element.src;
                    } else if (tagName === 'canvas' && window.HTMLCanvasElement) url = element.toDataURL();
                    this.load(url);
                }
            },
            {
                key: "load",
                value: function load(url) {
                    var _this = this;
                    if (!url) return;
                    this.url = url;
                    this.imageData = {};
                    var element = this.element, options = this.options;
                    if (!options.rotatable && !options.scalable) options.checkOrientation = false;
                    // Only IE10+ supports Typed Arrays
                    if (!options.checkOrientation || !window.ArrayBuffer) {
                        this.clone();
                        return;
                    }
                    // Detect the mime type of the image directly if it is a Data URL
                    if (REGEXP_DATA_URL.test(url)) {
                        // Read ArrayBuffer from Data URL of JPEG images directly for better performance
                        if (REGEXP_DATA_URL_JPEG.test(url)) this.read(dataURLToArrayBuffer(url));
                        else // Only a JPEG image may contains Exif Orientation information,
                        // the rest types of Data URLs are not necessary to check orientation at all.
                        this.clone();
                        return;
                    }
                    // 1. Detect the mime type of the image by a XMLHttpRequest.
                    // 2. Load the image as ArrayBuffer for reading orientation if its a JPEG image.
                    var xhr = new XMLHttpRequest();
                    var clone = this.clone.bind(this);
                    this.reloading = true;
                    this.xhr = xhr;
                    // 1. Cross origin requests are only supported for protocol schemes:
                    // http, https, data, chrome, chrome-extension.
                    // 2. Access to XMLHttpRequest from a Data URL will be blocked by CORS policy
                    // in some browsers as IE11 and Safari.
                    xhr.onabort = clone;
                    xhr.onerror = clone;
                    xhr.ontimeout = clone;
                    xhr.onprogress = function() {
                        // Abort the request directly if it not a JPEG image for better performance
                        if (xhr.getResponseHeader('content-type') !== MIME_TYPE_JPEG) xhr.abort();
                    };
                    xhr.onload = function() {
                        _this.read(xhr.response);
                    };
                    xhr.onloadend = function() {
                        _this.reloading = false;
                        _this.xhr = null;
                    };
                    // Bust cache when there is a "crossOrigin" property to avoid browser cache error
                    if (options.checkCrossOrigin && isCrossOriginURL(url) && element.crossOrigin) url = addTimestamp(url);
                    // The third parameter is required for avoiding side-effect (#682)
                    xhr.open('GET', url, true);
                    xhr.responseType = 'arraybuffer';
                    xhr.withCredentials = element.crossOrigin === 'use-credentials';
                    xhr.send();
                }
            },
            {
                key: "read",
                value: function read(arrayBuffer) {
                    var options = this.options, imageData = this.imageData;
                    // Reset the orientation value to its default value 1
                    // as some iOS browsers will render image with its orientation
                    var orientation = resetAndGetOrientation(arrayBuffer);
                    var rotate = 0;
                    var scaleX = 1;
                    var scaleY = 1;
                    if (orientation > 1) {
                        // Generate a new URL which has the default orientation value
                        this.url = arrayBufferToDataURL(arrayBuffer, MIME_TYPE_JPEG);
                        var _parseOrientation = parseOrientation(orientation);
                        rotate = _parseOrientation.rotate;
                        scaleX = _parseOrientation.scaleX;
                        scaleY = _parseOrientation.scaleY;
                    }
                    if (options.rotatable) imageData.rotate = rotate;
                    if (options.scalable) {
                        imageData.scaleX = scaleX;
                        imageData.scaleY = scaleY;
                    }
                    this.clone();
                }
            },
            {
                key: "clone",
                value: function clone() {
                    var element = this.element, url = this.url;
                    var crossOrigin = element.crossOrigin;
                    var crossOriginUrl = url;
                    if (this.options.checkCrossOrigin && isCrossOriginURL(url)) {
                        if (!crossOrigin) crossOrigin = 'anonymous';
                        // Bust cache when there is not a "crossOrigin" property (#519)
                        crossOriginUrl = addTimestamp(url);
                    }
                    this.crossOrigin = crossOrigin;
                    this.crossOriginUrl = crossOriginUrl;
                    var image = document.createElement('img');
                    if (crossOrigin) image.crossOrigin = crossOrigin;
                    image.src = crossOriginUrl || url;
                    image.alt = element.alt || 'The image to crop';
                    this.image = image;
                    image.onload = this.start.bind(this);
                    image.onerror = this.stop.bind(this);
                    addClass(image, CLASS_HIDE);
                    element.parentNode.insertBefore(image, element.nextSibling);
                }
            },
            {
                key: "start",
                value: function start() {
                    var _this2 = this;
                    var image = this.image;
                    image.onload = null;
                    image.onerror = null;
                    this.sizing = true;
                    // Match all browsers that use WebKit as the layout engine in iOS devices,
                    // such as Safari for iOS, Chrome for iOS, and in-app browsers.
                    var isIOSWebKit = WINDOW.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(WINDOW.navigator.userAgent);
                    var done = function done(naturalWidth, naturalHeight) {
                        assign(_this2.imageData, {
                            naturalWidth: naturalWidth,
                            naturalHeight: naturalHeight,
                            aspectRatio: naturalWidth / naturalHeight
                        });
                        _this2.initialImageData = assign({}, _this2.imageData);
                        _this2.sizing = false;
                        _this2.sized = true;
                        _this2.build();
                    };
                    // Most modern browsers (excepts iOS WebKit)
                    if (image.naturalWidth && !isIOSWebKit) {
                        done(image.naturalWidth, image.naturalHeight);
                        return;
                    }
                    var sizingImage = document.createElement('img');
                    var body = document.body || document.documentElement;
                    this.sizingImage = sizingImage;
                    sizingImage.onload = function() {
                        done(sizingImage.width, sizingImage.height);
                        if (!isIOSWebKit) body.removeChild(sizingImage);
                    };
                    sizingImage.src = image.src;
                    // iOS WebKit will convert the image automatically
                    // with its orientation once append it into DOM (#279)
                    if (!isIOSWebKit) {
                        sizingImage.style.cssText = "left:0;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;opacity:0;position:absolute;top:0;z-index:-1;";
                        body.appendChild(sizingImage);
                    }
                }
            },
            {
                key: "stop",
                value: function stop() {
                    var image = this.image;
                    image.onload = null;
                    image.onerror = null;
                    image.parentNode.removeChild(image);
                    this.image = null;
                }
            },
            {
                key: "build",
                value: function build() {
                    if (!this.sized || this.ready) return;
                    var element = this.element, options = this.options, image = this.image;
                    // Create cropper elements
                    var container = element.parentNode;
                    var template = document.createElement('div');
                    template.innerHTML = TEMPLATE;
                    var cropper = template.querySelector(".".concat(NAMESPACE, "-container"));
                    var canvas = cropper.querySelector(".".concat(NAMESPACE, "-canvas"));
                    var dragBox = cropper.querySelector(".".concat(NAMESPACE, "-drag-box"));
                    var cropBox = cropper.querySelector(".".concat(NAMESPACE, "-crop-box"));
                    var face = cropBox.querySelector(".".concat(NAMESPACE, "-face"));
                    this.container = container;
                    this.cropper = cropper;
                    this.canvas = canvas;
                    this.dragBox = dragBox;
                    this.cropBox = cropBox;
                    this.viewBox = cropper.querySelector(".".concat(NAMESPACE, "-view-box"));
                    this.face = face;
                    canvas.appendChild(image);
                    // Hide the original image
                    addClass(element, CLASS_HIDDEN);
                    // Inserts the cropper after to the current image
                    container.insertBefore(cropper, element.nextSibling);
                    // Show the hidden image
                    removeClass(image, CLASS_HIDE);
                    this.initPreview();
                    this.bind();
                    options.initialAspectRatio = Math.max(0, options.initialAspectRatio) || NaN;
                    options.aspectRatio = Math.max(0, options.aspectRatio) || NaN;
                    options.viewMode = Math.max(0, Math.min(3, Math.round(options.viewMode))) || 0;
                    addClass(cropBox, CLASS_HIDDEN);
                    if (!options.guides) addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-dashed")), CLASS_HIDDEN);
                    if (!options.center) addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-center")), CLASS_HIDDEN);
                    if (options.background) addClass(cropper, "".concat(NAMESPACE, "-bg"));
                    if (!options.highlight) addClass(face, CLASS_INVISIBLE);
                    if (options.cropBoxMovable) {
                        addClass(face, CLASS_MOVE);
                        setData(face, DATA_ACTION, ACTION_ALL);
                    }
                    if (!options.cropBoxResizable) {
                        addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-line")), CLASS_HIDDEN);
                        addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-point")), CLASS_HIDDEN);
                    }
                    this.render();
                    this.ready = true;
                    this.setDragMode(options.dragMode);
                    if (options.autoCrop) this.crop();
                    this.setData(options.data);
                    if (isFunction(options.ready)) addListener(element, EVENT_READY, options.ready, {
                        once: true
                    });
                    dispatchEvent(element, EVENT_READY);
                }
            },
            {
                key: "unbuild",
                value: function unbuild() {
                    if (!this.ready) return;
                    this.ready = false;
                    this.unbind();
                    this.resetPreview();
                    var parentNode = this.cropper.parentNode;
                    if (parentNode) parentNode.removeChild(this.cropper);
                    removeClass(this.element, CLASS_HIDDEN);
                }
            },
            {
                key: "uncreate",
                value: function uncreate() {
                    if (this.ready) {
                        this.unbuild();
                        this.ready = false;
                        this.cropped = false;
                    } else if (this.sizing) {
                        this.sizingImage.onload = null;
                        this.sizing = false;
                        this.sized = false;
                    } else if (this.reloading) {
                        this.xhr.onabort = null;
                        this.xhr.abort();
                    } else if (this.image) this.stop();
                }
            }
        ], [
            {
                key: "noConflict",
                value: function noConflict() {
                    window.Cropper = AnotherCropper;
                    return Cropper;
                }
            },
            {
                key: "setDefaults",
                value: function setDefaults(options) {
                    assign(DEFAULTS, isPlainObject(options) && options);
                }
            }
        ]);
    }();
    assign(Cropper.prototype, render, preview, events, handlers, change, methods);
    return Cropper;
});

});



parcelRegister("gQOJI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c448dbdfbca91fcd$export$2e2bcd8739ae039; });
class $c448dbdfbca91fcd$export$2e2bcd8739ae039 extends HTMLElement {
    connectedCallback() {
        this.abortController = new AbortController();
        this.#setEventListeners();
    }
    disconnectedCallback() {
        this.abortController.abort();
    }
    #setEventListeners() {
        const hasPhotoDescription = this.hasAttribute('enable-photo-description');
        const descriptionTab = this.querySelector("[data-tab='photo-description']");
        const editorTab = this.querySelector("[data-tab='photo-editor']");
        this.querySelector('.save').addEventListener('click', async ()=>{
            this.querySelectorAll('button').forEach((button)=>{
                button.setAttribute('disabled', '');
            });
            const description = hasPhotoDescription ? this.querySelector('#pictureSubtext')?.value.trim() : '';
            const image = await this.querySelector('peg-photo-editor').saveAsImage();
            this.#trackSave(description);
            await this.querySelector('peg-photo-uploader').startPhotoUpload(image, description);
            this.querySelectorAll('button').forEach((button)=>{
                button.removeAttribute('disabled');
            });
            await this.closest('wdk-dialog').closeModal();
        }, {
            signal: this.abortController?.signal
        });
        if (hasPhotoDescription) {
            this.querySelector('button.continue').addEventListener('click', ()=>{
                editorTab.setAttribute('inert', '');
                descriptionTab.removeAttribute('inert');
            }, {
                signal: this.abortController?.signal
            });
            this.querySelector('button.back').addEventListener('click', ()=>{
                descriptionTab.setAttribute('inert', '');
                editorTab.removeAttribute('inert');
            }, {
                signal: this.abortController?.signal
            });
        }
        this.querySelectorAll('.js-closeDialog').forEach((closeButton)=>{
            closeButton.addEventListener('click', ()=>{
                this.#trackAbort();
            }, {
                signal: this.abortController?.signal
            });
        });
    }
    #trackSave(photoDescription) {
        jPar.util.log.bigData({
            category: this.getAttribute('tracking-category'),
            subcategory: this.getAttribute('tracking-subcategory'),
            targetId: 'button_save',
            action: 'click',
            cd3: photoDescription ? 'with_caption' : 'no_caption'
        });
    }
    #trackAbort() {
        jPar.util.log.bigData({
            category: this.getAttribute('tracking-category'),
            subcategory: this.getAttribute('tracking-subcategory'),
            targetId: 'button_cancel',
            action: 'click'
        });
    }
}

});

parcelRegister("hScTJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0317c150519ccf1$export$2e2bcd8739ae039; });
/**
 * @typedef {Object} ValidityState
 * @property {boolean} badInput - Indicates if the user has provided input that the browser is unable to convert.
 * @property {boolean} customError - Indicates if the element's custom validity message is set.
 * @property {boolean} patternMismatch - Indicates if the value does not match the specified pattern.
 * @property {boolean} rangeOverflow - Indicates if the value is greater than the maximum specified by the max attribute.
 * @property {boolean} rangeUnderflow - Indicates if the value is less than the minimum specified by the min attribute.
 * @property {boolean} stepMismatch - Indicates if the value does not fit the rules provided by the step attribute.
 * @property {boolean} tooLong - Indicates if the value exceeds the specified maxlength.
 * @property {boolean} tooShort - Indicates if the value is less than the specified minlength.
 * @property {boolean} typeMismatch - Indicates if the value is not in the required syntax (e.g., email).
 * @property {boolean} valueMissing - Indicates if a required value is missing.
 * @property {boolean} valid - Indicates if the element meets all its validation constraints.
 */ class $d0317c150519ccf1$export$2e2bcd8739ae039 extends HTMLElement {
    // Can also have server-error | frontend-error | null to indicate the errorType
    static get observedAttributes() {
        return [
            'show'
        ];
    }
    async connectedCallback() {
        this.currentComponent = this;
        this.setAttribute('inert', 'true');
        const myHtml = `<style>
					:host {
						--maxHeight: 300px;
						display: flex;
						flex-shrink: 0;
						align-items: center;
						position: relative;
						color: var(--COLOR_support_white_default);
						border-radius: var(--RADIUS_S);
						height: auto;
						text-align: left;
						max-height: var(--maxHeight);
						opacity: 1;
					}
					
					/* *** skin error *** */
					:host([skin="error"]) {
						display: none;
						margin-top: 8px;
						font: var(--FONT_default_75);
						background-color: var(--COLOR_alert_error_light);
						color: var(--COLOR_alert_error_default);
						overflow: hidden;
						padding: 8px;
						opacity: 0;
						transition: opacity .2s linear, display .3s ease allow-discrete;
					}
					
					:host([skin="error"]) a {
						color: var(--COLOR_alert_error_default);
					}
										
					:host([skin="error"][show]) {
						display: flex;
						opacity: 1;
						
						@starting-style {
							opacity: 0;
						}
					}

					/* *** inFormElement on-brand *** */
					:host([skin="inFormElement"][on-brand]) {
						display: none;
						opacity: 0;
						padding: 4px 8px;
					    gap: 4px;
						overflow: hidden;
						font: var(--FONT_default_50);
						background-color: var(--COLOR_support_black_alpha_54);
						transition: max-height .3s linear, opacity .3s linear, display .3s ease allow-discrete;
					}

					:host([skin="inFormElement"][on-brand][show]) {
						opacity: 1;
						display: flex;
					    
						@starting-style {
							opacity: 0;
						}
					}
					
					:host([skin="inFormElement"][on-brand]) ::slotted([slot="icon"].wdk-icon) {
						width: 14px !important;
						height: 14px !important;
						fill: var(--COLOR_support_white_default) !important;
					}
					
					/* *** inFormElement NOT on-brand *** */
					:host([skin="inFormElement"]:not([on-brand])) {
						display: none;
						opacity: 0;
						overflow: hidden;
						margin: 0;
						padding: 8px;
						font: var(--FONT_default_75);
						color: var(--COLOR_alert_error_default);
						transition: opacity .3s linear, display .3s ease allow-discrete;
					}
					
					:host([skin="inFormElement"][show]:not([on-brand])) {
						display: flex;
						opacity: 1;
						
						@starting-style {
							opacity: 0;
						}
					}
										
					:host([skin="inFormElement"]:not([on-brand])) a {
						color: var(--COLOR_alert_error_default);
					}

					/* *** General *** */
					:host([skin="inFormElement"]:not([on-brand])) ::slotted([slot="icon"].wdk-icon),
					:host([skin="error"]) ::slotted([slot="icon"].wdk-icon) {
						position: absolute;
						left: 8px;
						top: 50%;
						margin-top: -16px;
						padding-right: 8px;
						width: 32px !important;
						height: 32px !important;
						fill: var(--COLOR_alert_error_default) !important;
					}
										
					:host([skin="inFormElement"]:not([on-brand])) slot,
					:host([skin="error"]) slot {
						display: inline-block;
						padding-left: 39px;
					}
					
					:host([skin="inFormElement"]:not([on-brand])) slot.is-empty,
					:host([skin="error"]) slot.is-empty {
						padding-left: 0;
					}
					
					:host .visuallyHidden {
						position: absolute !important;
						left: -10000px;
						top: auto;
						width: 1px;
						height: 1px;
						overflow: hidden;
						clip-path: inset(50%);
					}
					
					:host button {
						position: relative;
						border: none;
						background: transparent;
						cursor: pointer;
						align-self: flex-start;
    					margin: 0;
    					padding: 0;
    					width: 18px;
    					height: 18px;
					}
					
					:host button:focus-visible {
						outline: 2px dashed currentColor;
						outline-offset: 10px;
					}

					:host button:after {
						content: "";
    					position: absolute;
    					top: 50%;
    					left: 50%;
    					transform: translate(-50%, -50%);
    					height: 48px;
    					width: 48px;
					}

					:host button:hover {
						opacity: .7;
					}

					:host button svg {
						width: 16px;
						height: 16px;
						fill: var(--COLOR_gray_100);
					}
					
					#a11yWrapper {
						flex-grow: 1;
					}
					
					.wdkA11yRepeat {
						position:absolute;
						left:-9999px;
						width: 1px;
						height: 1px;
					}
				</style>
				<slot name="icon"></slot>
				<div id="a11yWrapper" aria-live="polite" aria-atomic="true"></div>
				${this.#getCloseButton()}
			`;
        const shadowTemplate = document.createElement('template');
        shadowTemplate.innerHTML = jPar.wdk.security.sanitizeEvilHtml(myHtml);
        const clone = document.importNode(shadowTemplate.content, true);
        if (!this.shadowRoot) {
            this.attachShadow({
                mode: 'open'
            });
            this.shadowRoot.appendChild(clone);
        }
        this.fillA11yWrapper();
        this.handleEmptyIcon(); // Kann initial ja auch schon show sein
        this.shadowRoot.querySelector('.js-close')?.addEventListener('click', ()=>{
            this.hide();
        });
    }
    attributeChangedCallback(name) {
        if (name === 'show') this.fillA11yWrapper();
    }
    #getCloseButton() {
        if (this.getAttribute('closable') !== null) return `<button part="base" class="js-close" type="button" role="button" aria-disabled="false" aria-label="Close" tabindex="0">
        			<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
						<path id="icon_x-a" fill-rule="evenodd" clip-rule="evenodd" d="M19.7044 18.2864C19.8936 18.4741 20 18.7295 20 18.996C20 19.2624 19.8936 19.5179 19.7044 19.7055C19.5168 19.8947 19.2614 20.0011 18.9949 20.0011C18.7285 20.0011 18.4731 19.8947 18.2854 19.7055L12 13.4194L5.71456 19.7055C5.52692 19.8947 5.27151 20.0011 5.00507 20.0011C4.73863 20.0011 4.48321 19.8947 4.29558 19.7055C4.10641 19.5179 4 19.2624 4 18.996C4 18.7295 4.10641 18.4741 4.29558 18.2864L10.581 12.0003L4.29558 5.71418C3.90375 5.3223 3.90375 4.68693 4.29558 4.29505C4.68742 3.90317 5.32272 3.90317 5.71456 4.29505L12 10.5812L18.2854 4.29505C18.6773 3.90317 19.3126 3.90317 19.7044 4.29505C20.0963 4.68693 20.0963 5.3223 19.7044 5.71418L13.419 12.0003L19.7044 18.2864Z"/>
					</svg>
      			</button>
				`;
        else return '';
    }
    fillA11yWrapper() {
        const lightClone = document.importNode(this.querySelector('template').content, true);
        if (this.shadowRoot !== null) {
            this.shadowRoot.querySelector('#a11yWrapper').innerHTML = '';
            this.shadowRoot.querySelector('#a11yWrapper').appendChild(lightClone);
            this.handleReloadLink();
            this.triggerA11yRepeat();
            this.handleShow();
        }
    }
    handleEmptyIcon() {
        const hasEmptySlot = this.shadowRoot.querySelector('slot').assignedElements().length === 0;
        if (hasEmptySlot) this.shadowRoot.querySelector('slot').classList.add('is-empty');
        else this.shadowRoot.querySelector('slot').classList.remove('is-empty');
    }
    show(scrollIntoView = false) {
        this.setAttribute('show', 'true');
        if (scrollIntoView) window.setTimeout(()=>{
            this.scrollIntoView({
                behavior: 'smooth',
                block: 'end'
            });
        }, 300); // after Animation... not very elegant but ok
    }
    handleShow() {
        if (this.hasAttribute('show')) {
            this.removeAttribute('inert');
            this.dispatchEvent(new CustomEvent('wdk-hintbox-error', {
                bubbles: true,
                detail: {
                    state: 'shown',
                    element: this
                }
            }));
        }
    }
    hide() {
        this.removeAttribute('show');
        this.setAttribute('inert', 'true');
        this.dispatchEvent(new CustomEvent('wdk-hintbox-error', {
            bubbles: true,
            detail: {
                state: 'hidden',
                element: this
            }
        }));
    }
    isVisible() {
        return this.getAttribute('show') === 'true';
    }
    triggerA11yRepeat() {
        window.setTimeout(()=>{
            this.shadowRoot.querySelector('.wdkA11yRepeat')?.remove();
            const myDiv = document.createElement('div');
            myDiv.classList.add('wdkA11yRepeat');
            myDiv.innerText = '!';
            this.shadowRoot.querySelector('#a11yWrapper').appendChild(myDiv);
        }, 200);
    }
    handleReloadLink() {
        this.shadowRoot.querySelectorAll('.js-reloadPage').forEach((reloadLink)=>{
            reloadLink.addEventListener('click', (event)=>{
                event.preventDefault();
                document.location.reload();
            });
        });
    }
}

});

parcelRegister("hSRP7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0513b0b857188de$export$2e2bcd8739ae039; });
class $d0513b0b857188de$export$2e2bcd8739ae039 extends HTMLElement {
    static get observedAttributes() {
        return [
            'disabled'
        ];
    }
    attributeChangedCallback(name) {
        this.#handleAttributeChange(name);
    }
    connectedCallback() {
        this.abortController = new AbortController();
        this.#prepareDom();
        this.inputElement = this.querySelector('.inputWrapper input');
        this.#handleAttributeChange();
        this.#handleInputEventListeners();
    }
    disconnectedCallback() {
        this.abortController?.abort();
        this.#cleanupDom();
    }
    #handleAttributeChange(name) {
        //when called from attributeChangedCallback directly our DOM is not yed finished
        if (this.inputElement !== undefined) {
            if (name === 'disabled' || this.hasAttribute('disabled')) this.inputElement.disabled = this.hasAttribute('disabled');
        }
    }
    #prepareDom() {
        const rawHtml = document.createElement('template');
        const isSwitch = this.getAttribute('switch') !== null;
        const isReverse = this.getAttribute('reverse') !== null;
        rawHtml.innerHTML = `
			<div class="designWrapper ${this.#sanitizeEvilHtml(isReverse ? 'reverse' : '')}">
				<div class="inputWrapper ${this.#sanitizeEvilHtml(isSwitch ? 'switch' : '')}">
					<input type="checkbox" />
					${this.#sanitizeEvilHtml(isSwitch ? '<div class="switchSlider"><div class="switchBg"></div><div class="switchKnob"></div></div>' : '')}
				</div>
				<div class="labelWrapper">
					<label for="${this.#sanitizeEvilHtml(this.#getId())}Input"></label>
				</div>
			</div>
			<div class="errors"></div>
  		`;
        const dataTemplate = this.querySelector('template');
        if (dataTemplate) {
            this.appendChild(rawHtml.content);
            const templateContent = document.importNode(dataTemplate.content, true);
            this.#fillLabel(templateContent);
            this.#fillInput(templateContent);
            this.#fillErrors(templateContent);
        }
    }
    //Important if Component is moved within the Dom
    #cleanupDom() {
        const children = Array.from(this.children);
        children.forEach((child)=>{
            if (child.tagName.toLowerCase() !== 'template') child.remove();
        });
    }
    #handleInputEventListeners() {
        this.inputElement.addEventListener('input', ()=>{
            if (this.inputElement.checkValidity()) this.hideErrors();
        });
        /*blur focus mouseenter mouseleave load unload do not bubble up the tree */ this.inputElement.addEventListener('blur', ()=>{
            if (this.inputElement.checkValidity()) this.hideErrors();
        });
        this.inputElement.addEventListener('invalid', ()=>{
            this.hideErrors();
            this.#showFrontendError();
        });
    }
    #showFrontendError() {
        const errorTypes = [
            {
                type: 'valueMissing',
                condition: /* @type {ValidityState} */ this.inputElement.validity.valueMissing
            },
            {
                type: 'rangeOverflow',
                condition: /* @type {ValidityState} */ this.inputElement.validity.rangeOverflow
            },
            {
                type: 'generic',
                condition: true
            }
        ];
        for (const errorType of errorTypes){
            const errorElement = this.querySelector(`wdk-hintbox-error[frontend-error="${errorType.type}"]`);
            if (errorType.condition && errorElement) {
                errorElement.show();
                break;
            }
        }
    }
    showBackendError(errorState) {
        const errorElement = this.querySelector(`wdk-hintbox-error[backend-error="${errorState}"]`);
        if (errorElement !== null) {
            this.hideErrors();
            errorElement.show();
        }
    }
    hideErrors() {
        this.querySelectorAll('.errors wdk-hintbox-error').forEach((error)=>{
            error.hide();
        });
    }
    getValue() {
        return this.inputElement.value;
    }
    #getId() {
        if (this.getAttribute('id')) return this.getAttribute('id');
        else console.error('No id specified!');
    }
    #fillLabel(templateContent) {
        const labelDiv = templateContent.querySelector('div[data-slot="label"]');
        this.querySelector('.labelWrapper label').innerHTML = this.#sanitizeEvilHtml(labelDiv.innerHTML);
        if (this.getAttribute('invisible-label') !== null) this.querySelector('.labelWrapper').classList.add('visuallyHidden');
    }
    #fillInput(templateContent) {
        const inputElement = templateContent.querySelector('div[data-slot="input"]');
        if (inputElement) {
            this.querySelector('.inputWrapper input').outerHTML = this.#sanitizeEvilHtml(inputElement.innerHTML);
            this.querySelector('.inputWrapper input').id = this.#getId() + 'Input';
        } else {
            this.querySelector('.inputWrapper input').remove();
            console.error('No input element specified!');
        }
    }
    #fillErrors(templateContent) {
        const errors = templateContent.querySelector('div[data-slot="errors"]');
        if (errors) this.querySelector('.errors').innerHTML = this.#sanitizeEvilHtml(errors.innerHTML);
        else this.querySelector('.errors').remove();
    }
    #sanitizeEvilHtml(string) {
        return String(string).replace(/<script\b|\bonerror=|\bonload=|\bonmouseover=|\bonmouseout=|\bonpagehide=|\bonpageshow=|\bonmessage=|\bonhashchange=|\bonbeforeunload=|\bonpopstate=|\bonresize=|\bonunload=|\bonkeydown=|\bonkeyup=|\bonkeypress=|\bonfocus=|\bonblur=|\bonchange=|\bonsubmit=|\bonreset=|\bonselect=|\bondblclick=|\bondrag=|\bondragend=|\bondragenter=|\bondragleave=|\bondragover=|\bondragstart=|\bondrop=|\bonwheel=|\boncopy=|\boncut=|\bonpaste=|\bonanimationend=|\bonanimationiteration=|\bonanimationstart=|\bontransitionend=|\bontouchcancel=|\bontouchend=|\bontouchmove=|\bontouchstart=|\bonclick=/gi, '');
    }
}

});

parcelRegister("eEuJF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aaaca48b6fad852c$export$2e2bcd8739ae039; });

var $elBdP = parcelRequire("elBdP");

var $9Acnl = parcelRequire("9Acnl");

var $c8xXg = parcelRequire("c8xXg");

var $hsgaE = parcelRequire("hsgaE");

var $a1ZJs = parcelRequire("a1ZJs");

var $bApRT = parcelRequire("bApRT");

var $dqHTc = parcelRequire("dqHTc");
customElements.define('wdk-dialog-body-default', (0, $9Acnl.default));
customElements.define('wdk-dialog-body-destructive', (0, $hsgaE.default));
customElements.define('wdk-dialog-body-freestyle', (0, $a1ZJs.default));
customElements.define('wdk-dialog-confirm', (0, $c8xXg.default));
customElements.define('wdk-dialog-trigger', (0, $bApRT.default));
class $aaaca48b6fad852c$export$2e2bcd8739ae039 extends HTMLElement {
    async connectedCallback() {
        await new Promise(requestAnimationFrame); //wait a tick
        this.abortController = new AbortController();
        this.loadingSpinnterTimer = null;
        this.isNotInAppShell = document.querySelector('peg-app-shell') === null;
        if (this.getAttribute('open') !== null) this.openModal({
            preventOpenAnimation: true
        });
    }
    async disconnectedCallback() {
        await new Promise(requestAnimationFrame); //wait a tick
        this.abortController.abort();
    }
    /**
	 * Opens the modal dialog with the specified options.
	 *
	 * @async
	 * @param {Object} [options={}] - The options for opening the modal.
	 * @param {string|null} [options.fetchUrl=null] - The URL to fetch content from.
	 * @param {boolean} [options.preventOpenAnimation=false] - Whether to prevent the open animation.
	 * @returns {Promise<void>} A promise that resolves when the modal is opened.
	 */ async openModal(options) {
        // this.#moveModalboxDomToBottom();
        options = options || {};
        const fetchUrl = options.fetchUrl || null;
        const preventOpenAnimation = options.preventOpenAnimation || false;
        if (options.keepCurrentDialogOpen === undefined) await this.#closeCurrentOpenDialog();
        this.#appendStyleAndDialogTag();
        this.#deactivateAnimation(preventOpenAnimation);
        if (this.isNotInAppShell) window.history.pushState({}, '', window.location.href + '#wdkDialogOpen');
        this.setAttribute('open', '');
        await this.#getContent(fetchUrl);
        this.dialog.showModal();
        this.dialog.focus(); // Fix for Safari, wihout this the focus is on the button with the dotted outline visible
        this.#handleDefaultClickListener();
        this.#passAttributesToDialogBody();
        this.#handleBackdropVisibility('openDialog');
    }
    /*#moveModalboxDomToBottom() {
		//Maybe it woulf be good to have something like this, because now we stay at the DOM-Position that we added the Dialog to. This could have some pretty strong CSS-Styles leaking into our wdk-dialog-boy-* Components
		//When ein console.log here it seems that the openModal Function is completly worked thrhough before the disconnected is thrown, don't know if this could make problems
		const dialogPlaceholder = document.createElement('div');
		dialogPlaceholder.className = 'dialogPlaceholder';
		this.parentNode.insertBefore(dialogPlaceholder, this);
		document.body.appendChild(this);
	}*/ /*#moveModalboxDomToOriginalPosition() {
		const placeholder = document.querySelector('.dialogPlaceholder');
		if (placeholder !== null) {
			placeholder.insertAdjacentElement('afterend', this);
			placeholder.remove();
		}
	}*/ #appendStyleAndDialogTag() {
        const dialogElement = document.createElement('template');
        dialogElement.innerHTML = `
			${this.#sanitizeEvilHtml((0, $elBdP.styles))}
			<dialog></dialog>
		`;
        const clone = document.importNode(dialogElement.content, true);
        this.appendChild(clone);
        this.dialog = this.querySelector('dialog');
        this.#handleCloseEvents();
        this.#observeOpen();
    }
    #showLoadingSpinner() {
        //Doing this in 2 Steps prevents a little jumping in Chrome XL for the very first milliseconds...
        this.dialog.innerHTML = this.#sanitizeEvilHtml('<div class="wdk-loadingSpinner noDisplay is-loading t-white t-size200"></div>');
        this.loadingSpinnterTimer = window.setTimeout(()=>{
            this.dialog.querySelector('.wdk-loadingSpinner')?.classList.remove('noDisplay');
        }, 1500);
    }
    #hideLoadingSpinner() {
        window.clearTimeout(this.loadingSpinnterTimer);
        this.dialog.querySelector('.wdk-loadingSpinner')?.remove();
    }
    async #getContent(fetchUrl = null) {
        const fetchContent = this.getAttribute('url') !== null || fetchUrl !== null;
        if (fetchContent) try {
            this.#showLoadingSpinner();
            const url = this.getAttribute('url') || fetchUrl;
            const data = await fetchIt.get(url);
            this.dialog.innerHTML = this.#sanitizeEvilHtml(data);
            this.#createClosingX();
            this.dispatchEvent(new CustomEvent('wdk-dialog:fetch-success', {
                bubbles: true
            }));
        } catch (error) {
            await this.#handleFetchError(error);
        } finally{
            this.#hideLoadingSpinner();
        }
        else {
            const innerTemplate = this.querySelector('template');
            const cloneInner = document.importNode(innerTemplate.content, true);
            this.dialog.appendChild(cloneInner);
            this.#createClosingX();
        }
    }
    #createClosingX() {
        if (this.getAttribute('closing-x') !== null) {
            const closeButtonLabel = this.#getLocalizedString('closeButtonLabel');
            const template = document.createElement('template');
            const closingXHtml = `
					<button type="button" class="closingX js-closeDialog" aria-label="${closeButtonLabel}">
						<svg viewBox="0 0 24 24">
						  <line x1="18" y1="6" x2="6" y2="18" stroke="black" stroke-width="1"/>
						  <line x1="6" y1="6" x2="18" y2="18" stroke="black" stroke-width="1"/>
						</svg>
					</button>
				`;
            template.innerHTML = this.#sanitizeEvilHtml(closingXHtml);
            const clone = document.importNode(template.content, true);
            this.dialog.prepend(clone);
        }
    }
    #deactivateAnimation(deactivate) {
        this.dialog.style.removeProperty('animation-name');
        this.dialog.style.removeProperty('transition');
        if (deactivate) {
            this.dialog.style.transition = 'none';
            this.dialog.style.animationName = 'none';
        }
    }
    /**
	 * @param {boolean} force
	 * */ async closeModal(force = false, preventCloseAnimation = false) {
        await this.#closeAndCleanup({
            force: force,
            preventAnimation: preventCloseAnimation,
            closedBy: 'programmatic'
        });
    }
    async #closeCurrentOpenDialog() {
        //Dialog opens when already a dialog is open
        const foundOpenDialog = document.querySelector('wdk-dialog dialog[open]'); //search on the whole Page. Check for really dialog-Tag is open
        if (foundOpenDialog !== null) {
            const currentWdkDialog = foundOpenDialog.closest('wdk-dialog[open]');
            currentWdkDialog.setAttribute('prevent-close-animation', '');
            await currentWdkDialog.closeModal(true);
        }
    }
    /**
	 * @param {TechnicalFetchCommandError} error - The error object.
	 * @returns {Promise<void>} A promise that resolves when #closeAndCleanup is done.
	 * @throws Will rethrow the error if it is not a technical error.
	 */ async #handleFetchError(error) {
        if (error.type === 'technicalError') {
            await this.#closeAndCleanup({
                closedBy: 'technicalError'
            });
            this.dispatchEvent(new CustomEvent('wdk-dialog:fetch-fail', {
                detail: {
                    response: error
                }
            }));
            switch(error.message){
                case 'browserTimeout':
                    document.querySelector('wdk-snackbar#timeoutNotification').show();
                    break;
                case 'sessionExpired':
                    jPar.util.network.reloadForSessionExpired();
                    break;
                case 'offline':
                    document.dispatchEvent(new CustomEvent('serviceworker:triggerOfflineAttention', {
                        bubbles: true
                    }));
                    break;
                default:
                    if (document.querySelector('#errorDialog500') !== null) await document.querySelector('#errorDialog500').openModal();
                    else jPar.wdk.modalbox.show({
                        modalboxId: 'errorModalbox500'
                    }); //Deprecated
                    console.error(error);
                    break;
            }
        } else throw error;
    }
    preventClose() {
        this.isClosePrevented = true;
    }
    async #closeAndCleanup(config = {}) {
        const { force: force = false, preventAnimation: preventAnimation = false, closedBy: closedBy = 'unknown' } = config;
        this.#deactivateAnimation(preventAnimation);
        this.isClosePrevented = false;
        this.dispatchEvent(new CustomEvent('wdk-dialog:closing', {
            detail: {
                wdkDialog: this,
                isForceClose: force
            },
            bubbles: true
        }));
        if (force === true) this.isClosePrevented = false;
        if (this.isClosePrevented === false) {
            if (this.isNotInAppShell) {
                const newUrl = (0, $dqHTc.getUrlWithRemovedParam)(document.location.href, 'wdkDialogOpen');
                history.replaceState(null, null, newUrl);
            }
            this.removeAttribute('open');
            this.#handleBackdropVisibility('closeDialog');
            this.dialog.close();
            await this.#animationsComplete();
            this.#resetContent();
            this.dispatchEvent(new CustomEvent('wdk-dialog:closed', {
                detail: {
                    wdkDialog: this,
                    isForceClose: force,
                    closedBy: closedBy
                },
                bubbles: true
            }));
        }
    }
    #handleCloseEvents() {
        //TODO could be replaced with closedby https://developer.mozilla.org/en-US/docs/Web/API/HTMLDialogElement/closedBy in the Future
        if (this.getAttribute('prevent-light-dismiss') === null) {
            //close on Background click
            this.dialog.addEventListener('click', async (event)=>{
                if (event.target.nodeName === 'DIALOG') await this.#closeAndCleanup({
                    closedBy: 'backgroundClick'
                });
            });
            this.dialog.addEventListener('keydown', async (event)=>{
                if (event.code === 'Escape') await this.#closeAndCleanup({
                    closedBy: 'escapeKey'
                });
            });
        //close on ESC -> Dialog has default cancel behavior on ESC so no need to handle it here
        } else // prevent closing on ESC
        // there is a listener for "cancel" that can be prevented, but for some reason it works only for the first click. Second click will close the dialog
        this.dialog.addEventListener('keydown', (event)=>{
            if (event.code === 'Escape') event.preventDefault();
        });
        if (this.isNotInAppShell) window.addEventListener('popstate', async ()=>{
            // Close the modal if #hasOpenModal is not in the URL
            if (!window.location.hash.includes('wdkDialogOpen')) await this.#closeAndCleanup({
                closedBy: 'browserBack'
            });
        }, {
            signal: this.abortController?.signal
        });
    }
    /**
	 * @param {string} action - The action to perform, either 'openDialog' or 'closeDialog'.
	 *                          - 'openDialog': Adds the current dialog to the list of opened dialogs and hides the backdrop for all other dialogs.
	 *                          - 'closeDialog': Removes the current dialog from the list of opened dialogs and restores the backdrop for the next dialog in the list.
	 */ #handleBackdropVisibility(action) {
        const currentlyOpenedDialogList = jPar.state.wdkDialog.openedDialogList;
        if (action === 'openDialog') {
            if (!jPar.state.wdkDialog.openedDialogList.includes(this.id)) jPar.state.wdkDialog.openedDialogList.unshift(this.id);
            currentlyOpenedDialogList.slice(1).forEach((wdkDialogId)=>{
                // we need to check the hole page for the opened dialogs
                document.querySelector(`#${wdkDialogId}`).setAttribute('no-backdrop', '');
            });
        } else if (action === 'closeDialog') {
            const index = jPar.state.wdkDialog.openedDialogList.indexOf(this.id);
            if (index > -1) jPar.state.wdkDialog.openedDialogList.splice(index, 1);
            // we need to check the hole page for the dialog with this id
            document.querySelector(`#${currentlyOpenedDialogList[0]}`)?.removeAttribute('no-backdrop');
        }
    }
    #passAttributesToDialogBody() {
        const wdkDialogBody = this.querySelector('wdk-dialog-body-default, wdk-dialog-body-destructive');
        if (wdkDialogBody !== null) {
            const attributesToPass = [
                'mobile-full-height',
                'mobile-center',
                'buttons-vertical',
                'closing-x'
            ];
            for (const attribute of this.attributes)if (attributesToPass.includes(attribute.name)) wdkDialogBody.setAttribute(attribute.name, attribute.value);
        }
    }
    #handleDefaultClickListener() {
        this.dialog.querySelectorAll('.js-closeDialog').forEach((elem)=>{
            elem.addEventListener('click', async (event)=>{
                if (event.currentTarget.classList.contains('closingX')) await this.#closeAndCleanup({
                    closedBy: 'closingX'
                });
                else await this.#closeAndCleanup({
                    closedBy: 'closingButton'
                });
            });
        });
        // Helper for Submitting the Form from outside the Form-Tag
        this.dialog.querySelector('[type="submit"]')?.addEventListener('click', (event)=>{
            event.preventDefault();
            this.dialog.querySelector('form')?.requestSubmit();
        });
    }
    #sanitizeEvilHtml(string) {
        // Das muss nochmal ein richtiger sanatizer werden
        return String(string).replace(/<script\b|\bonerror=|\bonload=|\bonmouseover=|\bonmouseout=|\bonpagehide=|\bonpageshow=|\bonmessage=|\bonhashchange=|\bonbeforeunload=|\bonpopstate=|\bonresize=|\bonunload=|\bonkeydown=|\bonkeyup=|\bonkeypress=|\bonfocus=|\bonblur=|\bonchange=|\bonsubmit=|\bonreset=|\bonselect=|\bondblclick=|\bondrag=|\bondragend=|\bondragenter=|\bondragleave=|\bondragover=|\bondragstart=|\bondrop=|\bonwheel=|\boncopy=|\boncut=|\bonpaste=|\bonanimationend=|\bonanimationiteration=|\bonanimationstart=|\bontransitionend=|\bontouchcancel=|\bontouchend=|\bontouchmove=|\bontouchstart=|\bonclick=/gi, '');
    }
    /**
	 * Wartet auf das Ende aller Animationen des Dialogs.
	 * @private
	 * @returns {Promise} Ein Promise, der nach n Sekunde erfüllt wird.
	 */ #animationsComplete() {
        // const animations = this.getAnimations();
        // console.log('animations', animations);
        // const finishedAnimations = animations.map((animation) => animation.finished);
        // return Promise.allSettled(finishedAnimations);
        if (this.hasAttribute('prevent-open-animation') || this.hasAttribute('prevent-close-animation')) return new Promise((resolve)=>resolve());
        else return new Promise((resolve)=>setTimeout(resolve, 500));
    }
    #observeOpen() {
        const dialogOpenerObserver = new MutationObserver((mutations)=>{
            mutations.forEach(async (mutation)=>{
                if (mutation.attributeName === 'open') {
                    const isOpen = this.dialog.hasAttribute('open');
                    if (isOpen) {
                        this.dispatchEvent(new CustomEvent('wdk-dialog:opening', {
                            bubbles: true
                        }));
                        await this.#animationsComplete();
                        this.dispatchEvent(new CustomEvent('wdk-dialog:opened', {
                            detail: {
                                wdkDialog: this
                            },
                            bubbles: true
                        }));
                    }
                }
            });
        });
        dialogOpenerObserver.observe(this.dialog, {
            attributes: true
        });
    }
    #resetContent() {
        const children = Array.from(this.children);
        children.forEach((child)=>{
            if (child.tagName.toLowerCase() !== 'template') this.removeChild(child);
        });
        this.removeAttribute('prevent-close-animation');
        this.removeAttribute('prevent-open-animation');
    // this.#moveModalboxDomToOriginalPosition();
    }
    #getLocalizedString(key) {
        const translations = {
            en: {
                closeButtonLabel: 'Close'
            },
            de: {
                closeButtonLabel: "Schlie\xdfen"
            },
            fr: {
                closeButtonLabel: 'Fermer'
            },
            es: {
                closeButtonLabel: 'Cerrar'
            },
            nl: {
                closeButtonLabel: 'Sluiten'
            }
        };
        const userLanguages = navigator.languages;
        for (const language of userLanguages){
            const langCode = language.split('-')[0]; // Extract the language code (e.g., 'en' from 'en-US')
            if (translations[langCode] && translations[langCode][key]) return translations[langCode][key];
        }
        return translations['en'][key]; // Fallback to English if no match is found
    }
}

});
parcelRegister("elBdP", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $a71fe65a7d502b21$export$9dd6ff9ea0189349; });
const $a71fe65a7d502b21$export$9dd6ff9ea0189349 = `
	<style>
		html:has(wdk-dialog dialog[open]) {
			overflow: hidden;
		}
				
		/* Just to make the Component "visible" to Tests. So we don't have to check for the real dialog Element in here */
		wdk-dialog:has(dialog[open]) {
			position: fixed;
    		inset: 0;
		}
		
		wdk-dialog {
			--wdk-dialog-width-desktop: 560px;
		}
		/*
		--BREAKPOINT_S: 320px;
		--BREAKPOINT_M: 601px;
		--BREAKPOINT_L: 768px;
		--BREAKPOINT_XL: 980px;
		*/
	
		 /* 
		don't change anything about height and width 
		-> this was evil to get it work in all variants 
		(long text, short text, only one word text etc., mobile, desktop, mobile-full-height and not mobile-full-height
		*/
		wdk-dialog dialog {
			inset: 0;
			width: 100%;
			max-width: 100%;
			max-height: 80dvh;
			overflow: hidden;
			border: none;
			padding: 0;
			margin-block-end: 0;
			background-color: transparent;
			transition: display .5s allow-discrete, overlay .5s allow-discrete;
			animation: close .5s forwards;
		}

		/*Close Animation Safari iOS ist holperig. Der innere Teil bleibt komisch stehen */
		html.macSafari wdk-dialog dialog,
		html.ios wdk-dialog dialog {
			transition: none;
		}
		
		wdk-dialog[open] dialog {
			animation: open .5s forwards;
		}
		
		@media only screen and (min-width: 601px) {
			wdk-dialog dialog {
				max-width: none;
				width: var(--wdk-dialog-width-desktop);
				margin-bottom: auto;
			}
		}
		
		wdk-dialog[mobile-full-height] dialog {
			height: 100dvh;
			max-height: 100dvh;
		}
		
		@media only screen and (min-width: 601px) {
			wdk-dialog[mobile-full-height] dialog {
				height: fit-content;
				max-height: 80dvh;
			}
		}

		@media only screen and (max-width: 600px) {
			wdk-dialog[mobile-center] dialog {
				margin-block-end: auto;
				padding-inline: 8px;
			}
		}
				 
		wdk-dialog dialog[open]::backdrop {
			backdrop-filter: blur(16px);
			-webkit-backdrop-filter: blur(16px);
			background-color: #00000A99; /* 99 = 60% opacity -> Safari has a bug with vars for background-color on backdrop*/
		}
		
		wdk-dialog[no-backdrop] dialog::backdrop {
			background-color: transparent;
			backdrop-filter: blur(0);
			-webkit-backdrop-filter: blur(0);
		}
		
		wdk-dialog[closing-x="inside"] dialog .closingX {
			display: flex;
			align-items: center;
			justify-content: center;
			position: absolute;
			z-index: 1;
			top: 20px;
			right: 20px;
			height: 32px;
			width: 32px;
			padding: 0;
			border: 0;
			cursor: pointer;
			background-color: transparent;
		}
		
		wdk-dialog[closing-x="inside"] dialog .closingX:hover {
			opacity: .5;
		}
		
		wdk-dialog[closing-x="inside"] dialog .closingX svg {
			display: block;
			width: 32px;
			height: 32px; 
		}

		wdk-dialog[closing-x="inside"] dialog .closingX svg line {
			stroke: var(--wdk-dialog-closing-x-color, var(--COLOR_support_black_default));
			stroke-width: 1.8px;
		}

		wdk-dialog[closing-x="outside"] dialog {
			padding-bottom: 100px;
		}

		@media only screen and (min-width: 601px) {
			wdk-dialog[closing-x="outside"] dialog {
				padding-bottom: 50px;
			}
		}
		
		wdk-dialog[closing-x="outside"] dialog .closingX {
			display: flex;
			align-items: center;
			justify-content: center;
			position: absolute;
			bottom: 20px;
			left: calc(50% - 16px);
			height: 32px;
			width: 32px;
			padding: 0;
			background-color: transparent;
			border: 0;
			border-radius: 30px;
			cursor: pointer;
		}
		
		@media only screen and (min-width: 601px) {
			wdk-dialog[closing-x="outside"] dialog .closingX {
				bottom: 0;
			}
		}
		
		wdk-dialog[closing-x="outside"] dialog .closingX:hover {
			opacity: .5;
		}
		
		wdk-dialog[closing-x="outside"] dialog .closingX svg {
			display: block;
			height: 32px;
			width: 32px;
		}
		
		wdk-dialog[closing-x="outside"] dialog .closingX svg line {
			stroke: var(--COLOR_support_white_default);
			stroke-width: 1.8px;
		}
		
		wdk-dialog dialog:has(.wdk-loadingSpinner) {
			display: flex;
			justify-content: center;
			padding-bottom: 32px;
		}
		
		wdk-dialog dialog:has(wdk-dialog-body-freestyle) {
			overflow-y: auto;
		}
		
		@keyframes open {
			from {
				opacity: 0;
				transform: translateY(100%);
			}
			to {
				opacity: 1;
				transform: translateY(0);
			}
		}
		
		@keyframes close {
			from {
				opacity: 1;
				transform: translateY(0);
			}
			to {
				opacity: 0;
				transform: translateY(100%);
			}
		}
		
	</style>
`;

});

parcelRegister("9Acnl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6fa1135e800a6308$export$2e2bcd8739ae039; });

var $fIfI9 = parcelRequire("fIfI9");
class $6fa1135e800a6308$export$2e2bcd8739ae039 extends HTMLElement {
    async connectedCallback() {
        this.#createDom();
        this.#cleanupSlots();
    }
    #createDom() {
        const template = document.createElement('template');
        template.innerHTML = `
			${this.#sanitizeEvilHtml((0, $fIfI9.styles))}
			<div class="dialogContent">
				<header><h2><slot name="header"></slot></h2></header>
				<article><slot></slot></article>
				<footer>
					<ul>
						<li><slot name="button_1"></slot></li>
						<li><slot name="button_2"></slot></li>
					</ul>
				</footer>
			</div>
		`;
        const clone = document.importNode(template.content, true);
        if (!this.shadowRoot) {
            this.attachShadow({
                mode: 'open'
            });
            this.shadowRoot.appendChild(clone);
        }
    }
    #cleanupSlots() {
        window.setTimeout(()=>{
            if (this.#hasSlot('header') === false) this.shadowRoot.querySelector('header').remove();
            if (this.#hasSlot('button_1') === false && this.#hasSlot('button_2') === false) this.shadowRoot.querySelector('footer').remove();
            if (this.#hasSlot('button_1') === false && this.#hasSlot('button_2') === true) this.shadowRoot.querySelector('li:first-of-type').remove();
            if (this.#hasSlot('button_1') === true && this.#hasSlot('button_2') === false) this.shadowRoot.querySelector('li:last-of-type').remove();
        });
    }
    #hasSlot(slotName) {
        const myVal = Array.from(this.shadowRoot.querySelectorAll('slot')).filter((element)=>{
            return element.name === slotName && element.assignedElements().length !== 0;
        });
        return Boolean(myVal.length);
    }
    #sanitizeEvilHtml(string) {
        // Das muss nochmal ein richtiger sanatizer werden
        return String(string).replace(/<script\b|\bonerror=|\bonload=|\bonmouseover=|\bonmouseout=|\bonpagehide=|\bonpageshow=|\bonmessage=|\bonhashchange=|\bonbeforeunload=|\bonpopstate=|\bonresize=|\bonunload=|\bonkeydown=|\bonkeyup=|\bonkeypress=|\bonfocus=|\bonblur=|\bonchange=|\bonsubmit=|\bonreset=|\bonselect=|\bondblclick=|\bondrag=|\bondragend=|\bondragenter=|\bondragleave=|\bondragover=|\bondragstart=|\bondrop=|\bonwheel=|\boncopy=|\boncut=|\bonpaste=|\bonanimationend=|\bonanimationiteration=|\bonanimationstart=|\bontransitionend=|\bontouchcancel=|\bontouchend=|\bontouchmove=|\bontouchstart=|\bonclick=/gi, '');
    }
}

});
parcelRegister("fIfI9", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $b70726fc2f3dc3d9$export$9dd6ff9ea0189349; });
const $b70726fc2f3dc3d9$export$9dd6ff9ea0189349 = `
<style>
	/*
	Attantion! if you add some new params for styling purpose, 
	the funtion passAttributesToDialogBody needs to be updated in wdk-dialog.js
	*/

	:host {
		display: block;
		max-width: 600px;
		--inline-padding: 12px;
		/*line-height: 24px; EP: 27px */ /* Workaround for CSS line-height calculation: Will calculate scroll height wrong of the article, because our line height is lower than the renderbox of the Text. Nicht globalgmeacht, weil wir dann \xfcberall 2px mehr line-hieght haben. Nur lokal implementieren, wenn notwendig https://stackoverflow.com/questions/16443642/scroll-bars-showing-up-when-not-expecting-them-line-height-and-overflow-y-issue */
	}
	
	/*Fix for Chrome only (July 2024): When content is not wide enough the width of the 
	Dialog is to small and jumps second later to the right width.*/
	@media only screen and (min-width: 360px) {
		:host {
			min-width: 360px;
		}
		
		:host([mobile-center]) {
			min-width: calc(360px - 16px);
		}
	}
	
	@media only screen and (min-width: 375px) {
		:host {
			min-width: 375px;
		}
		
		:host([mobile-center]) {
			min-width: calc(375px - 16px);
		}
	}
	
	@media only screen and (min-width: 390px) {
		:host {
			min-width: 390px;
		}
		
		:host([mobile-center]) {
			min-width: calc(390px - 16px);
		}
	}
	
	@media only screen and (min-width: 425px) {
		:host {
			min-width: 425px;
		}
		
		:host([mobile-center]) {
			min-width: calc(425px - 16px);
		}
	}
	
	@media only screen and (min-width: 601px) {
		:host {
			--inline-padding: 24px;
			width: var(--wdk-dialog-width-desktop);
			min-width: auto !important;
			max-width: none;
		}
	}
	
	.dialogContent {
		display: flex;
		flex-flow: column;
		max-height: 80dvh; /* Default height */
		width: 100%;
		border-top-left-radius: var(--RADIUS_M);
		border-top-right-radius: var(--RADIUS_M);
		background-color: var(--wdk-dialog-body-default-bg-color, var(--COLOR_support_white_default));
	}
	
	.dialogContent:not(:has(header)) { /* if no closingX oder X is outside we don't have to reserve some space in dialogContent */	
		padding-top: 16px;
		max-height: calc(80dvh - 16px); 
	}
	
	:host([closing-x="inside"]) .dialogContent:not(:has(header)) { /* Reserve Space so that content does not run into ClosingX */
		padding-top: 48px;
		max-height: calc(80dvh - 48px);  
	}
	
	@media only screen and (max-width: 600px) { /* SM */
		:host([mobile-full-height]) .dialogContent {
			height: 100dvh; /* Default height when header is present */
			max-height: 100dvh;
			border-top-left-radius: 0;
			border-top-right-radius: 0;
		}
		
		:host([mobile-full-height]) .dialogContent:not(:has(header)) { /* Full height without closingX, but no header */
			height: calc(100dvh - 16px); 
			max-height: calc(100dvh - 16px);
		}
		
		:host([closing-x="inside"][mobile-full-height]) .dialogContent:not(:has(header)) {
			height: calc(100dvh - 48px); 
			max-height: calc(100dvh - 48px);
		}
	}

	:host([mobile-center]) .dialogContent { /* If mobile-center we want to have the rounded border also for SM */
		border-bottom-left-radius: var(--RADIUS_M);
		border-bottom-right-radius: var(--RADIUS_M);
	}
	
	@media only screen and (min-width: 601px) { /* Rounded border in every case if we are in XL */
		.dialogContent {
			border-bottom-left-radius: var(--RADIUS_M);
			border-bottom-right-radius: var(--RADIUS_M);			
		}
	}
		
	/*:host([mobile-full-height]) .dialogContent {
		background-color: var(--COLOR_support_white_default);
	}*/
	
	.dialogContent > header {
		width: 100%;
	}
	
	.dialogContent > header h2 {
		display: flex;
		align-items: center;
		min-height: 60px;
		margin: 0;
		padding: 18px var(--inline-padding) var(--inline-padding) var(--inline-padding);
		font: var(--FONT_default_200);
		color: var(--COLOR_defaultText);
	}
	
	:host([closing-x="inside"]) .dialogContent > header h2 {
		padding: 18px 68px var(--inline-padding) var(--inline-padding);
	}
	
	.dialogContent > article {
		display: flex;
		flex-direction: column;
		padding: 0 var(--inline-padding) var(--inline-padding) var(--inline-padding);
		overflow-y: auto;
		flex-grow: 1;
	}
	
	.dialogContent:has(footer) > article {
		padding-bottom: 0;
	}
	
	.dialogContent > article::-webkit-scrollbar {
		width: 12px;
		height: 12px;
	}
	
	.dialogContent > article::-webkit-scrollbar-track {
		background: transparent;
		border-radius: var(--RADIUS_rounded);
	}
	
	.dialogContent > article::-webkit-scrollbar-thumb {
		background: var(--COLOR_gray_400);
		border: 3px solid transparent;
		border-radius: var(--RADIUS_rounded);
		background-clip: content-box;
	}
	
	.dialogContent > article::-webkit-scrollbar-thumb:hover {
		background: var(--COLOR_gray_300);
		background-clip: content-box;
	}
	
	/* .dialogContent > article ::slotted(form) {
		!*not sure if we should style the form here or if this should be styled outside the component*!
		  display: flex;
		flex-direction: column;
		height: 100%;
	}*/
	
	.dialogContent > footer {
		padding: 16px 24px;
	}
	
	@media only screen and (min-width: 375px) {
		.dialogContent > footer {
			padding: 24px;
		}
	}

	@media only screen and (min-width: 601px) {
		.dialogContent > footer {
			padding: 32px 24px;
		}
	}
	
	.dialogContent > footer ul {
		width: 100%;
		display: flex;
		flex-flow: wrap;
		gap: 20px;
		justify-content: space-between;
		margin: 0;
		padding: 0;
	}
	
	.dialogContent > footer ul li {
		flex-basis: calc(40% - 20px);
		flex-grow: 1;
		list-style: none;
		text-align: center;
		vertical-align: top;
		margin: 0;
		padding: 0;
	}
	
	/* Full width for Buttons if shown in 2 lines */
	.dialogContent > footer:has(li:nth-child(2)) ::slotted([slot^='button_']) {
		width: 100%;
	}
	
	/* Buttons always one below another */
	
	:host([buttons-vertical]) .dialogContent > footer ul {
		display: grid;
		grid-template-rows: auto;
		justify-content: center;
		gap: 8px;
	}
	
	:host([buttons-vertical]) .dialogContent > footer ul li {
		flex-basis: auto;
	}
</style>
`;

});


parcelRegister("c8xXg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d6092255fef05ee$export$2e2bcd8739ae039; });
class $8d6092255fef05ee$export$2e2bcd8739ae039 extends HTMLElement {
    async connectedCallback() {
        await new Promise(requestAnimationFrame);
        this.#appendMarkup();
        this.querySelector('.js-closeConfirm')?.addEventListener('click', (event)=>{
            event.preventDefault();
            this.closeConfirm();
        });
        this.closest('wdk-dialog').querySelector('wdk-dialog-confirm .js-forceCloseDialog')?.addEventListener('click', ()=>{
            this.closest('wdk-dialog').closeModal(true);
        });
    }
    #appendMarkup() {
        const confirmElement = document.createElement('template');
        confirmElement.innerHTML = `
			<style>
				:host(:not([open])) {
					display: none;
				}
				
				:host {
					--inline-padding: 12px;
				}

				@media only screen and (min-width: 601px) {
					:host {
						--inline-padding: 24px;
					}
				}
				
				:host([open]) {
					display: flex;
					justify-content: center;
					align-items: center;
					position: absolute;
					top: 0;
					left: 0;
					background-color: var(--COLOR_support_black_alpha_15);
					width: 100%;
					height: 100%;
					border-radius: var(--RADIUS_M);
				}
				
				.dialogContent {
					height: fit-content;
					width: 100%;
					margin: 0 16px;
					background-color: var(--COLOR_support_white_default);
					border-radius: var(--RADIUS_M);
					box-shadow: var(--SHADOW_M);
				}
				
				@media only screen and (min-width: 601px) {
					.dialogContent {
						width: 70%;
						margin: 0;
					}
				}
				
				.dialogContent > header h2 {
					display: flex;
					align-items: center;
					min-height: 60px;
					margin: 0;
					padding: 18px var(--inline-padding) var(--inline-padding) var(--inline-padding);
					font: var(--FONT_default_200);
					color: var(--COLOR_defaultText);
				}
				
				.dialogContent > article {
					display: flex;
					flex-direction: column;
					padding: 0 var(--inline-padding);
				}
				
				.dialogContent > footer {
					padding: 24px var(--inline-padding);
				}
				
				.dialogContent > footer ul {
					width: 100%;
					display: flex;
					flex-flow: wrap;
					gap: 20px;
					justify-content: space-between;
					margin: 0;
					padding: 0;
				}
				
				.dialogContent > footer ul li {
					flex-basis: calc(40% - 20px);
					flex-grow: 1;
					list-style: none;
					text-align: center;
					vertical-align: top;
					margin: 0;
					padding: 0;
				}
				
				/* Full width for Buttons if shown in 2 lines */
				.dialogContent > footer:has(li:nth-child(2)) ::slotted([slot^='button_']) {
					width: 100%;
				}
			</style>
			<div class="dialogContent">
				<header><h2><slot name="headline"></slot></h2></header>
				<article><slot></slot></article>
				<footer>
					<ul>
						<li><slot name="button_1"></slot></li>
						<li><slot name="button_2"></slot></li>
					</ul>
				</footer>
			</div>
		`;
        const clone = document.importNode(confirmElement.content, true);
        if (!this.shadowRoot) {
            this.attachShadow({
                mode: 'open'
            });
            this.shadowRoot.appendChild(clone);
        }
    }
    openConfirm() {
        this.setAttribute('open', '');
    }
    closeConfirm() {
        this.removeAttribute('open');
    }
}

});

parcelRegister("hsgaE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb5198646132d671$export$2e2bcd8739ae039; });

var $8W3wQ = parcelRequire("8W3wQ");
class $cb5198646132d671$export$2e2bcd8739ae039 extends HTMLElement {
    async connectedCallback() {
        const template = document.createElement('template');
        template.innerHTML = `
			${this.#sanitizeEvilHtml((0, $8W3wQ.styles))}
			<div class="dialogContent">
				<header><h2><slot name="header"></slot></h2></header>
				<article><slot></slot></article>
				<footer>
					<ul>
						<li><slot name="button_1"></slot></li>
						<li><slot name="button_2"></slot></li>
					</ul>
					<small><slot name="belowButtons"></slot></small>
				</footer>
			</div>
		`;
        const clone = document.importNode(template.content, true);
        if (!this.shadowRoot) {
            this.attachShadow({
                mode: 'open'
            });
            this.shadowRoot.appendChild(clone);
        }
        this.#cleanupDom();
    }
    #cleanupDom() {
        window.setTimeout(()=>{
            if (this.#hasSlot('header') === false) this.shadowRoot.querySelector('header').remove();
            if (this.#hasSlot('button_1') === false && this.#hasSlot('button_2') === false) this.shadowRoot.querySelector('footer').remove();
            if (this.#hasSlot('button_1') === false && this.#hasSlot('button_2') === true) this.shadowRoot.querySelector('li:first-of-type').remove();
            if (this.#hasSlot('button_1') === true && this.#hasSlot('button_2') === false) this.shadowRoot.querySelector('li:last-of-type').remove();
            if (this.#hasSlot('belowButtons') === false) this.shadowRoot.querySelector('footer small').remove();
        });
    }
    #hasSlot(slotName) {
        const myVal = Array.from(this.shadowRoot.querySelectorAll('slot')).filter((element)=>{
            return element.name === slotName && element.assignedElements().length !== 0;
        });
        return Boolean(myVal.length);
    }
    #sanitizeEvilHtml(string) {
        // Das muss nochmal ein richtiger sanatizer werden
        return String(string).replace(/<script\b|\bonerror=|\bonload=|\bonmouseover=|\bonmouseout=|\bonpagehide=|\bonpageshow=|\bonmessage=|\bonhashchange=|\bonbeforeunload=|\bonpopstate=|\bonresize=|\bonunload=|\bonkeydown=|\bonkeyup=|\bonkeypress=|\bonfocus=|\bonblur=|\bonchange=|\bonsubmit=|\bonreset=|\bonselect=|\bondblclick=|\bondrag=|\bondragend=|\bondragenter=|\bondragleave=|\bondragover=|\bondragstart=|\bondrop=|\bonwheel=|\boncopy=|\boncut=|\bonpaste=|\bonanimationend=|\bonanimationiteration=|\bonanimationstart=|\bontransitionend=|\bontouchcancel=|\bontouchend=|\bontouchmove=|\bontouchstart=|\bonclick=/gi, '');
    }
}

});
parcelRegister("8W3wQ", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $68167a3b53905ddc$export$9dd6ff9ea0189349; });
const $68167a3b53905ddc$export$9dd6ff9ea0189349 = `
<style>
	:host {
		display: block;
		--inline-padding: 12px;
	}
	
	@media only screen and (min-width: 601px) {
		:host {
			--inline-padding: 24px;
			width: var(--wdk-dialog-width-desktop);
		}
	}
	
	.dialogContent {
		display: flex;
		flex-flow: column;
		max-height: 80dvh;
		width: 100%;
		text-align: center;
		color: var(--COLOR_support_white_default);
	}
	
	@media only screen and (max-width: 600px) {
		:host([mobile-full-height]) .dialogContent {
			height: 100dvh;
			max-height: 100dvh;
		}
	}
	
	.dialogContent > header h2 {
		display: flex;
		align-items: center;
		min-height: 60px;
		margin: 0;
		padding: 18px var(--inline-padding) var(--inline-padding) var(--inline-padding);
		font: var(--FONT_default_200);
	}
	
	:host([closing-x="inside"]) .dialogContent > header h2 {
		padding: 18px 68px var(--inline-padding) var(--inline-padding);
	}
	
	.dialogContent > article {
		display: flex;
		flex-direction: column;
		padding: 0 var(--inline-padding) var(--inline-padding) var(--inline-padding);
		overflow-y: auto;
		scrollbar-color: var(--COLOR_gray_400) var(--COLOR_support_white_default);
		scrollbar-width: thin;
		flex-grow: 1;
	}
	
	.dialogContent:has(footer) > article {
		padding: 0 var(--inline-padding);
	}
	
	/* Safari doesn't support the above and needs this webkit selectors */
	.dialogContent > article::-webkit-scrollbar {
		width: 12px;
		height: 12px;
	}
	
	.dialogContent > article::-webkit-scrollbar-track {
		background: transparent;
		border-radius: var(--RADIUS_rounded);
	}
	
	.dialogContent > article::-webkit-scrollbar-thumb {
		background: var(--COLOR_gray_400);
		border: 3px solid transparent;
		border-radius: var(--RADIUS_rounded);
		background-clip: content-box;
	}
	
	.dialogContent > article::-webkit-scrollbar-thumb:hover {
		background: var(--COLOR_gray_300);
		border: 3px solid red;
		background-clip: content-box;
	}
	
	.dialogContent > footer {
		padding: 24px var(--inline-padding);
	}
	
	.dialogContent > footer ul {
		width: 100%;
		display: flex;
		flex-flow: wrap;
		gap: 20px;
		justify-content: space-between;
		margin: 0;
		padding: 0;
	}
	
	.dialogContent > footer ul li {
		flex-basis: calc(40% - 20px);
		flex-grow: 1;
		list-style: none;
		text-align: center;
		vertical-align: top;
		margin: 0;
		padding: 0;
	}
	
	/* Full width for Buttons if shown in 2 lines */
	.dialogContent > footer:has(li:nth-child(2)) ::slotted([slot^='button_']) {
		width: 100%;
	}
	
	.dialogContent > footer small {
		display: block;
    	font: var(--FONT_default_50);
    	margin-top: 32px;
	}
</style>
`;

});


parcelRegister("a1ZJs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74d9e2194b2b6ce7$export$2e2bcd8739ae039; });
class $74d9e2194b2b6ce7$export$2e2bcd8739ae039 extends HTMLElement {
    async connectedCallback() {
        const template = document.createElement('template');
        template.innerHTML = `
			<style>
				:host {
					display: block;
				}
				
				@media only screen and (min-width: 601px) {
					:host {
						width: var(--wdk-dialog-width-desktop);
					}
				}
				
				@media only screen and (max-width: 600px) {
					:host([mobile-full-height]) .dialogContent {
						height: 100dvh;
						max-height: 100dvh;
						border-top-left-radius: 0;
						border-top-right-radius: 0;
					}
				}
			</style>
			<div class="dialogContent">
				<article><slot></slot></article>
			</div>
		`;
        const clone = document.importNode(template.content, true);
        if (!this.shadowRoot) {
            this.attachShadow({
                mode: 'open'
            });
            this.shadowRoot.appendChild(clone);
        }
    }
}

});

parcelRegister("bApRT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86f71f66065f2d43$export$2e2bcd8739ae039; });
class $86f71f66065f2d43$export$2e2bcd8739ae039 extends HTMLElement {
    #abortController = null;
    #dialogId = null;
    async connectedCallback() {
        this.#abortController = new AbortController();
        this.#dialogId = this.getAttribute('dialog-id');
        await jPar.util.waitForChildNodes();
        this.addEventListener('click', ()=>{
            document.querySelector('#' + this.#dialogId).openModal();
            this.trackClick();
        }, {
            signal: this.#abortController.signal
        });
    }
    trackClick() {
        const configTemplate = this.querySelector('template[data-tracking]');
        if (configTemplate !== null) {
            let trackingConfig = {};
            try {
                const configText = configTemplate.content.textContent.trim();
                trackingConfig = JSON.parse(configText).tracking;
                const trackingData = {
                    category: trackingConfig.category || '',
                    subcategory: trackingConfig.subcategory || '',
                    targetId: trackingConfig.targetId || '',
                    action: trackingConfig.action || 'click'
                };
                [
                    'cd1',
                    'cd2',
                    'cd3',
                    'cd4',
                    'cd5',
                    'cd6'
                ].forEach((key)=>{
                    if (trackingConfig[key] && trackingConfig[key].trim()) trackingData[key] = trackingConfig[key];
                });
                jPar.util.log.bigData(trackingData);
            } catch (e) {
                console.error('Fehler beim Parsen der JSON Tracking-Konfiguration aus dem Template', e);
            }
        }
    }
    async disconnectedCallback() {
        this.#abortController?.abort();
    }
}

});

parcelRegister("dqHTc", function(module, exports) {

$parcel$export(module.exports, "getUrlWithRemovedParam", function () { return $9c6fbf952b888833$export$868fae3979cec718; });
$parcel$export(module.exports, "awaitTimeout", function () { return $9c6fbf952b888833$export$61b2d63f8d9c8660; });
$parcel$export(module.exports, "hasStorageAccess", function () { return $9c6fbf952b888833$export$308c0cf53c5934ae; });
/**
 * Removes a specified query parameter from a given URL string.
 *
 * @param {string} urlString - The URL string from which the parameter should be removed.
 * @param {string} removeParam - The name of the query parameter to remove.
 * @returns {string} - The new URL string with the specified parameter removed.
 */ function $9c6fbf952b888833$export$868fae3979cec718(urlString, removeParam) {
    const urlObj = new URL(urlString);
    const params = new URLSearchParams(urlObj.search);
    while(params.has(removeParam))params.delete(removeParam);
    const newParamList = params.toString();
    const divider = newParamList !== '' ? '?' : '';
    return urlObj.origin + urlObj.pathname + divider + newParamList;
}
function $9c6fbf952b888833$export$61b2d63f8d9c8660(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
function $9c6fbf952b888833$export$308c0cf53c5934ae() {
    try {
        localStorage.setItem('featureTest', 'true');
        localStorage.removeItem('featureTest');
        return true;
    } catch  {
        return false;
    }
}

});


parcelRegister("hdSdV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $033c59a64368d8ea$export$2e2bcd8739ae039; });
class $033c59a64368d8ea$export$2e2bcd8739ae039 extends HTMLElement {
    connectedCallback() {
        this.querySelectorAll('.js-reloadPage').forEach((reloadLink)=>{
            reloadLink.addEventListener('click', (event)=>{
                event.preventDefault();
                document.location.reload();
            });
        });
    }
}

});

parcelRegister("dxNUL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9dc513693ca9d4a2$export$2e2bcd8739ae039; });
class $9dc513693ca9d4a2$export$2e2bcd8739ae039 extends HTMLElement {
    connectedCallback() {
        this.#hideHintBoxIfPersisted();
        this.#renderHTML();
        this.#initHintboxOnConnect();
    }
    static get observedAttributes() {
        return [
            'hidden'
        ];
    }
    attributeChangedCallback(name) {
        if (name === 'hidden') this.#fillA11yWrapper();
    }
    #hideHintBoxIfPersisted() {
        this.storageNameSpaceKey = this.getAttribute('storageNameSpaceKey');
        this.storageCategoryKey = this.getAttribute('storageCategoryKey');
        if (this.storageNameSpaceKey !== null && this.storageCategoryKey !== null) {
            const isSeen = jPar.app?.appState?.get('localStorage', this.storageNameSpaceKey, this.storageCategoryKey);
            if (isSeen === true) this.hide();
        }
    }
    #renderHTML() {
        const myHtml = `<style>
					:host {
						display: flex;
						flex-shrink: 0;
						gap: 8px;
						margin-top: 8px;
						margin-bottom: 10px;
						align-items: center;
						position: relative;
						color: var(--COLOR_support_white_default);
						font: var(--FONT_default_75);
						border-radius: var(--RADIUS_S);
						padding: 14px;
						height: auto;
						max-height: 350px; 
						opacity: 1;
					}
					
					:host(.closeingAnimation) {
						transform-origin: top left;
						transition: opacity .3s ease-out, max-height .3s ease-out, padding-top .3s ease-out, padding-bottom .3s ease-out; 
					}
					
					:host([hidden]) {
						display: flex !important; /* muss hier leider \xfcberschrieben werden */
						opacity: 0;
						max-height: 0;
						margin: 0;
						padding-top: 0;
						padding-bottom: 0;
					}
					
					:host([skin="success"]) {
						background-color: var(--COLOR_alert_success_default);
						color: var(--COLOR_support_white_default);
						overflow: hidden;
					}

					:host([skin="warning"]) {
						background-color: var(--COLOR_alert_warning_default);
						color: var(--COLOR_support_white_default);
						overflow: hidden;
					}

					:host([skin="info"]) {
						background-color: var(--COLOR_alert_info_default);
						color: var(--COLOR_support_white_default);
						overflow: hidden;
					}

					:host([skin="info2"]) {
						background-color: var(--COLOR_alert_info_light);
    					color: var(--COLOR_alert_info_default);
						overflow: hidden;
					}

					:host([skin="info3"]) {
						background-color: var(--COLOR_gray_500);
						color: var(--COLOR_gray_100);
						overflow: hidden;
					}
					
					:host([skin="healthyDating"]) {
						display: flex;
						align-items: center;
						padding: 16px;
						color: var(--COLOR_defaultText);
						border: 2px solid var(--COLOR_primary_default); 
				
						img {
							margin-right: 8px;
						}
				
						a {
							color: var(--COLOR_defaultText) !important;
						}
					}

					:host a {
						color: currentColor;
						text-decoration: underline;
					}

					:host h3 {
						font: var(--FONT_default_50);
						text-transform: uppercase;
						margin: 0 0 4px 0;
					}

					:host button {
						position: relative;
						border: none;
						background: transparent;
						cursor: pointer;
						align-self: flex-start;
    					margin: 0;
    					padding: 0;
    					width: 18px;
    					height: 18px;
					}
					
					:host button:focus-visible {
						outline: 2px dashed currentColor;
						outline-offset: 10px;
					}

					:host button:after {
						content: "";
    					position: absolute;
    					top: 50%;
    					left: 50%;
    					transform: translate(-50%, -50%);
    					height: 48px;
    					width: 48px;
					}

					:host button:hover {
						opacity: .7;
					}

					:host button svg {
						width: 16px;
						height: 16px;
						fill: var(--COLOR_gray_100);
					}
				
					::slotted([slot="icon"].wdk-icon) {
						width: 22px !important;
						height: 22px !important;
						min-width: 22px;
						fill: currentColor !important;
					}

					#a11yWrapper {
						flex-grow: 1;
					}

					.wdkA11yRepeat {
						position:absolute;
						left:-9999px;
						width: 1px;
						height: 1px;
					}
				</style>
				<slot name="icon"></slot>
				<div id="a11yWrapper" aria-live="assertive" role="alert" aria-atomic="true"></div>
				${this.#getCloseButton()}
			`;
        this.shadowTemplate = document.createElement('template');
        this.shadowTemplate.innerHTML = jPar.wdk.security.sanitizeEvilHtml(myHtml);
    }
    #initHintboxOnConnect() {
        const clone = document.importNode(this.shadowTemplate.content, true);
        if (!this.shadowRoot) {
            this.attachShadow({
                mode: 'open'
            });
            this.shadowRoot.appendChild(clone);
            this.#fillA11yWrapper();
        }
        this.shadowRoot.querySelector('.js-close')?.addEventListener('click', ()=>{
            this.hide();
        });
    }
    #getCloseButton() {
        if (this.getAttribute('closable') !== null) return `<button part="base" class="js-close" type="button" role="button" aria-disabled="false" aria-label="Close" tabindex="0">
        			<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
						<path id="icon_x-a" fill-rule="evenodd" clip-rule="evenodd" d="M19.7044 18.2864C19.8936 18.4741 20 18.7295 20 18.996C20 19.2624 19.8936 19.5179 19.7044 19.7055C19.5168 19.8947 19.2614 20.0011 18.9949 20.0011C18.7285 20.0011 18.4731 19.8947 18.2854 19.7055L12 13.4194L5.71456 19.7055C5.52692 19.8947 5.27151 20.0011 5.00507 20.0011C4.73863 20.0011 4.48321 19.8947 4.29558 19.7055C4.10641 19.5179 4 19.2624 4 18.996C4 18.7295 4.10641 18.4741 4.29558 18.2864L10.581 12.0003L4.29558 5.71418C3.90375 5.3223 3.90375 4.68693 4.29558 4.29505C4.68742 3.90317 5.32272 3.90317 5.71456 4.29505L12 10.5812L18.2854 4.29505C18.6773 3.90317 19.3126 3.90317 19.7044 4.29505C20.0963 4.68693 20.0963 5.3223 19.7044 5.71418L13.419 12.0003L19.7044 18.2864Z"/>
					</svg>
      			</button>
				`;
        else return '';
    }
    #fillA11yWrapper() {
        const lightClone = document.importNode(this.querySelector('template').content, true);
        if (this.shadowRoot !== null && this.hasAttribute('hidden') === false) {
            this.shadowRoot.querySelector('#a11yWrapper').innerHTML = '';
            this.shadowRoot.querySelector('#a11yWrapper').appendChild(lightClone);
            this.#triggerA11yRepeat();
            this.#handleShow();
        }
    }
    #handleShow() {
        if (this.hasAttribute('hidden') === false) {
            this.removeAttribute('inert');
            this.dispatchEvent(new CustomEvent('wdk-hintbox', {
                bubbles: true,
                detail: {
                    state: 'shown',
                    element: this
                }
            }));
        }
    }
    show() {
        this.removeAttribute('hidden');
    }
    hide() {
        this.classList.add('closeingAnimation');
        this.addEventListener('transitionend', function() {
            this.classList.remove('closeingAnimation');
        }, {
            once: true
        });
        this.setAttribute('hidden', '');
        this.setAttribute('inert', 'true');
        if (this.storageNameSpaceKey !== null && this.storageCategoryKey !== null) jPar.app?.appState?.set('localStorage', this.storageNameSpaceKey, this.storageCategoryKey, true);
        this.dispatchEvent(new CustomEvent('wdk-hintbox', {
            bubbles: true,
            detail: {
                state: 'hidden',
                element: this
            }
        }));
    }
    #triggerA11yRepeat() {
        window.setTimeout(()=>{
            const myDiv = document.createElement('div');
            myDiv.classList.add('wdkA11yRepeat');
            myDiv.innerText = '!';
            this.shadowRoot.querySelector('#a11yWrapper').appendChild(myDiv);
        }, 200);
    }
    isVisible() {
        return this.getAttribute('hidden') === 'false';
    }
}

});

parcelRequire("aARjA");
parcelRequire("9GUbU");
parcelRequire("DAqcY");
parcelRequire("c5qCG");
parcelRequire("iVy6J");
parcelRequire("5fGOo");
parcelRequire("7BphF");
parcelRequire("bpIsd");
parcelRequire("8UdKr");
parcelRequire("jWUCj");
parcelRequire("7NWf9");
parcelRequire("47BUi");
parcelRequire("fWFpU");
parcelRequire("jViHV");
parcelRequire("DhLhF");
parcelRequire("4oI1F");
parcelRequire("7mtHF");
parcelRequire("59Ooq");
parcelRequire("dNG6s");
jPar.loginAndRegistration = jPar.loginAndRegistration || {};
$j(function() {
    try {
        jPar.Tracking.init();
    } catch (e) {
        jPar.util.log.error(e.stack, 'jPar.loginAndRegistration: Init external libs failed');
    }
    if (document.body.id === 'loginPage') jPar.loginAndRegistration.loginPage.init();
    if (document.body.id === 'verificationPage') jPar.loginAndRegistration.verificationPage.init();
    if (document.body.id === 'registrationPage') jPar.loginAndRegistration.registrationPage.init();
    if (document.body.id === 'passwordPage') jPar.loginAndRegistration.passwordPage.init();
    if (document.querySelector('#genderSelectionPage')) {
        if (document.body.classList.contains('isNewGenderScreenEnabled')) jPar.loginAndRegistration.genderSelectPage.init();
        else jPar.loginAndRegistration.genderSelectPage_deprecated.init();
    }
    if (document.querySelector('#searchGenderSelectionPage')) jPar.loginAndRegistration.searchGenderSelectPage.init();
    try {
        jPar.util.pwa.init();
        jPar.wdk.screensize.setScreenSizeCookie();
        jPar.util.timezone.setTimezone();
    } catch (e) {
        jPar.util.log.error(e.stack, 'jPar.loginAndRegistration: low prio failed');
    }
});


jPar.loginAndRegistration.util = jPar.loginAndRegistration.util || {};
$j.extend(true, jPar.loginAndRegistration, {
    util: {
        showLoadingAnimation: function showLoadingAnimation() {
            $j('#wrapperForLoadingAnimation').addClass('hidden');
            $j('#loadingText').addClass('is-visible');
            $j('#regFormSubmit').attr('disabled', true);
        },
        hideLoadingAnimation: function hideLoadingAnimation() {
            $j('.directSocialSignOn').removeClass('directSocialSignOn');
            $j('#wrapperForLoadingAnimation').removeClass('hidden');
            $j('#loadingText').removeClass('is-visible');
            $j('#regFormSubmit').attr('disabled', false);
        }
    }
});


jPar.loginAndRegistration = jPar.loginAndRegistration || {};
$j.extend(true, jPar.loginAndRegistration, {
    genderSelectPage: {
        initialValueMainGender: null,
        init: function() {
            this.tracking.trackPageView();
            this.renderInitialState();
            document.querySelectorAll('#changeGenderForm input[name="gender"]').forEach((el)=>{
                el.addEventListener('click', (ev)=>{
                    const value = ev.currentTarget.value;
                    if (value === this.initialValueMainGender) return;
                    this.selectMainGender();
                    this.tracking.trackMainGenderChange(value, this.initialValueMainGender);
                    this.initialValueMainGender = value;
                });
            });
            this.initialValueMainGender = document.querySelector('#changeGenderForm input:checked')?.value;
        },
        renderInitialState: function() {
            if (document.querySelector('#changeGenderForm input[name="gender"]:checked')) document.querySelector('#nextButton').disabled = false;
        },
        selectMainGender: function() {
            document.querySelector('#nextButton').disabled = false;
        },
        tracking: {
            trackPageView: function() {
                jPar.util.log.bigData({
                    category: 'registration',
                    subcategory: 'own_gender_select_screen',
                    action: 'screen_view'
                });
            },
            trackMainGenderChange: function(newGender, oldGender) {
                const createValueForTracking = (gender)=>{
                    switch(gender){
                        case 'MALE':
                            return 'button_man';
                        case 'FEMALE':
                            return 'button_woman';
                        case 'DIVERSE':
                            return 'button_nonbinary';
                    }
                };
                jPar.util.log.bigData({
                    category: 'registration',
                    subcategory: 'own_gender_select_screen',
                    action: 'click',
                    targetId: 'gender',
                    cd1: createValueForTracking(oldGender) || '',
                    cd2: createValueForTracking(newGender)
                });
            }
        }
    }
});


jPar.loginAndRegistration = jPar.loginAndRegistration || {};
$j.extend(true, jPar.loginAndRegistration, {
    genderSelectPage_deprecated: {
        init: function init() {
            jPar.wdk.forms.init();
            this.genderSelectBox.init();
            document.querySelector('#formGenderSelection').addEventListener('submit', (event)=>{
                this.validate.validateForm();
                if (jPar.wdk.forms.hasVisibleErrors(event.target)) event.preventDefault();
            });
        },
        genderSelectBox: {
            hasEsSex: true,
            init: function() {
                this.hasEsSex = document.querySelector('#essexRow') !== null;
                document.querySelectorAll('#formGenderSelection #mysexRow input[type=radio]').forEach((mySexRadio)=>{
                    mySexRadio.addEventListener('click', (event)=>{
                        this.mySexClick(event);
                    });
                });
                document.querySelectorAll('#formGenderSelection #essexRow input[type=checkbox]').forEach((esSexCheckbox)=>{
                    esSexCheckbox.addEventListener('click', (event)=>{
                        this.esSexClick(event);
                    });
                });
            },
            mySexClick: function(event) {
                this.preselectEsSex(event.target);
                this.handleHideError();
            },
            esSexClick: function(event) {
                event.preventDefault();
                event.stopPropagation();
                window.setTimeout(function() {
                    // Der Browser meldet hier ansonsten falschen checked status, warum ist das so???
                    if (event.target.checked === false) event.target.checked = true;
                    else {
                        const othercheckboxId = event.target.id === 'essexM' ? 'essexW' : 'essexM';
                        const deselectAllowed = document.querySelector('#formGenderSelection #essexRow #' + othercheckboxId).checked === true;
                        if (deselectAllowed) event.target.checked = false;
                    }
                }, 0);
                this.preselectMySex(event.target);
                this.syncEsSexForSubmit();
                this.handleHideError();
            },
            preselectMySex: function(changedElement) {
                if (jPar.wdk.brands.forBrands([
                    'ps',
                    'ep'
                ])) {
                    const hasNotCheckedMySex = document.querySelectorAll('#formGenderSelection #mysexRow [type=radio]:checked').length === 0;
                    if (hasNotCheckedMySex) {
                        // 0 = male; 1 = female; 3 = all;
                        const esSexValue = changedElement.value;
                        if (esSexValue === '0') document.querySelector('#formGenderSelection #mysexW').click();
                        else document.querySelector('#formGenderSelection #mysexM').click();
                    }
                }
            },
            preselectEsSex: function(changedElement) {
                if (jPar.wdk.brands.forBrands([
                    'ps',
                    'ep'
                ]) && this.hasEsSex) {
                    const hasNotCheckedEsSex = document.querySelectorAll('#formGenderSelection #essexRow [type=checkbox]:checked').length === 0;
                    if (hasNotCheckedEsSex) {
                        // 0 = male; 1 = female; 3 = all;
                        const mySexValue = changedElement.value;
                        if (mySexValue === '0') document.querySelector('#formGenderSelection #essexW').click();
                        else document.querySelector('#formGenderSelection #essexM').click();
                    }
                }
            },
            syncEsSexForSubmit: function() {
                const femaleChecked = document.querySelector('#formGenderSelection #essexRow #essexW:checked') !== null;
                const maleChecked = document.querySelector('#formGenderSelection #essexRow #essexM:checked') !== null;
                if (femaleChecked && maleChecked) document.querySelector('#formGenderSelection #hiddenEssex').value = '3';
                else if (femaleChecked) document.querySelector('#formGenderSelection #hiddenEssex').value = '1';
                else if (maleChecked) document.querySelector('#formGenderSelection #hiddenEssex').value = '0';
            },
            handleHideError: function() {
                const mysexChecked = document.querySelectorAll('#formGenderSelection input[name="mysex"]:checked').length === 1;
                let essexChecked;
                if (this.hasEsSex) essexChecked = document.querySelector('#formGenderSelection input[name="essex"]').value !== '';
                else essexChecked = true;
                if (mysexChecked && essexChecked) jPar.wdk.forms.hideError(document.querySelector('#formGenderSelection  #regsexError'));
            }
        },
        validate: {
            validateForm: function validateForm() {
                this.validateSex();
            },
            validateSex: function validateSex() {
                jPar.wdk.forms.showError(document.querySelector('#regsexError'));
                const hasNoSelectedMySex = document.querySelectorAll('#formGenderSelection input[name="mysex"]:checked').length === 0;
                let hasNoSelectedEsSex;
                if (jPar.loginAndRegistration.genderSelectPage_deprecated.genderSelectBox.hasEsSex) hasNoSelectedEsSex = document.querySelector('#formGenderSelection input[name="essex"]').value === '';
                else hasNoSelectedEsSex = false;
                if (hasNoSelectedMySex || hasNoSelectedEsSex) jPar.wdk.forms.showError(document.querySelector('#regsexError'));
                else jPar.wdk.forms.hideError(document.querySelector('#regsexError'));
            }
        }
    }
});


jPar.loginAndRegistration = jPar.loginAndRegistration || {};
$j.extend(true, jPar.loginAndRegistration, {
    loginPage: {
        init: function init() {
            jPar.wdk.forms.init();
            this.validate.init();
            this.socialSignOn.init();
            this.stayLoggedInInfo();
            this.accessTokenSubmit();
            try {
                this.loginDelay();
            } catch (e) {
                jPar.util.log.error(e.stack, 'jPar.loginAndRegistration.loginPage.init: low prio failed');
            }
            if ($j('#verificationCodeFailedModal').length > 0) jPar.wdk.modalbox.show({
                modalboxId: 'verificationCodeFailedModal'
            });
            // kann im iframe im messenger geladen werden bei abgelaufener Session
            parent.postMessage({
                domLoaded: 'loginPage'
            }, window.location.origin);
        },
        emailPermissionRetries: 0,
        validate: {
            init: function init() {
                try {
                    const _this = this;
                    $j('#loginFormSubmit').on('click', function(event) {
                        _this.submitForm(event);
                    });
                    $j('#loginFormEmail').on('change', function(event) {
                        if (jPar.util.validate.isNotTabOrShiftKey(event.keyCode) && $j(this).val() !== '') _this.validateEmail();
                    });
                    $j('#loginFormPasswort').on('keyup change', function(event) {
                        if (jPar.util.validate.isNotTabOrShiftKey(event.keyCode)) _this.validatePassword();
                    });
                } catch (e) {
                    jPar.util.log.error(e.stack, 'jPar.loginAndRegistration.loginPage.validate.init');
                }
            },
            validateEmail: function validateEmail() {
                const $elem = $j('#emailRow');
                const $errorElement = $elem.find('#loginFormEmailError');
                const $emailElement = $elem.find('#loginFormEmail');
                const isEmailEmpty = jPar.util.validate.textfieldIsEmpty($emailElement);
                const isNotEmail = jPar.util.validate.isEmailAddress($emailElement) === false;
                if (isNotEmail || isEmailEmpty) jPar.wdk.forms.showError($errorElement);
                else jPar.wdk.forms.hideError($errorElement);
            },
            validatePassword: function validatePassword() {
                const $elem = $j('#passwordRow');
                const $errorElement = $elem.find('#loginFormPasswordError');
                if (jPar.util.validate.textfieldIsEmpty($elem.find('#loginFormPasswort'))) jPar.wdk.forms.showError($errorElement);
                else jPar.wdk.forms.hideError($errorElement);
            },
            validateCompleteForm: function validateCompleteForm() {
                jPar.wdk.forms.hideError($j('#loginError2'));
                this.validateEmail();
                this.validatePassword();
            },
            hasValidationErrors: function hasValidationErrors() {
                return jPar.wdk.forms.hasVisibleErrors($j('#loginForm'));
            },
            submitForm: function submitForm(event) {
                this.validateCompleteForm();
                if (this.hasValidationErrors()) event.preventDefault();
                else jPar.loginAndRegistration.util.showLoadingAnimation();
            }
        },
        loginDelay: function loginDelay() {
            const loginDelay = $j('#loadingText').data('logindelay');
            if (loginDelay !== undefined) window.setTimeout(function() {
                jPar.loginAndRegistration.util.hideLoadingAnimation();
            }, loginDelay);
        },
        stayLoggedInInfo: function() {
            $j('.js-showStayLoggedInModal').on('click', function(event) {
                event.preventDefault();
                jPar.wdk.modalbox.show({
                    modalboxId: 'stayLoggedInModal'
                });
            });
        },
        accessTokenSubmit: function() {
            if (document.querySelector('body.accessTokenPage') !== null) document.getElementById('loginForm').submit();
        }
    }
});


jPar.loginAndRegistration.loginPage = jPar.loginAndRegistration.loginPage || {};
deepMerge(true, jPar.loginAndRegistration.loginPage, {
    socialSignOn: {
        init: function() {
            const hasAppleSocialButton = document.querySelector('peg-apple-social-button') !== null;
            const hasGoogleSocialButton = document.querySelector('peg-google-social-button') !== null;
            if (hasAppleSocialButton) this.apple.checkAutosubmit();
            if (hasGoogleSocialButton) this.google.init();
        },
        google: {
            init: function init() {
                this.error.showGoogleBackendErrorModal();
                this.error.showErrorNoEMailAdressModal();
                this.checkAutosubmit();
            },
            checkAutosubmit: function() {
                const isFromGoogle = jPar.util.getGetParamFromUrl('scope') !== undefined;
                const hasNoError = jPar.util.getGetParamFromUrl('error') === undefined;
                const hasCode = jPar.util.getGetParamFromUrl('code') !== undefined;
                if (isFromGoogle && hasNoError && hasCode) {
                    const form = document.querySelector('#loginForm');
                    this.addHiddenInputfields(form);
                    form.submit();
                }
            },
            addHiddenInputfields: function(form) {
                const socialProviderInput = document.createElement('input');
                socialProviderInput.type = 'hidden';
                socialProviderInput.name = 'socialProvider';
                socialProviderInput.value = 'GOOGLE';
                const socialAccessTokenInput = document.createElement('input');
                socialAccessTokenInput.type = 'hidden';
                socialAccessTokenInput.name = 'socialAccessToken';
                socialAccessTokenInput.value = jPar.util.getGetParamFromUrl('code');
                form.appendChild(socialProviderInput);
                form.appendChild(socialAccessTokenInput);
            },
            error: {
                showGoogleBackendErrorModal: function showGoogleBackendErrorModal() {
                    if (document.querySelector('#googleBackendErrorModal') !== null) jPar.wdk.modalbox.show({
                        modalboxId: 'googleBackendErrorModal'
                    });
                },
                showErrorNoEMailAdressModal: function() {
                    if (document.querySelector('#googleNoEMailAdress') !== null) jPar.wdk.modalbox.show({
                        modalboxId: 'googleNoEMailAdress'
                    });
                }
            }
        },
        apple: {
            checkAutosubmit: function() {
                // Return URL: /appleCallback?socialProvider=APPLE&id_token=eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6I&code=eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6I&user=
                const isReturnFromApple = jPar.util.getGetParamFromUrl('socialProvider') === 'APPLE';
                const hasNoError = jPar.util.getGetParamFromUrl('error') === undefined;
                this.error.showAppleBackendErrorModal();
                if (isReturnFromApple && hasNoError) {
                    this.localFormPreparation();
                    jPar.loginAndRegistration.util.showLoadingAnimation();
                    document.querySelector('#loginForm').submit();
                }
            },
            localFormPreparation: function() {
                const appleButton = document.querySelector('peg-apple-social-button');
                const idToken = appleButton && appleButton.getAttribute('social-provider-token') !== null ? appleButton.getAttribute('social-provider-token') : jPar.wdk.security.escapeStringForHtml(jPar.util.getGetParamFromUrl('id_token')); // <- deprecated by MOVE_TOKEN_PARAMETER_FROM_APPLE_LOGIN_BY_MANTIS - set empty string if appleButton.getAttribute('social-provider-token') = null
                const code = jPar.wdk.security.escapeStringForHtml(jPar.util.getGetParamFromUrl('code')); // Apple Information
                const user = jPar.util.getGetParamFromUrl('user'); // don't sanitize, because the param 'user' is a json, see: https://developer.apple.com/documentation/sign_in_with_apple/sign_in_with_apple_js/incorporating_sign_in_with_apple_into_other_platforms
                const template = document.createElement('template');
                const filledHiddenInputs = `
					<div>
						<input type="hidden" name="socialProvider" value="APPLE">
						<input type="hidden" name="id_token" value="${idToken}">
						<input type="hidden" name="code" value="${code}">
						<input type="hidden" name="user" value="${user}">
					</div>
				`;
                template.innerHTML = jPar.wdk.security.sanitizeEvilHtml(filledHiddenInputs);
                const node = template.content.firstElementChild;
                document.querySelector('#loginForm').appendChild(node);
            },
            error: {
                showAppleBackendErrorModal: function showAppleBackendErrorModal() {
                    if (document.querySelector('#appleBackendErrorModal') !== null) jPar.wdk.modalbox.show({
                        modalboxId: 'appleBackendErrorModal'
                    });
                }
            }
        }
    }
});


jPar.loginAndRegistration = jPar.loginAndRegistration || {};
$j.extend(true, jPar.loginAndRegistration, {
    countdown: {
        start (endTimeMillis, timeout, callback, finishedCallback) {
            callback(this.getRemainingTime(endTimeMillis));
            return setInterval(()=>{
                const remaining = this.getRemainingTime(endTimeMillis);
                callback(remaining);
                if (remaining.total <= 0) finishedCallback();
            }, timeout);
        },
        stop (countdownInterval) {
            clearInterval(countdownInterval);
        },
        getRemainingTime (endTimeMillis) {
            const total = Date.parse(new Date(endTimeMillis)) - new Date().getTime();
            const seconds = Math.floor(total / 1000 % 60);
            const minutes = Math.floor(total / 1000 / 60 % 60);
            const hours = Math.floor(total / 3600000 % 24);
            const days = Math.floor(total / 86400000);
            return {
                total: total,
                days: days,
                hours: hours,
                minutes: minutes,
                seconds: seconds
            };
        }
    }
});


jPar.loginAndRegistration = jPar.loginAndRegistration || {};
deepMerge(true, jPar.loginAndRegistration, {
    passwordPage: {
        init: function init() {
            jPar.wdk.forms.init();
            this.trackingInit();
            try {
                jPar.wdk.passwordRestrictionBox.init();
                document.querySelector('#passwordForm').addEventListener('submit', (event)=>{
                    this.validatePassword();
                    if (jPar.wdk.forms.hasVisibleErrors(document.querySelector('#passwordForm'))) event.preventDefault();
                });
            } catch (e) {
                jPar.util.log.error(e.stack, 'jPar.loginAndRegistration.passwordPage.init: low prio failed');
            }
        },
        validatePassword: function validatePassword() {
            jPar.wdk.passwordRestrictionBox.checkPasswordRestrictions();
            const passwordEmptyError = document.querySelector('#passwordEmptyError');
            const passwordNotValidError = document.querySelector('#passwordNotValidError');
            if (jPar.util.validate.textfieldIsEmpty(document.querySelector('#passFormPassword'))) {
                jPar.wdk.forms.showError(passwordEmptyError);
                jPar.wdk.forms.hideError(passwordNotValidError);
            } else if (jPar.wdk.passwordRestrictionBox.isPasswordValid() === false) {
                jPar.wdk.forms.showError(passwordNotValidError);
                jPar.wdk.forms.hideError(passwordEmptyError);
            } else {
                jPar.wdk.forms.hideError(passwordNotValidError);
                jPar.wdk.forms.hideError(passwordEmptyError);
            }
        },
        trackingInit () {
            jPar.util.log.bigData({
                category: 'registration',
                subcategory: 'password_start_screen',
                action: 'view'
            });
            document.querySelector('#passwordForm').addEventListener('submit', ()=>{
                jPar.util.log.bigData({
                    category: 'registration',
                    subcategory: 'password_start_screen',
                    action: 'submit',
                    targetId: 'button_password'
                });
            });
        }
    }
});


jPar.loginAndRegistration = jPar.loginAndRegistration || {};
$j.extend(true, jPar.loginAndRegistration, {
    registrationPage: {
        conf: {
            emailNoticeInput: '#regFormEmail',
            emailNoticeBox: '#emailNoticeBox'
        },
        emailPermissionRetries: 0,
        init: function init() {
            this.validate.init();
            this.genderSelectBox.init();
            jPar.wdk.forms.init();
            this.socialSignOn.init();
            this.trackingInit();
            try {
                this.emailNoticeBox();
                jPar.wdk.passwordRestrictionBox.init();
                this.openDuplicateEmailModal();
            } catch (e) {
                jPar.util.log.error(e.stack, 'jPar.loginAndRegistration.registrationPage.init: low prio failed');
            }
        },
        openDuplicateEmailModal: function init() {
            if ($j('#duplicateEmail').length > 0) jPar.wdk.modalbox.show({
                modalboxId: 'duplicateEmail'
            });
        },
        genderSelectBox: {
            init: function() {
                const _this = this;
                document.querySelectorAll('#formRegistration #mysexRow input[type=radio]').forEach(function(mySexRadio) {
                    mySexRadio.addEventListener('click', function(event) {
                        _this.mySexClick(event);
                    });
                });
                document.querySelectorAll('#formRegistration #essexRow input[type=checkbox]').forEach(function(esSexCheckbox) {
                    esSexCheckbox.addEventListener('click', function(event) {
                        _this.esSexClick(event);
                    });
                });
            },
            mySexClick: function(event) {
                document.querySelectorAll('#formRegistration input[type=radio]').forEach(function(currentElem) {
                    currentElem.closest('label').classList.remove('selected');
                });
                event.target.closest('label').classList.add('selected');
                this.preselectEsSex(event.target);
                this.handleHideError();
            },
            esSexClick: function(event) {
                event.preventDefault();
                event.stopPropagation();
                window.setTimeout(function() {
                    // Der Browser meldet hier ansonsten falschen checked status
                    if (event.target.checked === false) {
                        event.target.checked = true;
                        event.target.closest('label').classList.add('selected');
                    } else {
                        const othercheckboxId = event.target.id === 'essexM' ? 'essexW' : 'essexM';
                        const deselectAllowed = document.querySelector('#essexRow #' + othercheckboxId).checked === true;
                        if (deselectAllowed) {
                            event.target.checked = false;
                            event.target.closest('label').classList.remove('selected');
                        }
                    }
                }, 0);
                this.preselectMySex(event.target);
                this.syncEsSexForSubmit();
                this.handleHideError();
            },
            preselectMySex: function(changedElement) {
                if (jPar.wdk.brands.forBrands([
                    'ps',
                    'ep'
                ])) {
                    const hasNotCheckedMySex = document.querySelectorAll('#formRegistration #mysexRow [type=radio]:checked').length === 0;
                    if (hasNotCheckedMySex) {
                        const esSexValue = changedElement.value;
                        const isGayAndEssexFemale = esSexValue === '1' && document.querySelector('#formRegistration.gay') !== null;
                        const isHeteroAndEssexMale = esSexValue === '0' && document.querySelector('#formRegistration.hetero') !== null;
                        if (isGayAndEssexFemale || isHeteroAndEssexMale) document.querySelector('#formRegistration #mysexW').click();
                        else document.querySelector('#formRegistration #mysexM').click();
                    }
                }
            },
            preselectEsSex: function(changedElement) {
                if (jPar.wdk.brands.forBrands([
                    'ps',
                    'ep'
                ])) {
                    const hasNotCheckedEsSex = document.querySelectorAll('#formRegistration #essexRow [type=checkbox]:checked').length === 0;
                    if (hasNotCheckedEsSex) {
                        // 0 = male; 1 = female; 3 = all;
                        const mySexValue = changedElement.value;
                        const isGayAndMysexFemale = mySexValue === '1' && document.querySelector('#formRegistration.gay') !== null;
                        const isHeteroAndMysexMale = mySexValue === '0' && document.querySelector('#formRegistration.hetero') !== null;
                        if (isGayAndMysexFemale || isHeteroAndMysexMale) document.querySelector('#formRegistration #essexW').click();
                        else document.querySelector('#formRegistration #essexM').click();
                    }
                }
            },
            syncEsSexForSubmit: function() {
                const femaleChecked = document.querySelector('#formRegistration #essexRow #essexW:checked') !== null;
                const maleChecked = document.querySelector('#formRegistration #essexRow #essexM:checked') !== null;
                if (femaleChecked && maleChecked) document.querySelector('#hiddenEssex').value = '3';
                else if (femaleChecked) document.querySelector('#hiddenEssex').value = '1';
                else if (maleChecked) document.querySelector('#hiddenEssex').value = '0';
            },
            handleHideError: function() {
                const mysexChecked = document.querySelectorAll('#formRegistration #mysexRow [type=radio]:checked').length === 1;
                const essexChecked = document.querySelectorAll('#formRegistration #essexRow [type=checkbox]:checked').length >= 1;
                if (mysexChecked && essexChecked) jPar.wdk.forms.hideError($j('#regsexError'));
            }
        },
        // Toggeld die Hilfebox zur Email-Adresse (unsichtbar und gut geschuetzt usw.)
        emailNoticeBox: function emailNoticeBox() {
            const _this = this;
            $j(_this.conf.emailNoticeInput).on('focus', function() {
                $j(_this.conf.emailNoticeBox).fadeIn(400);
            });
            $j(_this.conf.emailNoticeInput).on('blur', function() {
                $j(_this.conf.emailNoticeBox).fadeOut(400);
            });
        },
        trackingInit () {
            jPar.util.log.bigData({
                category: 'registration',
                subcategory: 'registration_start_screen',
                action: 'view'
            });
            document.querySelector('#formRegistration').addEventListener('submit', function() {
                jPar.util.log.bigData({
                    category: 'registration',
                    subcategory: 'registration_start_screen',
                    action: 'click',
                    targetId: 'button_registration'
                });
            });
        }
    }
});


jPar.loginAndRegistration.registrationPage = jPar.loginAndRegistration.registrationPage || {};
deepMerge(true, jPar.loginAndRegistration.registrationPage, {
    socialSignOn: {
        init: function() {
            const hasAppleSocialButton = document.querySelector('peg-apple-social-button') !== null;
            const hasGoogleSocialButton = document.querySelector('peg-google-social-button') !== null;
            if (hasAppleSocialButton) this.apple.init();
            if (hasGoogleSocialButton) this.google.init();
        },
        google: {
            init: function() {
                this.error.showGoogleBackendErrorModal();
                this.error.showErrorNoEMailAdressModal();
                this.checkAutosubmit();
            },
            checkAutosubmit: function() {
                // /profile/registration/?scope=email&code=213214214&state=action%3Dreg%26oid%3D1%26search%3D10
                const isFromGoogle = jPar.util.getGetParamFromUrl('scope') !== undefined;
                const hasNoError = jPar.util.getGetParamFromUrl('error') === undefined;
                const hasCode = jPar.util.getGetParamFromUrl('code') !== undefined;
                if (isFromGoogle && hasNoError && hasCode) {
                    const form = document.querySelector('#formRegistration');
                    form.dataset.clickFromSocialLogin = 'true';
                    this.addHiddenInputfields(form);
                    form.submit();
                }
            },
            addHiddenInputfields: function(form) {
                const socialProviderInput = document.createElement('input');
                socialProviderInput.type = 'hidden';
                socialProviderInput.name = 'socialProvider';
                socialProviderInput.value = 'GOOGLE';
                const socialAccessTokenInput = document.createElement('input');
                socialAccessTokenInput.type = 'hidden';
                socialAccessTokenInput.name = 'socialAccessToken';
                socialAccessTokenInput.value = jPar.util.getGetParamFromUrl('code');
                form.appendChild(socialProviderInput);
                form.appendChild(socialAccessTokenInput);
                let state = jPar.util.getGetParamFromUrl('state');
                if (state) {
                    state = decodeURIComponent(state);
                    if (document.querySelector('#mysexEssexRow') === null) {
                        const decodedStateValue = decodeURIComponent(state);
                        const stateParams = new URLSearchParams(decodedStateValue);
                        const gender = stateParams.get('search');
                        const mysex = stateParams.get('mysex');
                        const searchGenders = stateParams.get('searchGenders');
                        const genderInput = document.createElement('input');
                        genderInput.type = 'hidden';
                        genderInput.name = 'gender';
                        genderInput.value = gender;
                        const mysexInput = document.createElement('input');
                        genderInput.type = 'hidden';
                        genderInput.name = 'mysex';
                        genderInput.value = mysex;
                        const searchGendersInput = document.createElement('input');
                        searchGendersInput.type = 'hidden';
                        searchGendersInput.name = 'searchGenders';
                        searchGendersInput.value = searchGenders;
                        form.appendChild(genderInput);
                        form.appendChild(mysexInput);
                        form.appendChild(searchGendersInput);
                    }
                }
            },
            error: {
                showGoogleBackendErrorModal: function showGoogleBackendErrorModal() {
                    if (document.querySelector('#googleBackendErrorModal') !== null) jPar.wdk.modalbox.show({
                        modalboxId: 'googleBackendErrorModal'
                    });
                },
                showErrorNoEMailAdressModal: function() {
                    if (document.querySelector('#googleNoEMailAdress') !== null) jPar.wdk.modalbox.show({
                        modalboxId: 'googleNoEMailAdress'
                    });
                }
            }
        },
        apple: {
            init: function() {
                this.setEventlistener();
                this.error.showAppleBackendErrorModal();
                this.error.showErrorNoRegModal();
                this.checkAutosubmit();
            },
            setEventlistener: function() {
                let isValidform = false;
                document.querySelectorAll('#formRegistration input[type=radio], #formRegistration input[type=checkbox]').forEach(function(element) {
                    element.addEventListener('click', function() {
                        setTimeout(function() {
                            isValidform = true;
                            const mySex = document.querySelector('#mysexRow input:checked').value;
                            const esSex = document.querySelector('#essexRow #hiddenEssex').value;
                            document.querySelector('peg-apple-social-button').setAttribute('orientation', mySex + esSex);
                        }, 50);
                    });
                });
                document.querySelector('peg-apple-social-button').addEventListener('click', ()=>{
                    if (isValidform === false) {
                        event.preventDefault();
                        jPar.loginAndRegistration.registrationPage.validate.validateSex({});
                    }
                });
            },
            checkAutosubmit: function() {
                // Return URL GET: /profile/registration?state=action%3Dreg%26oid%3D1%26search%3D10&code=c7c2135cecefa48d285d86a4a193347e3.0.sztx.WEf9EEabvDADxprdDr8HNQ&id_token=eyJraWQiOiJweWFSUXBBYm5ZIiwiYWxnIjoiUlMyNTYifQxxx&socialProvider=APPLE
                const isFromApple = jPar.util.getGetParamFromUrl('socialProvider') === 'APPLE';
                const hasNoError = jPar.util.getGetParamFromUrl('error') === undefined;
                if (isFromApple && hasNoError) {
                    this.selectGenderInUi();
                    const form = document.querySelector('#formRegistration');
                    form.dataset.clickFromSocialLogin = 'true';
                    this.localFormPreparation();
                    form.submit();
                }
            },
            selectGenderInUi: function() {
                const url = window.location.href;
                const params = new URLSearchParams(url.split('?')[1]);
                const stateValue = params.get('state');
                const decodedStateValue = decodeURIComponent(stateValue);
                const stateParams = new URLSearchParams(decodedStateValue);
                const genderSearch = stateParams.get('search');
                if (genderSearch === '10') {
                    document.querySelector('#mysexW').click();
                    document.querySelector('#essexM').click();
                } else if (genderSearch === '01') {
                    document.querySelector('#mysexM').click();
                    document.querySelector('#essexW').click();
                } else if (genderSearch === '11') {
                    document.querySelector('#mysexW').click();
                    document.querySelector('#essexW').click();
                } else if (genderSearch === '00') {
                    document.querySelector('#mysexM').click();
                    document.querySelector('#essexM').click();
                }
            },
            localFormPreparation: function() {
                const appleButton = document.querySelector('peg-apple-social-button');
                const idToken = appleButton && appleButton.getAttribute('social-provider-token') !== null ? appleButton.getAttribute('social-provider-token') : jPar.wdk.security.escapeStringForHtml(jPar.util.getGetParamFromUrl('id_token')); // <- deprecated by MOVE_TOKEN_PARAMETER_FROM_APPLE_LOGIN_BY_MANTIS - set empty string if appleButton.getAttribute('social-provider-token') = null
                const code = jPar.wdk.security.escapeStringForHtml(jPar.util.getGetParamFromUrl('code')); // Apple Information
                const user = jPar.util.getGetParamFromUrl('user'); // don't sanitize, because the param 'user' is a json, see: https://developer.apple.com/documentation/sign_in_with_apple/sign_in_with_apple_js/incorporating_sign_in_with_apple_into_other_platforms
                const template = document.createElement('template');
                const filledHiddenInputs = `
					<div>
						<input type="hidden" name="socialProvider" value="APPLE">
						<input type="hidden" name="id_token" value="${idToken}">
						<input type="hidden" name="code" value="${code}">
						<input type="hidden" name="user" value="${user}">
					</div>
				`;
                template.innerHTML = jPar.wdk.security.sanitizeEvilHtml(filledHiddenInputs);
                const node = template.content.firstElementChild;
                document.querySelector('#formRegistration').appendChild(node);
            },
            error: {
                showAppleBackendErrorModal: function showAppleBackendErrorModal() {
                    if (document.querySelector('#appleBackendErrorModal') !== null) jPar.wdk.modalbox.show({
                        modalboxId: 'appleBackendErrorModal'
                    });
                },
                showErrorNoRegModal: function() {
                    if (document.querySelector('#appleNoReg') !== null) jPar.wdk.modalbox.show({
                        modalboxId: 'appleNoReg'
                    });
                }
            }
        }
    }
});


jPar.loginAndRegistration.registrationPage = jPar.loginAndRegistration.registrationPage || {};
$j.extend(true, jPar.loginAndRegistration.registrationPage, {
    // Ueberprueft die Formularwerete und stoppt ggf. den submit
    validate: {
        conf: {
            registrationFormName: '#formRegistration'
        },
        init: function init() {
            try {
                const _this = this;
                $j(this.conf.registrationFormName + ' #regFormEmail').on('keyup change', function() {
                    if ($j('#regFormEmail').parents('.wdk-form-text').hasClass('has-error')) _this.validateEmail();
                });
                $j(this.conf.registrationFormName + ' input.checkPassword[type=password]').on('focus', function() {
                    jPar.wdk.forms.hideError($j('#regPasswordEmptyError'));
                    jPar.wdk.forms.hideError($j('#regPasswordNotValidError'));
                });
                $j(this.conf.registrationFormName).on('submit', function(event) {
                    _this.validateForm({
                        clickFromSocialLogin: $j('#formRegistration').data('clickFromSocialLogin')
                    });
                    $j('#formRegistration').data('clickFromSocialLogin', false);
                    const isTurnstileInvalid = document.querySelector(`${_this.conf.registrationFormName} peg-turnstile`)?.validate() === false;
                    if (jPar.wdk.forms.hasVisibleErrors($j(_this.conf.registrationFormName)) || isTurnstileInvalid) event.preventDefault();
                    else jPar.loginAndRegistration.util.showLoadingAnimation();
                });
            } catch (e) {
                jPar.util.log.error(e.stack, 'jPar.loginAndRegistration.registrationPage.validate.init');
            }
        },
        validateForm: function validateForm(param) {
            param = param || {};
            this.validateSex(param);
            this.validateEmail(param);
            this.validatePassword(param);
        },
        validateSex: function validateSex() {
            // DEV-32423
            if (document.querySelector('#mysexEssexRow') === null) return;
            if (!$j('input[name="mysex"]:checked').length || ($j('input[name="essex"]').val(), false)) jPar.wdk.forms.showError($j('#regsexError'));
            else jPar.wdk.forms.hideError($j('#regsexError'));
        },
        validateEmail: function validateEmail(param) {
            param = param || {};
            const eMailField = $j('#regFormEmail');
            const isEmailEmptyOrNotValidAddress = jPar.util.validate.textfieldIsEmpty(eMailField) || jPar.util.validate.isEmailAddress(eMailField) === false;
            if (param.clickFromSocialLogin === false && isEmailEmptyOrNotValidAddress) jPar.wdk.forms.showError($j('#regEmailError'));
            else jPar.wdk.forms.hideError($j('#regEmailError'));
        },
        validatePassword: function validatePassword(param) {
            param = param || {};
            if (param.clickFromSocialLogin === true) {
                jPar.wdk.forms.hideError($j('#regPasswordEmptyError'));
                jPar.wdk.forms.hideError($j('#regPasswordNotValidError'));
            } else {
                jPar.wdk.passwordRestrictionBox.checkPasswordRestrictions();
                if (jPar.util.validate.textfieldIsEmpty($j('#regFormPassword'))) {
                    jPar.wdk.forms.showError($j('#regPasswordEmptyError'));
                    jPar.wdk.forms.hideError($j('#regPasswordNotValidError'));
                } else if (jPar.wdk.passwordRestrictionBox.isPasswordValid() === false) {
                    jPar.wdk.forms.hideError($j('#regPasswordEmptyError'));
                    jPar.wdk.forms.showError($j('#regPasswordNotValidError'));
                } else {
                    jPar.wdk.forms.hideError($j('#regPasswordEmptyError'));
                    jPar.wdk.forms.hideError($j('#regPasswordNotValidError'));
                }
            }
        }
    }
});


jPar.loginAndRegistration = jPar.loginAndRegistration || {};
$j.extend(true, jPar.loginAndRegistration, {
    searchGenderSelectPage: {
        init: function() {
            this.tracking.trackPageView();
            const searchGenderForm = document.querySelector('#changeSearchGenderForm');
            if (searchGenderForm.querySelector('input[name="selectedGenders"]:checked')) {
                document.querySelector('#nextButton').disabled = false;
                document.querySelector('.infoText').classList.remove('noDisplay');
            }
            searchGenderForm.querySelectorAll('input[name="selectedGenders"]').forEach((el)=>{
                el.addEventListener('click', (ev)=>{
                    const hasNoGenderSelected = searchGenderForm.querySelectorAll('input[name="selectedGenders"]:checked').length === 0;
                    document.querySelector('#nextButton').disabled = hasNoGenderSelected;
                    document.querySelector('.infoText').classList.remove('noDisplay');
                    this.tracking.trackSearchGenderChange(ev.currentTarget.value);
                });
            });
            searchGenderForm.addEventListener('submit', (ev)=>{
                ev.preventDefault();
                const selectedGendersList = Array.from(searchGenderForm.querySelectorAll('input')).map((input)=>input.checked ? input.value : null).filter((el)=>el !== null);
                const formData = new URLSearchParams({
                    selectedGenders: selectedGendersList,
                    _csrf: jPar.wdk.security.csrf.getToken()
                });
                fetch(searchGenderForm.action, {
                    // Fetch instead of fetchIt because we need the raw response
                    method: 'POST',
                    body: formData,
                    headers: {
                        'X-CSRF-TOKEN': jPar.wdk.security.csrf.getToken(),
                        'x-requested-with': 'XMLHttpRequest',
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }).then((response)=>{
                    if (response.redirected) window.location.href = response.url;
                });
            });
        },
        tracking: {
            trackPageView: function() {
                jPar.util.log.bigData({
                    category: 'registration',
                    subcategory: 'search_gender_select_screen',
                    action: 'screen_view'
                });
            },
            trackSearchGenderChange: function(value) {
                let targetId = '';
                switch(value){
                    case 'MALE':
                        targetId = 'button_man';
                        break;
                    case 'FEMALE':
                        targetId = 'button_woman';
                        break;
                    case 'DIVERSE':
                        targetId = 'button_nonbinary';
                        break;
                }
                jPar.util.log.bigData({
                    category: 'registration',
                    subcategory: 'search_gender_select_screen',
                    action: 'click',
                    targetId: targetId
                });
            }
        }
    }
});


jPar.loginAndRegistration = jPar.loginAndRegistration || {};
$j.extend(true, jPar.loginAndRegistration, {
    verificationPage: {
        resendCountDownStarted: false,
        resendCountdownInterval: 0,
        init: function init() {
            this.setFormEvents();
            this.setHelpEvents();
            this.countDown();
            this.trackViewScreen();
            try {
                this.loginDelay();
            } catch (e) {
                jPar.util.log.error(e.stack, 'jPar.loginAndRegistration.verificationPage.init: low prio failed');
            }
        },
        countDown: function() {
            if ($j('#verificationTimeoutError').length > 0) {
                $j('#code').attr('readonly', true);
                $j('.codeWrapper').hide();
                const currentMillis = new Date().getTime();
                const blockedUntil = currentMillis + parseInt($j('#verificationTimeoutError').data('countDown'));
                jPar.loginAndRegistration.countdown.start(blockedUntil, 1000, (remaining)=>{
                    $j('.countDown').html(remaining.minutes + ':' + remaining.seconds.toString().padStart(2, '0'));
                }, ()=>{
                    $j('.countDown').html('0:00');
                    location.assign('/login?login_error=verification_code_failed');
                });
            }
        },
        setFormEvents: function() {
            const _this = this;
            $j('#verificationForm').on('keydown keyup', '#code', function(event) {
                _this.hideCursor(event);
                _this.submitCode(event);
                return _this.isWantedCharacter(event);
            });
            $j('#verificationForm').on('change', '#code', function(event) {
                _this.submitCode(event);
            });
            $j('#verificationForm').on('paste', '#code', function(event) {
                _this.removeNotWantedCharacters(event);
            });
            if (document.querySelector('.verificationError')) _this.trackSubmitCodeInvalid();
        },
        setHelpEvents: function() {
            const _this = this;
            $j('.js-openModalDrawer').on('click', function() {
                jPar.wdk.modalbox.show({
                    modalboxId: 'helpModal'
                });
                _this.trackOpenHelpModal();
            });
            $j('#resendButton').on('click', function() {
                _this.resendCode();
                _this.trackResendCode();
            });
            $j('#openOscHelpPages').on('click', function() {
                jPar.wdk.modalbox.hide();
                _this.trackClickHelpCenter();
            });
            $j('#cancelButton').on('click', function() {
                jPar.wdk.modalbox.hide();
                _this.trackClickCancelHelpModal();
            });
        },
        isWantedCharacter: function(event) {
            // BUG-16466
            if (this.isNumber(event.key)) return true;
            // other cases
            const charCode = this.getKeyCode(event);
            const backspaceOrDelete = charCode === 8 || charCode === 46;
            const arrows = charCode >= 37 && charCode <= 40;
            const tab = charCode === 9;
            const paste = event.ctrlKey && charCode === 86;
            const functionKeys = charCode >= 112 && charCode <= 123;
            return paste || backspaceOrDelete || arrows || tab || functionKeys;
        },
        getKeyCode: function(event) {
            return event.which ? event.which : event.keyCode;
        },
        isNumber: function(number) {
            return !isNaN(parseFloat(number)) && isFinite(number);
        },
        hideCursor: function(event) {
            if (event.type === 'keydown') {
                if (this.isCodeAlmostComplete()) {
                    if (this.isNumber(event.key)) $j(event.target).addClass('cursorHidden');
                    else $j(event.target).removeClass('cursorHidden');
                } else $j(event.target).removeClass('cursorHidden');
            }
        },
        isCodeAlmostComplete: function() {
            const maxLength = parseInt($j('#verificationForm #code').attr('maxLength'));
            const currentLength = $j('#verificationForm #code').val().length;
            return maxLength > 0 && currentLength + 1 >= maxLength;
        },
        isCodeComplete: function() {
            const maxLength = $j('#verificationForm #code').attr('maxLength');
            const currentLength = '' + $j('#verificationForm #code').val().length;
            return maxLength > 0 && currentLength === maxLength;
        },
        removeNotWantedCharacters: function(event) {
            const pastedText = event.originalEvent.clipboardData.getData('text');
            if (pastedText !== '') {
                $j('#code').val(pastedText.replace(/\D+/g, ''));
                event.preventDefault();
                return false;
            }
        },
        submitCode: function(event) {
            if (event.type === 'keyup' && !$j('#verificationForm').hasClass('submitInProgress') && this.isCodeComplete()) {
                $j('#verificationForm').addClass('submitInProgress');
                $j('#code').attr('readonly', true);
                this.trackSubmitCode();
                $j('#verificationForm').trigger('submit');
            }
        },
        resendCode: function() {
            const _this = this;
            $j.ajax({
                type: 'POST',
                url: $j('#verificationForm').data('resendUrl'),
                data: {
                    _csrf: jPar.wdk.security.csrf.getToken(),
                    j_username: $j('#verificationForm input[name="j_username"]').val()
                },
                success: function(data) {
                    jPar.wdk.modalbox.hide();
                    if (data.success) {
                        jPar.wdk.modalbox.show({
                            modalboxId: 'resendSuccessModal'
                        });
                        _this.trackResendCodeSuccess();
                    } else if (data.blockedDurationInMs) {
                        const durationBlocked = data.blockedDurationInMs;
                        $j('.resendBlockedCounter').data('countDown', durationBlocked);
                        jPar.wdk.modalbox.show({
                            modalboxId: 'resendBlockedModal'
                        });
                        _this.resendCountDown();
                    } else jPar.wdk.modalbox.show({
                        modalboxId: 'errorModalbox500'
                    });
                },
                error: function() {
                    jPar.wdk.modalbox.show({
                        modalboxId: 'errorModalbox500'
                    });
                }
            });
        },
        resendCountDown: function() {
            if ($j('.resendBlockedCounter').data('countDown') !== '' && !this.resendCountDownStarted) {
                this.resendCountDownStarted = true;
                const currentMillis = new Date().getTime();
                const blockedUntil = currentMillis + parseInt($j('.resendBlockedCounter').data('countDown'));
                this.resendCountdownInterval = jPar.loginAndRegistration.countdown.start(blockedUntil, 1000, (remaining)=>{
                    $j('.resendBlockedCounter').html(remaining.minutes + ':' + remaining.seconds.toString().padStart(2, '0'));
                }, ()=>{
                    this.resendCountDownStarted = false;
                    $j('.resendBlockedCounter').html('0:00');
                    jPar.loginAndRegistration.countdown.stop(this.resendCountdownInterval);
                });
            }
        },
        loginDelay: function loginDelay() {
            const loginDelay = $j('#loadingText').data('logindelay');
            if (loginDelay !== undefined) window.setTimeout(function() {
                jPar.loginAndRegistration.util.hideLoadingAnimation();
            }, loginDelay);
        },
        trackViewScreen: function() {
            jPar.util.log.bigData({
                category: 'authentication',
                subcategory: 'authentication_screen',
                action: 'screen_view'
            });
        },
        trackSubmitCode: function() {
            jPar.util.log.bigData({
                category: 'authentication',
                subcategory: 'authentication_screen',
                action: 'submit'
            });
        },
        trackSubmitCodeInvalid: function() {
            document.querySelectorAll('.verificationError').forEach(function(element) {
                const errorCode = element.dataset.error;
                jPar.util.log.bigData({
                    category: 'authentication',
                    subcategory: 'authentication_screen',
                    action: 'authentication_invalid',
                    targetId: errorCode
                });
            });
        },
        trackOpenHelpModal: function() {
            jPar.util.log.bigData({
                category: 'authentication',
                subcategory: 'authentication_screen',
                action: 'click',
                targetId: 'link_help'
            });
        },
        trackResendCode: function() {
            jPar.util.log.bigData({
                category: 'authentication',
                subcategory: 'authentication_screen',
                action: 'click',
                targetId: 'button_resend_code'
            });
        },
        trackResendCodeSuccess: function() {
            jPar.util.log.bigData({
                category: 'authentication',
                subcategory: 'authentication_screen',
                action: 'code_sent'
            });
        },
        trackClickHelpCenter: function() {
            jPar.util.log.bigData({
                category: 'authentication',
                subcategory: 'authentication_screen',
                action: 'click',
                targetId: 'button_visit_help_center'
            });
        },
        trackClickCancelHelpModal: function() {
            jPar.util.log.bigData({
                category: 'authentication',
                subcategory: 'authentication_screen',
                action: 'click',
                targetId: 'button_cancel'
            });
        }
    }
});



var $hGPqC = parcelRequire("hGPqC");

var $5WXf9 = parcelRequire("5WXf9");

var $2FBCq = parcelRequire("2FBCq");

var $b4Kph = parcelRequire("b4Kph");

var $6Ts2t = parcelRequire("6Ts2t");

var $4LrRv = parcelRequire("4LrRv");
class $a50618aa83d6711e$export$2e2bcd8739ae039 extends HTMLElement {
    connectedCallback() {
        this.abortController = new AbortController();
        this.#trackViewScreen();
    }
    disconnectedCallback() {
        this.abortController.abort();
    }
    #trackViewScreen() {
        jPar.util.log.bigData({
            category: 'adaptive_blocking',
            subcategory: 'otp_verification_screen',
            action: 'screen_view'
        });
    }
}


class $42fed79d91448f16$export$2e2bcd8739ae039 extends HTMLElement {
    async connectedCallback() {
        await new Promise(requestAnimationFrame);
        this.abortController = new AbortController();
        this.#setEventListeners();
        this.#trackViewPage();
        // reset checkboxes after navigation back to this page
        setTimeout(()=>{
            this.querySelector('#termsAndConditionsReadInput').checked = false;
            this.querySelector('#electronicDisclosureReadInput').checked = false;
        }, 100);
    }
    async disconnectedCallback() {
        await new Promise(requestAnimationFrame);
        this.abortController.abort();
    }
    #setEventListeners() {
        this.querySelector('.startLivenessCheck').addEventListener('click', async (event)=>{
            if (event.target.classList.contains('disabled')) event.preventDefault();
            else {
                this.#disableButtonAndCheckboxes();
                this.querySelector('wdk-hintbox-error.tokenError').hide();
                await this.#fetchAccessToken();
                this.#triggerEmailSendout();
                this.#trackClickStartVerify();
            }
        }, {
            signal: this.abortController.signal
        });
        this.querySelector('#termsAndConditionsRead').addEventListener('change', ()=>{
            this.#toggleStartLivenessCheckButton();
        }, {
            signal: this.abortController.signal
        });
        this.querySelector('#electronicDisclosureRead').addEventListener('change', ()=>{
            this.#toggleStartLivenessCheckButton();
        }, {
            signal: this.abortController.signal
        });
    }
    async #fetchSubjectToken() {
        // the subjectToken needs to be fetched via endpoint (and not on pageLoad in ftl) because of its TTL. So it's nice and fresh when the user clicks the button
        try {
            const subjectToken = await fetchIt.get(`/user/verification/liveness/token`);
            return subjectToken.token;
        } catch (error) {
            jPar.util.log.error(error.toString(), 'page_method.fetchTokenToGetTheToken.js fetchTokenToGetTheToken failed');
            location.href = '/login';
            return null;
        }
    }
    #getBrand() {
        let brand;
        if (jPar.wdk.brands.forBrands([
            'ps'
        ])) brand = 'parship';
        else if (jPar.wdk.brands.forBrands([
            'eh'
        ])) brand = 'eharmony';
        else brand = 'elitepartner';
        return brand;
    }
    async #fetchAccessToken() {
        try {
            const subjectToken = await this.#fetchSubjectToken();
            if (!subjectToken) throw new Error('Kein Subject-Token erhalten');
            const brand = this.#getBrand();
            const startButton = this.querySelector('.startLivenessCheck');
            const accessTokenUrl = startButton.getAttribute('data-access-token-url');
            const gatewayUrl = startButton.getAttribute('data-gateway-url');
            const config = {
                locale: 'en',
                hostAppName: brand,
                hostAppVersion: '1.0.0',
                credentials: btoa(`${brand}:secret`),
                authUrl: accessTokenUrl,
                authToken: subjectToken,
                gatewayUrl: gatewayUrl
            };
            const chiffre = this.getAttribute('user-id');
            const id = `${brand}:user:${chiffre}`;
            const tmgWebSDK = new TMGWebSDK(config); /* global TMGWebSDK */ 
            tmgWebSDK.registerProfile(id, {}, (err)=>{
                if (err) {
                    console.error('error registering profile', err);
                    jPar.util.log.error(err, 'fetchAccessToken failed, error registering profile');
                    return;
                }
                tmgWebSDK.getJWT((error, JWT)=>{
                    if (error) {
                        this.#enableButtonAndCheckboxes();
                        this.querySelector('wdk-hintbox-error.tokenError').show();
                        console.error(error);
                        return;
                    }
                    this.#startVerification(JWT);
                });
            });
        } catch (error) {
            this.#enableButtonAndCheckboxes();
            this.querySelector('wdk-hintbox-error.tokenError').show();
            jPar.util.log.error(error.toString(), 'page_method.fetchAccessToken.js fetchAccessToken failed');
            console.error(error);
            return null;
        }
    }
    #startVerification(accessToken) {
        const button = this.querySelector('.startLivenessCheck');
        const redirectUrl = button.getAttribute('data-redirect-url');
        const livenessCheckUrl = button.getAttribute('data-liveness-check-url');
        location.href = livenessCheckUrl + `&access_token=${encodeURIComponent(accessToken)}&redirect_url=${encodeURIComponent(redirectUrl)}`;
    }
    #enableButtonAndCheckboxes() {
        jPar.wdk.loadingIndicator.hide(this.querySelector('.startLivenessCheck'));
        this.querySelector('#termsAndConditionsReadInput').removeAttribute('disabled');
        this.querySelector('#electronicDisclosureReadInput').removeAttribute('disabled');
    }
    #disableButtonAndCheckboxes() {
        jPar.wdk.loadingIndicator.show(this.querySelector('.startLivenessCheck'));
        this.querySelector('#termsAndConditionsReadInput').setAttribute('disabled', '');
        this.querySelector('#electronicDisclosureReadInput').setAttribute('disabled', '');
    }
    async #triggerEmailSendout() {
        // just fetch, no return handling needed
        try {
            await fetchIt.post(`/user/verification/liveness/triggerEmail`, {});
        } catch (error) {
            jPar.util.log.error(error.toString(), 'page_method.triggerEmailSendout.js triggerEmail/status failed');
            await jPar.util.awaitTimeout(5000); // Chance to have a selfhealing in the Backend
            return 'FAILED';
        }
    }
    #toggleStartLivenessCheckButton() {
        const termsAndConditionsChecked = this.querySelector('#termsAndConditionsReadInput').checked;
        const electronicDisclosureChecked = this.querySelector('#electronicDisclosureReadInput').checked;
        const startLivenessCheckButton = this.querySelector('.startLivenessCheck');
        const buttonShouldBeEnabled = termsAndConditionsChecked && electronicDisclosureChecked;
        startLivenessCheckButton.classList.toggle('disabled', !buttonShouldBeEnabled);
    }
    #trackViewPage() {
        jPar.util.log.bigData({
            category: 'adaptive_blocking',
            subcategory: 'liveness_verification_initialization',
            action: 'page_view'
        });
    }
    #trackClickStartVerify() {
        jPar.util.log.bigData({
            category: 'adaptive_blocking',
            subcategory: 'liveness_verification_initialization',
            action: 'click',
            targetId: 'click_button_verify'
        });
    }
}


class $d3a1ce72bde7289e$export$2e2bcd8739ae039 extends HTMLElement {
    async connectedCallback() {
        await new Promise(requestAnimationFrame);
        this.abortController = new AbortController();
        this.startTime = Date.now();
        this.countRetries = 0;
        this.#setEventListeners();
        this.#trackViewPage();
        this.#pollBackendStatus();
    }
    async disconnectedCallback() {
        await new Promise(requestAnimationFrame);
        this.abortController.abort();
    }
    #setEventListeners() {
        this.querySelector('.reloadPage').addEventListener('click', ()=>{
            this.#trackReloadPage();
            location.href = '/user/verification/liveness';
        }, {
            signal: this.abortController.signal
        });
        this.querySelector('.callCustomerSupport').addEventListener('click', ()=>{
            this.#trackClickHelp();
        }, {
            signal: this.abortController.signal
        });
    }
    #pollBackendStatus() {
        this.#waitForEventBridgeResponse().then((status)=>{
            if (status === 'REDIRECT') location.replace('/profile/welcomepage');
            else if (status === 'REFRESHLIMITREACHED') {
                this.querySelector('.spinnerWrapper').remove();
                this.querySelector('.refreshLimitReachedWrapper').classList.remove('noDisplay');
            } else if (status === 'FAILED') throw new Error('Failed to get a valid response from the backend after several retries.');
        }).catch((error)=>{
            jPar.util.log.error(error.toString(), 'page_method.pollBackendStatus.js EventBridge/status failed');
        });
    }
    async #waitForEventBridgeResponse() {
        // for debugging
        // backstageToolRwd.mockFetch.mockRequest('/user/verification/liveness/done/status?refreshCount=1', 'GET', { blocked: true, refreshLimitReached: false, cooldownTimeInSeconds: 5 });
        // backstageToolRwd.mockFetch.mockRequest('/user/verification/liveness/done/status?refreshCount=1', 'GET', { blocked: false, refreshLimitReached: false, cooldownTimeInSeconds: 5 });
        // backstageToolRwd.mockFetch.mockRequest('/user/verification/liveness/done/status?refreshCount=1', 'GET', { blocked: true, refreshLimitReached: true, cooldownTimeInSeconds: 5 });
        this.countRetries++;
        return fetchIt.get(`/user/verification/liveness/done/status?refreshCount=${this.countRetries}`).then(async (data)=>{
            if (data.refreshLimitReached) return 'REFRESHLIMITREACHED';
            else {
                if (data.blocked) {
                    await jPar.util.awaitTimeout(parseInt(data.cooldownTimeInSeconds, 10) * 1000);
                    return this.#pollBackendStatus();
                } else return 'REDIRECT';
            }
        }).catch(async (error)=>{
            jPar.util.log.error(error.toString(), 'page_method.waitForEventBridgeResponse.js EventBridge/status failed');
            await jPar.util.awaitTimeout(5000); // Chance to have a selfhealing in the Backend
            return 'FAILED';
        });
    }
    #getElapsedSeconds() {
        return Math.round((Date.now() - this.startTime) / 1000);
    }
    #trackViewPage() {
        jPar.util.log.bigData({
            category: 'adaptive_blocking',
            subcategory: 'liveness_verification_done',
            action: 'page_view'
        });
    }
    #trackReloadPage() {
        jPar.util.log.bigData({
            category: 'adaptive_blocking',
            subcategory: 'liveness_verification_done',
            action: 'click',
            targetId: 'click_link_retry',
            cd2: this.#getElapsedSeconds(),
            cd3: this.countRetries
        });
    }
    #trackClickHelp() {
        jPar.util.log.bigData({
            category: 'adaptive_blocking',
            subcategory: 'livenessPageDone',
            action: 'click',
            targetId: 'click_button_support',
            cd2: this.#getElapsedSeconds(),
            cd3: this.countRetries
        });
    }
}


class $1a98499edce01e69$export$2e2bcd8739ae039 extends HTMLElement {
    async connectedCallback() {
        await new Promise(requestAnimationFrame);
        this.abortController = new AbortController();
        this.#setEventListeners();
        this.#trackViewPage();
    }
    async disconnectedCallback() {
        await new Promise(requestAnimationFrame);
        this.abortController.abort();
    }
    #setEventListeners() {
        this.querySelector('#uploadPicture').addEventListener('click', ()=>{
            this.#trackStartUpload();
        }, {
            signal: this.abortController.signal
        });
        this.addEventListener('pegPhotoUploader:uploadSuccess', ()=>{
            window.location.replace('/lists/partnersuggestions');
        }, {
            signal: this.abortController.signal
        });
    }
    #trackStartUpload() {
        jPar.util.log.bigData({
            category: 'adaptive_blocking',
            subcategory: 'mandatory_photo_initialization_screen',
            action: 'click',
            targetId: 'click_button_upload'
        });
    }
    #trackViewPage() {
        jPar.util.log.bigData({
            category: 'adaptive_blocking',
            subcategory: 'mandatory_photo_initialization_screen',
            action: 'screen_view'
        });
    }
}


class $eef46a892028716d$export$2e2bcd8739ae039 extends HTMLElement {
    connectedCallback() {
        this.abortController = new AbortController();
        this.startTime = Date.now();
        this.inputElement = this.querySelector('#code');
        this.#setEventListeners();
    }
    disconnectedCallback() {
        this.abortController.abort();
    }
    #setEventListeners() {
        this.querySelector('form').addEventListener('submit', (event)=>{
            event.preventDefault();
        });
        this.inputElement.addEventListener('focus', ()=>{
            this.#hideAllErrorMessages();
        }, {
            signal: this.abortController.signal
        });
        this.inputElement.addEventListener('input', (event)=>{
            this.#removeNotWantedCharacters(event);
            this.#submitCode();
        }, {
            signal: this.abortController.signal
        });
        this.inputElement.addEventListener('paste', (event)=>{
            this.#removeNotWantedCharacters(event);
        }, {
            signal: this.abortController.signal
        });
        // prevent pasting in Chrome/iOS with the clipboard-button on the virtual keyboard
        this.inputElement.addEventListener('beforeinput', (event)=>{
            if (event.inputType === 'insertFromPaste' || event.inputType === 'insertFromPasteAsPlainText') this.#removeNotWantedCharacters(event);
        }, {
            signal: this.abortController.signal
        });
    }
    #hideAllErrorMessages() {
        this.querySelectorAll(`.wdk-styledHintBox[data-error]`).forEach((hintBox)=>{
            hintBox.classList.remove('is-visible');
        });
    }
    async #submitCode() {
        if (this.#isCodeComplete() && this.#canSubmitCode()) {
            this.querySelector('form').classList.add('submitInProgress');
            this.inputElement.setAttribute('readonly', true);
            try {
                const data = {
                    _csrf: jPar.wdk.security.csrf.getToken(),
                    code: this.inputElement.value
                };
                const response = await fetchIt.post('/user/verification/oneTimePassword', JSON.stringify(data));
                this.#trackSubmitCode();
                if (jPar.util.network.hasValidSessionAndCsrfToken(response)) {
                    if (response.verified) {
                        this.#trackCodeValid();
                        location.replace('/profile/welcomepage');
                    } else {
                        this.#handleUnverifiedCode(response.error);
                        this.#trackCodeInvalid(response.error);
                    }
                }
            } catch (error) {
                jPar.util.network.defaultErrorHandling(error);
            }
        }
    }
    /**
	 * @param {('CODE_INVALID'|'CODE_EXPIRED'|'GENERAL_ERROR')} errorCode - The error code indicating the type of error.
	 */ #handleUnverifiedCode(errorCode) {
        this.querySelector(`.wdk-styledHintBox[data-error="${errorCode}"]`).classList.add('is-visible');
        this.querySelector('form').classList.remove('submitInProgress');
        this.inputElement.removeAttribute('readonly');
        this.inputElement.value = '';
        this.inputElement.blur();
    }
    #canSubmitCode() {
        return !this.querySelector('form').classList.contains('submitInProgress');
    }
    #isCodeComplete() {
        const maxLength = parseInt(this.inputElement.getAttribute('maxlength'), 10);
        const currentLength = this.inputElement.value.length;
        return maxLength > 0 && currentLength === maxLength;
    }
    #removeNotWantedCharacters(event) {
        event.preventDefault();
        this.inputElement.value = this.inputElement.value.replace(/\D/g, '');
    }
    #trackSubmitCode() {
        const elapsedSeconds = Math.round((Date.now() - this.startTime) / 1000); // time_in_seconds from start of the page to submit the form
        jPar.util.log.bigData({
            category: 'adaptive_blocking',
            subcategory: 'otp_verification_screen',
            action: 'submit',
            cd2: elapsedSeconds
        });
    }
    #trackCodeValid() {
        jPar.util.log.bigData({
            category: 'adaptive_blocking',
            subcategory: 'otp_verification_screen',
            action: 'success'
        });
    }
    #trackCodeInvalid(errorCode) {
        jPar.util.log.bigData({
            category: 'adaptive_blocking',
            subcategory: 'otp_verification_screen',
            action: 'authentication_invalid',
            targetId: errorCode
        });
    }
}


class $9388b979c91a4878$export$2e2bcd8739ae039 extends HTMLElement {
    connectedCallback() {
        this.abortController = new AbortController();
        this.#setEventListeners();
    }
    disconnectedCallback() {
        this.abortController.abort();
    }
    #setEventListeners() {
        this.querySelector('#resendButton').addEventListener('click', ()=>{
            this.#resendCode();
            this.#trackClickResendCode();
        }, {
            signal: this.abortController.signal
        });
        this.querySelector('#openOscHelpPages').addEventListener('click', ()=>{
            this.#trackOpenOscHelpPages();
        }, {
            signal: this.abortController.signal
        });
        this.querySelector('#cancelButton').addEventListener('click', ()=>{
            this.#trackCancelHelpOverlay();
        }, {
            signal: this.abortController.signal
        });
    }
    async #resendCode() {
        try {
            const data = {
                _csrf: jPar.wdk.security.csrf.getToken(),
                userId: this.getAttribute('user-id')
            };
            const response = await fetchIt.post('/user/verification/oneTimePassword/resend', JSON.stringify(data));
            if (jPar.util.network.hasValidSessionAndCsrfToken(response)) {
                if (response.success) {
                    document.querySelector('wdk-dialog#resendSuccessModal').openModal();
                    this.#trackClickResendCodeSuccessful();
                } else // possible errorCodes: VERIFICATION_NOT_NEEDED, GENERAL_ERROR
                if (response.errorCode === 'VERIFICATION_NOT_NEEDED') document.querySelector('wdk-dialog#resendVerificationNotNeededModal').openModal();
                else document.querySelector('wdk-dialog#resendBlockedModal').openModal();
            } else jPar.wdk.modalbox.show({
                modalboxId: 'errorModalbox500'
            });
        } catch (error) {
            jPar.util.network.defaultErrorHandling(error);
        }
    }
    #trackClickResendCodeSuccessful() {
        jPar.util.log.bigData({
            category: 'adaptive_blocking',
            subcategory: 'otp_verification_screen',
            action: 'code_sent'
        });
    }
    #trackClickResendCode() {
        jPar.util.log.bigData({
            category: 'adaptive_blocking',
            subcategory: 'otp_verification_screen',
            action: 'click',
            targetId: 'button_resend_code'
        });
    }
    #trackOpenOscHelpPages() {
        jPar.util.log.bigData({
            category: 'adaptive_blocking',
            subcategory: 'otp_verification_screen',
            action: 'click',
            targetId: 'button_visit_help_center'
        });
    }
    #trackCancelHelpOverlay() {
        jPar.util.log.bigData({
            category: 'adaptive_blocking',
            subcategory: 'otp_verification_screen',
            action: 'click',
            targetId: 'button_cancel'
        });
    }
}


class $94413037573dee5c$export$2e2bcd8739ae039 extends HTMLElement {
    connectedCallback() {
        this.sitekey = this.getAttribute('sitekey');
        this.isInteractiveChallenge = false;
        this.turnstileContainer = this.querySelector('.turnstile-container');
        this.errorMessage = this.querySelector('#regTurnstileError');
        this.#loadTurnstileScript();
    }
    #loadTurnstileScript() {
        const script = document.createElement('script');
        script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
        script.defer = true;
        script.onload = ()=>this.#renderTurnstile();
        this.append(script);
    }
    #renderTurnstile() {
        turnstile.render(this.turnstileContainer, {
            'sitekey': this.sitekey,
            'size': 'flexible',
            'retry': 'never',
            'appearance': 'interaction-only',
            'callback': ()=>this.#successCallback(),
            'error-callback': (error)=>this.#errorCallback(error),
            'before-interactive-callback': ()=>this.#beforeInteractiveCallback(),
            'language': document.documentElement.lang.toLowerCase()
        });
    }
    #successCallback() {
        jPar.wdk.forms.hideError(this.errorMessage);
    }
    #errorCallback(error) {
        jPar.util.log.bigData({
            category: 'registration',
            subcategory: 'registration_start_screen',
            action: 'turnstile_error',
            targetId: 'turnstile_error',
            cd1: error,
            cd2: this.sitekey
        });
    }
    #beforeInteractiveCallback() {
        this.setAttribute('is-interactive-challenge', '');
        this.isInteractiveChallenge = true;
    }
    validate() {
        const isValid = turnstile?.getResponse(this.turnstileContainer) !== undefined;
        if (!isValid && this.isInteractiveChallenge) jPar.wdk.forms.showError(this.errorMessage);
        return isValid;
    }
}



var $hlI6t = parcelRequire("hlI6t");

var $af8Hs = parcelRequire("af8Hs");

var $1fstn = parcelRequire("1fstn");

var $gQOJI = parcelRequire("gQOJI");

var $hScTJ = parcelRequire("hScTJ");

var $hSRP7 = parcelRequire("hSRP7");

var $eEuJF = parcelRequire("eEuJF");

var $hdSdV = parcelRequire("hdSdV");

var $dxNUL = parcelRequire("dxNUL");
// *********** Usages ***********
// "App" Scope
customElements.define('peg-apple-social-button', (0, $hGPqC.default));
customElements.define('peg-google-social-button', (0, $5WXf9.default));
customElements.define('peg-cookiebanner', (0, $2FBCq.default));
customElements.define('bst-message-keys', (0, $6Ts2t.default));
customElements.define('peg-footer', (0, $4LrRv.default));
customElements.define('peg-offline-notification', (0, $b4Kph.default));
customElements.define('peg-otp-page', (0, $a50618aa83d6711e$export$2e2bcd8739ae039));
customElements.define('peg-liveness-page', (0, $42fed79d91448f16$export$2e2bcd8739ae039));
customElements.define('peg-liveness-page-done', (0, $d3a1ce72bde7289e$export$2e2bcd8739ae039));
customElements.define('peg-mandatoryphotoupload-page', (0, $1a98499edce01e69$export$2e2bcd8739ae039));
customElements.define('peg-verification-code', (0, $eef46a892028716d$export$2e2bcd8739ae039));
customElements.define('peg-otp-help-dialog', (0, $9388b979c91a4878$export$2e2bcd8739ae039));
customElements.define('peg-error-dialog-500', (0, $hdSdV.default));
customElements.define('peg-turnstile', (0, $94413037573dee5c$export$2e2bcd8739ae039));
customElements.define('peg-photo-selector', (0, $hlI6t.default));
customElements.define('peg-photo-uploader', (0, $af8Hs.default));
customElements.define('peg-photo-editor', (0, $1fstn.default));
customElements.define('peg-photo-upload-dialog', (0, $gQOJI.default));
// WDK
customElements.define('wdk-hintbox', (0, $dxNUL.default));
customElements.define('wdk-hintbox-error', (0, $hScTJ.default));
customElements.define('wdk-input-checkbox', (0, $hSRP7.default));
customElements.define('wdk-dialog', (0, $eEuJF.default));

})();
//# sourceMappingURL=login_and_registration_combined.js.map
